import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'billing.confirm.amountDue': 'Amount due today',
  'billing.confirm.and': 'and',
  'billing.confirm.boostersTerms': 'Boosters Terms of Use',
  'billing.confirm.confirm': 'Confirm',
  'billing.confirm.discountHint': 'Discount {percent}% applies to the first invoice only.',
  'billing.confirm.havePromo': 'Have a promo code?',
  'billing.confirm.hideDetails': 'Hide details',
  'billing.confirm.invalidPromo': 'The promo code is invalid',
  'billing.confirm.monthlyFrom': 'Monthly from {date}',
  'billing.confirm.noCharges': 'No upcoming booster charges',
  'billing.confirm.noChargesDescription': "You won't have any active boosters after confirmation.",
  'billing.confirm.oneTimeHint': 'One-time payment covers usage until the end of the billing cycle.',
  'billing.confirm.paymentMethod': 'Payment method',
  'billing.confirm.perMonth': '/month',
  'billing.confirm.perYear': '/year',
  'billing.confirm.privacy': 'Privacy Policy',
  'billing.confirm.promoFailed': 'Failed to apply promo code',
  'billing.confirm.promoLine': 'Promo code {code}',
  'billing.confirm.promoPlaceholder': 'Promo code',
  'billing.confirm.promotionTerms': 'Promotion Terms',
  'billing.confirm.remove': '(removed)',
  'billing.confirm.removeItem': 'Remove {item}',
  'billing.confirm.renews': 'Renews automatically until cancelled',
  'billing.confirm.subscribe': 'Subscribe with obligation to pay',
  'billing.confirm.taxHint': 'Total includes taxes based on your billing info.',
  'billing.confirm.terms': 'Terms of Service',
  'billing.confirm.termsIntro': "By confirming, you agree to Rask AI's",
  'billing.confirm.updatePayment': 'Please update payment method',
  'billing.confirm.vat': 'VAT {percent}',
  'billing.confirm.viewDetails': 'View details',
  'billing.confirm.yearlyFrom': 'Yearly from {date}',
  'billing.error.authentication': "Payment authentication failed. We couldn't confirm the payment with your bank.",
  'billing.error.bankDeclined': 'Payment was declined by your bank. The bank did not approve this transaction.',
  'billing.error.cardCannotBeUsed': "This card can't be used",
  'billing.error.cardDetails':
    'Card details are incorrect. Please check your card number, expiration date, and security code.',
  'billing.error.changePayment': 'Change your payment method',
  'billing.error.editPayment': 'Edit payment method',
  'billing.error.failed': 'Payment failed',
  'billing.error.insufficient':
    'Payment failed — insufficient funds or limit reached. Your bank declined the payment due to low balance or spending limit.',
  'billing.error.retryPayment': 'Try again or change payment method',
  'billing.result.canClose': 'You can close this modal at any time.',
  'billing.result.closeWindow': 'Close modal',
  'billing.result.processing': "We're processing your order",
  'billing.result.processingDescription':
    "This may take a few minutes. We'll continue processing it in the background and activate your subscription automatically once it's complete.",
  'billing.result.success': 'Payment processed successfully',
  'billing.result.viewInvoice': 'View invoice',
  'bookDemo.booked': "You're booked!",
  'bookDemo.bookedFor': "You're booked for {slot}",
  'bookDemo.coverDescription':
    "your localization use case, the best way to implement it in Rask, how Rask fits into your team's workflow, and a clear pricing structure.",
  'bookDemo.coverTitle': "What we'll cover:",
  'bookDemo.inviteSent': 'An invite with the meeting link has been sent to your email.',
  'bookDemo.seeYou': 'See you soon',
  'bookDemo.subtitle': "We'll discuss your workflow, show hidden features, and pick the best plan for your needs.",
  'bookDemo.timeBenefit': 'A 30-minute demo saves you around 5 hours of product discovery.',
  'bookDemo.title': 'Book a demo with our specialist',
  'pricing.actions.contactUs': 'Contact us',
  'pricing.actions.downgrade': 'Downgrade',
  'pricing.actions.getStarted': 'Get started',
  'pricing.actions.renew': 'Renew',
  'pricing.actions.switchAnnual': 'Switch to annual',
  'pricing.actions.switchMonthly': 'Switch to monthly',
  'pricing.actions.upgrade': 'Upgrade',
  'pricing.archived.description': 'You are currently on an archived {plan} plan with {count} min included.',
  'pricing.archived.hint': 'Continue using it or upgrade to the new plan.',
  'pricing.billing.annual': 'Annual',
  'pricing.billing.aria': 'Billing period',
  'pricing.billing.billAnnual': 'Bill annually',
  'pricing.billing.billedAnnually': 'Bill annually',
  'pricing.billing.monthly': 'Monthly',
  'pricing.billing.payAnnual': 'Pay annually',
  'pricing.booster.addForMonth': 'Add for {price} per month',
  'pricing.buyMinutes.benefitRemain': 'Unused minutes will remain in your account even if you pause the subscription',
  'pricing.buyMinutes.benefitRollOver': 'We will roll over your unused minutes to the next month',
  'pricing.buyMinutes.checkout': 'Checkout',
  'pricing.buyMinutes.minutes': 'Minutes',
  'pricing.buyMinutes.newPricingDescription':
    'Check out our new pricing with flexible bundled minutes and new features!',
  'pricing.buyMinutes.newPricingTitle': 'We just launched new pricing!',
  'pricing.buyMinutes.payLess': 'Pay less',
  'pricing.buyMinutes.payOnly': 'Pay only {price} per minute!',
  'pricing.buyMinutes.perMinute': '{price}/min',
  'pricing.buyMinutes.price': 'Price',
  'pricing.buyMinutes.title': 'Buy additional minutes',
  'pricing.buyMinutes.upgradeDescription': 'Upgrade your plan and pay less for additional minutes',
  'pricing.cancelDowngrade.button': 'Cancel downgrade',
  'pricing.cancelDowngrade.currentDescription':
    "You're currently on the {plan} plan at {price}, billed {interval}, and active until {date}.",
  'pricing.cancelDowngrade.currentTitle': 'Current plan',
  'pricing.cancelDowngrade.hint': 'You can schedule the downgrade again anytime.',
  'pricing.cancelDowngrade.scheduledDescription':
    "You're scheduled to switch to the {plan} plan at {price}, billed {interval}, starting {date}. If you cancel this change, your current {currentPlan} subscription will continue.",
  'pricing.cancelDowngrade.scheduledTitle': 'Scheduled plan',
  'pricing.cancelDowngrade.success': 'Subscription change cancelled. Your {plan} plan will remain active.',
  'pricing.change.activeUntil': 'Your current plan remains active until {date}.',
  'pricing.change.boosterDescription':
    "SRT Upload & Download is now included in your plan at no extra cost. We'll remove it from your boosters automatically.",
  'pricing.change.boosterIncluded': 'Booster included!',
  'pricing.change.changeSuccess': 'Your plan change has been processed',
  'pricing.change.current': 'Current plan',
  'pricing.change.currentDescription':
    "You're currently on the {plan} plan with {interval} billing, active until {date}.",
  'pricing.change.downgradeDescription':
    "You're switching to the {plan} plan with {interval} billing. The change will take effect at the end of your current billing period.",
  'pricing.change.downgradeError': 'Failed to downgrade plan:',
  'pricing.change.downgradeSuccess': 'Your downgrade has been scheduled',
  'pricing.change.featuresLost': 'Features you lose',
  'pricing.change.monthly': 'monthly',
  'pricing.change.new': 'New plan',
  'pricing.change.scheduleDowngrade': 'Schedule downgrade',
  'pricing.change.switchBack': 'You can switch back to your previous plan starting {date}.',
  'pricing.change.upgradeDescription':
    "You're switching to the {plan} plan with {interval} billing. You'll immediately get new features plus {count} additional min (the difference between plans).",
  'pricing.change.upgradeError': 'Failed to upgrade plan:',
  'pricing.change.upgradeNow': 'Upgrade now',
  'pricing.change.upgradePaidSuccess': 'Payment processed successfully, subscription upgraded',
  'pricing.change.upgradeSuccess': 'Your plan has been updated',
  'pricing.change.yearly': 'yearly',
  'pricing.compare.credits': 'Credits and generations',
  'pricing.compare.editor': 'Editor',
  'pricing.compare.extraMinutes': 'Extra minutes',
  'pricing.compare.minutesIncluded': 'Minutes included',
  'pricing.compare.plans': 'Compare plans',
  'pricing.compare.row.api': 'API and integrations',
  'pricing.compare.row.apiDescription': 'Connect Rask to your existing tools and automate your workflow.',
  'pricing.compare.row.autoCut': 'AI Auto-cut',
  'pricing.compare.row.autoCutDescription': 'Remove filler words and silences from recordings automatically.',
  'pricing.compare.row.autoZoom': 'Autozoom',
  'pricing.compare.row.autoZoomDescription': 'Automatically zoom into the action as you record.',
  'pricing.compare.row.controls': 'Script, subtitle and voice controls',
  'pricing.compare.row.controlsDescription':
    'Edit the transcript, timestamps, speaker labels, and voice settings directly.',
  'pricing.compare.row.extraDescription': 'You can buy additional minutes anytime on annual plans.',
  'pricing.compare.row.glossary': 'Glossary and terminology',
  'pricing.compare.row.glossaryDescription':
    'Save custom terms so the same words are translated consistently every time.',
  'pricing.compare.row.lipSync': 'Multi-speaker lip-sync',
  'pricing.compare.row.lipSyncDescription':
    'Matches mouth movements to translated audio for more natural-looking dubbing.',
  'pricing.compare.row.minutes': 'Localization minutes included per year',
  'pricing.compare.row.minutesDescription':
    'The annual allowance for translation or dubbing. Annual Business plans grant all minutes upfront.',
  'pricing.compare.row.minutesTitle': 'Localization minutes included per year',
  'pricing.compare.row.multiLanguage': 'Multi-language workflow',
  'pricing.compare.row.multiLanguageDescription': 'Translate a single video into several languages in one project.',
  'pricing.compare.row.prompting': 'Prompting',
  'pricing.compare.row.promptingDescription':
    'Add instructions before translating to set the context: tone, formality, and wording.',
  'pricing.compare.row.review': 'Review workflow',
  'pricing.compare.row.reviewDescription': "Send translated content to reviewers for approval before it's published.",
  'pricing.compare.row.screenRecorder': 'AI Screen Recorder',
  'pricing.compare.row.screenRecorderDescription': 'Record your screen and camera right inside Rask.',
  'pricing.compare.row.security': 'Security and procurement',
  'pricing.compare.row.securityDescription': 'Support for contracts, invoicing, and compliance documentation.',
  'pricing.compare.row.speed': 'Processing speed',
  'pricing.compare.row.speedDescription': 'How quickly your videos are processed and rendered.',
  'pricing.compare.row.srt': 'SRT import/export',
  'pricing.compare.row.srtDescription': 'Download subtitle files or upload your own to sync with dubbing.',
  'pricing.compare.row.srtTitle': 'SRT import / export',
  'pricing.compare.row.team': 'Team workspace',
  'pricing.compare.row.teamDescription': 'Invite teammates to collaborate on projects in one shared space.',
  'pricing.compare.row.voices': 'Saved custom voices',
  'pricing.compare.row.voicesDescription': 'Save cloned voices so you can reuse them across future projects.',
  'pricing.compare.showAll': 'See all features',
  'pricing.compare.showLess': 'Show less',
  'pricing.compare.subtitle': 'Choose the plan that matches how often you publish.',
  'pricing.compare.support': 'Support and teamwork',
  'pricing.compare.title': 'Compare what changes when you scale',
  'pricing.compare.value.compliance': 'SSO, DPA, compliance review',
  'pricing.compare.value.customBatch': 'Custom batch pipelines',
  'pricing.compare.value.customIntegrations': 'Custom integrations',
  'pricing.compare.value.customRoles': 'Custom roles',
  'pricing.compare.value.dedicated': 'Dedicated / priority',
  'pricing.compare.value.extraMinute': '$3 per extra minute',
  'pricing.compare.value.fiveMembers': 'Up to 5 members + guest reviewers',
  'pricing.compare.value.fullApi': 'Full API access',
  'pricing.compare.value.included': 'Included',
  'pricing.compare.value.managedQa': 'Managed QA / SME approval',
  'pricing.compare.value.managedTerms': 'Managed terminology workflow',
  'pricing.compare.value.multiBatch': 'Batch processing for multiple videos and languages',
  'pricing.compare.value.personalGlossary': 'Personal glossary',
  'pricing.compare.value.priorityQueue': 'Priority queue',
  'pricing.compare.value.reviewer': 'Reviewer roles and approval',
  'pricing.compare.value.sandboxApi': 'Limited sandbox API access',
  'pricing.compare.value.sharedGlossary': 'Shared brand glossary',
  'pricing.compare.value.sharedVoices': '10 shared team voices',
  'pricing.compare.value.standard': 'Standard',
  'pricing.compare.value.standardQueue': 'Standard queue',
  'pricing.compare.value.three': '3',
  'pricing.compare.value.threeMembers': 'Up to 3 members',
  'pricing.compare.value.unlimited': 'Unlimited',
  'pricing.compare.value.upgradePro': 'Upgrade to Pro',
  'pricing.compare.value.voiceLibrary': 'Custom voice library',
  'pricing.compare.whatChanges': 'What changes',
  'pricing.enterprisePayment.contactSupport': 'Please contact us via support chat or email us at',
  'pricing.enterprisePayment.unknownError': 'Unknown error',
  'pricing.feature.aiRewriter': 'AI script adjustment',
  'pricing.feature.allBusiness': 'All Business features, plus:',
  'pricing.feature.allCreator': 'All Creator features, plus:',
  'pricing.feature.allCreatorPro': 'All Creator Pro features, plus:',
  'pricing.feature.api': 'API',
  'pricing.feature.applyChanges': 'Apply changes for free',
  'pricing.feature.businessContract': 'Business contract and invoicing',
  'pricing.feature.captions': 'Automated captions/subtitles',
  'pricing.feature.customerSuccess': 'Customer Success Manager',
  'pricing.feature.dictionary': 'Translation dictionary',
  'pricing.feature.editor': 'Advanced video editor',
  'pricing.feature.flexibleMinutes': 'Flexible minutes pricing',
  'pricing.feature.humanReview': 'Human-in-the-loop',
  'pricing.feature.languages': 'Translations in 135+ languages',
  'pricing.feature.languagesDescription': 'Language availability depends on whether you use AI voices or Voice Clone.',
  'pricing.feature.learnMore': 'Learn more',
  'pricing.feature.lipSync': 'Multispeaker Lip-sync',
  'pricing.feature.machineTranslation': 'Automated machine translation',
  'pricing.feature.multiLanguage': 'Simultaneous multi-language translation',
  'pricing.feature.noWatermark': 'No watermark',
  'pricing.feature.onlyVideoDownload': 'Video download only',
  'pricing.feature.priority': 'Priority processing',
  'pricing.feature.prompting': 'Translation prompting',
  'pricing.feature.readDocs': 'Read documentation',
  'pricing.feature.speechToText': 'Auto speech-to-text transcription',
  'pricing.feature.srtDownload': 'SRT download',
  'pricing.feature.srtDownloadUpload': 'SRT download & upload',
  'pricing.feature.srtUpload': 'SRT upload',
  'pricing.feature.support': 'Support 24/7',
  'pricing.feature.teamspace3': '1 Teamspace, 3 members',
  'pricing.feature.teamspace5': '1 Teamspace, 5 members',
  'pricing.feature.teamspaces': 'Teamspaces',
  'pricing.feature.voiceClones10': '10 custom voice clones',
  'pricing.feature.voiceClones3': '3 custom voice clones',
  'pricing.feature.voiceCloning': 'Voice cloning in 32 languages',
  'pricing.feature.voiceCloningDescription':
    'Available in 32 languages, including English, Spanish, French, Italian, Portuguese, and Russian.',
  'pricing.feature.voiceLibrary': 'Voice Clone library',
  'pricing.feature.voiceSettings': 'Voice Clone settings',
  'pricing.feature.watermark': 'Watermark',
  "pricing.featurePaywall.controlDownload.formats": "Any format anytime",
  "pricing.featurePaywall.controlDownload.fullVideo": "Export the full video, not just the preview",
  "pricing.featurePaywall.controlDownload.share": "Share for free",
  "pricing.featurePaywall.controlDownload.subtitle": "Upgrade to download videos without watermarks and get unlimited downloads, or share for free.",
  "pricing.featurePaywall.controlDownload.title": "Unlock full video export or share for free",
  "pricing.featurePaywall.controlDownload.unlock": "Unlock video export",
  "pricing.featurePaywall.controlDownload.watermark": "Remove watermark",
  'pricing.header.description':
    'Every plan includes video translation into any language, emotion-preserving voice cloning, and free, easy-to-use controls.',
  'pricing.header.title': 'Plans that scale with your video output',
  'pricing.legacy.businessFeature1': 'Ensure brand voice consistency',
  'pricing.legacy.businessFeature2': 'Control terminology in translation',
  'pricing.legacy.businessFeature3': 'Process large volumes of content faster than ever',
  'pricing.legacy.creatorFeature1': 'Dub in 135+ languages with AI',
  'pricing.legacy.creatorFeature2': 'Clone voices in 32 languages',
  'pricing.legacy.creatorFeature3': 'Powerful editor with unlimited use',
  'pricing.legacy.creatorFeature4': 'Auto transcription and translation',
  'pricing.legacy.creatorProFeature1': 'Add lip-sync and subtitles',
  'pricing.legacy.creatorProFeature2': 'Use pro-level voice and script tools',
  'pricing.legacy.creatorProFeature3': 'Work together in a shared space',
  'pricing.legacy.enterpriseFeature1': 'Get custom contracts and invoicing',
  'pricing.legacy.enterpriseFeature2': 'Access dedicated priority support',
  'pricing.legacy.enterpriseFeature3': 'Tailor everything to fit your needs',
  'pricing.legacy.everythingBusiness': 'Everything in Business, plus:',
  'pricing.legacy.everythingCreator': 'Everything in Creator, plus:',
  'pricing.legacy.everythingCreatorPro': 'Everything in Creator Pro, plus:',
  'pricing.limits.enterprise.contactOrSelectPlan':
    'Contact our partnership specialist at {email} or select one of our pricing plans.',
  'pricing.limits.enterprise.notEnoughMinutes': "You don't have enough minutes to translate this video.",
  'pricing.limits.enterprise.notEnoughMinutesShort': 'Not enough minutes to translate this video.',
  'pricing.limits.enterprise.purchaseMore': 'Contact our partnership specialist to purchase more minutes: {email}',
  'pricing.limits.enterprise.ranOut': 'Your plan has run out of minutes.',
  'pricing.limits.enterprise.renewAccess': 'Contact our partnership specialist at {email} to renew your access.',
  'pricing.limits.enterprise.renewOrSelectPlan':
    'Contact our partnership specialist at {email} to renew your access or select one of our pricing plans.',
  'pricing.limits.exploreFullVersion': 'Explore the full version with advanced features',
  'pricing.limits.feature.lipSyncBeta': 'Apply the Lip-sync feature (beta)',
  'pricing.limits.feature.noTrialLimits': 'Upload files without free trial limits',
  'pricing.limits.feature.proofread': 'Proofread before dubbing',
  'pricing.limits.feature.srtUpload': 'Upload an SRT file along with your video',
  'pricing.limits.feature.translation130': 'Translate into 135+ languages',
  'pricing.limits.feature.voiceClone28': 'Use Voice Clone in 32 languages',
  'pricing.limits.freeVideoLimit': "You've reached your free videos limit.",
  'pricing.limits.notEnoughMinutes': 'There are not enough available minutes to translate the video.',
  'pricing.limits.paymentFailed':
    "We couldn't process payment to renew your subscription. Please update your payment details to keep using Rask.",
  'pricing.limits.renewSubscription': 'Renew subscription',
  'pricing.limits.spaceUnsupported': 'Your current plan does not support this space. Upgrade to continue using it.',
  'pricing.limits.subscriptionCanceled': 'Your subscription is canceled.',
  'pricing.limits.subscriptionCanceledDescription':
    'We froze the minutes in your account. Renew your subscription to keep using Rask and spend your minutes.',
  'pricing.limits.subscriptionExpired': 'Your subscription has expired. Renew your subscription to keep using Rask.',
  'pricing.limits.subscriptionPaused':
    'Your subscription is paused. We froze the minutes in your account. Renew your subscription to keep using Rask and spend your minutes.',
  'pricing.limits.translationMinuteLimit': "You've reached your minute limit for Translation.",
  'pricing.limits.unlockFullVersion': 'Unlock full version',
  'pricing.limits.updatePayment': 'Update payment details',
  'pricing.limits.upgradeForMoreVideos': 'Upgrade to translate more videos',
  'pricing.limits.upgradeForMoreVideosTitle': 'Upgrade to translate more videos:',
  'pricing.limits.upgradePlanForMoreVideos': 'Upgrade your plan to translate more videos',
  'pricing.limits.upgradeToContinue': 'Upgrade to continue generating content.',
  'pricing.limits.whiteLabelInactive':
    'Your subscription is no longer active. Please contact {email} for further assistance.',
  'pricing.limits.whiteLabelOutOfMinutes': 'You have run out of minutes. Please recharge your minutes balance.',
  'pricing.minutes.custom': 'Custom minutes',
  'pricing.minutes.from': 'from {count} minutes',
  'pricing.minutes.fromMonthly': 'From {count} minutes/month',
  'pricing.minutes.included': '{count} minutes included',
  'pricing.modal.closeAria': 'Close',
  'pricing.notActive.checkBoosters': 'Check out other boosters',
  'pricing.notActive.closeAria': 'Close team invite offer',
  'pricing.notActive.paidDescription':
    'Add more members to your subscription and collaborate seamlessly in your shared space!',
  'pricing.notActive.title': 'Better together. Invite your team!',
  'pricing.notActive.trialDescription':
    'Create dedicated workspaces, invite collaborators, and manage projects together with Teamspaces.',
  'pricing.notActive.trialPaywallTitle': 'Unlock team potential',
  'pricing.notActive.unlockTeamspaces': 'Unlock Teamspaces with Creator Pro',
  'pricing.pause.chargeDescription': 'You will be charged your original {interval} rate of {price} on {date}.',
  'pricing.pause.description':
    "It's scheduled to reactivate on {date}. Your account data is being kept safe for when your subscription resumes.",
  'pricing.pause.nextBillingDate': 'your next billing date',
  'pricing.pause.resumeNow': 'Resume subscription now',
  'pricing.pause.resumeTitle': 'Want to resume?',
  'pricing.pause.success': 'Subscription resumed.\nYou will be billed on your next subscription renewal date.',
  'pricing.pause.title': 'Your subscription is paused',
  'pricing.paywall.enterpriseQuestion': 'Translating more than 1,000 minutes a month?',
  'pricing.paywall.feature.api': 'API access',
  'pricing.paywall.feature.customVoiceClone': 'Customize Voice Clone and save it to your library',
  'pricing.paywall.feature.dictionary': 'Save custom translations in the Dictionary',
  'pricing.paywall.feature.lipSync': 'Apply lip-sync',
  'pricing.paywall.feature.srtDownload': 'Download an SRT subtitle file',
  'pricing.paywall.feature.srtUpload': 'Upload an SRT file with your video',
  'pricing.paywall.feature.subtitles': 'Add subtitles to your video',
  'pricing.paywall.feature.teamspacesSoon': 'Create Teamspaces and collaborate with your team',
  'pricing.paywall.feature.translation130': 'Translate your video and audio into 135+ languages',
  'pricing.paywall.feature.voiceClone29': 'Voice Clone in 32 languages',
  'pricing.paywall.queueTitle': 'The queue for free users is currently overloaded',
  'pricing.paywall.requestEnterpriseDemo': 'Request enterprise demo',
  'pricing.paywall.upgradeTitle': 'Upgrade to get full access!',
  'pricing.paywall.viewPlans': 'View plans',
  'pricing.plan.bestForBeginners': 'Best for beginners',
  'pricing.plan.bestForIndividuals': 'Best for individuals',
  'pricing.plan.bestValue': 'Best value',
  'pricing.plan.business': 'Business',
  'pricing.plan.businessDescription': 'For teams with a growing video library',
  'pricing.plan.businessFeature1': 'Review and manage projects with your team',
  'pricing.plan.businessFeature2': 'Keep brand and terminology consistent',
  'pricing.plan.businessFeature3': 'Upload and translate batches of videos',
  'pricing.plan.creator': 'Creator',
  'pricing.plan.creatorDescription': 'For creators working on smaller projects',
  'pricing.plan.creatorFeature1': 'Zero-setup onboarding',
  'pricing.plan.creatorFeature2': 'Translate a single video into a few languages',
  'pricing.plan.creatorFeature3': 'Upgrade when you localize regularly',
  'pricing.plan.creatorPro': 'Creator Pro',
  'pricing.plan.creatorProDescription': 'For creators who publish videos regularly',
  'pricing.plan.creatorProFeature1': 'Control translation and speech accuracy',
  'pricing.plan.creatorProFeature2': 'Preserve speaker identity with lip-sync',
  'pricing.plan.creatorProFeature3': 'Built for recurring projects with a small team',
  'pricing.plan.current': 'Current plan',
  'pricing.plan.currentOutsideGrid': 'Your current plan: {plan}, {price}',
  'pricing.plan.currentShort': 'Current',
  'pricing.plan.enterprise': 'Enterprise',
  'pricing.plan.enterpriseDescription': 'For global operations requiring trust and predictability',
  'pricing.plan.enterpriseFeature1': 'Security and compliance readiness',
  'pricing.plan.enterpriseFeature2': 'Production reliability and SLA',
  'pricing.plan.enterpriseFeature3': 'Custom integrations and API access',
  'pricing.plan.enterpriseFeature4': 'Managed quality assurance',
  'pricing.plan.limitedOffer': 'Limited time offer',
  'pricing.plan.mostPopular': 'Most popular',
  'pricing.plan.starter': 'Starter',
  'pricing.plan.starterDescription': 'For getting started with simple video localization',
  'pricing.plan.tailoredOnboarding': 'Tailored onboarding & SLA',
  'pricing.plan.toggleDetails': 'Toggle plan details',
  'pricing.plan.unlimitedRecording': 'Unlimited screen recording',
  'pricing.price.billedMonthly': 'billed monthly',
  'pricing.price.billedYearly': 'billed {amount} yearly',
  'pricing.price.custom': 'Custom',
  'pricing.price.from': 'from',
  'pricing.price.perMonth': '/mo',
  'pricing.price.perMonthLong': 'per month',
  'pricing.renew.happy': "We're happy you're here again!",
  'pricing.renew.welcome': 'Welcome back!',
  'pricing.savings.year': 'Save {amount}/year ({percent}% off)',
  'pricing.socialProof': 'Over {count} happy users',
  'pricing.starter.allCreator': 'All features from the Creator plan',
  'pricing.starter.currentTitle': '{plan} Plan {price} per month',
  'pricing.starter.minuteDescription':
    '1 minute = 1 minute of translated content. For example, translating a 1-minute video into two languages uses 2 minutes.',
  'pricing.starter.minuteTitle': 'What does one minute mean?',
  'pricing.starter.tryTitle': 'Try it out for {price} per month with the {plan} Plan',
  'pricing.starter.watermarkDescription':
    'The video will have a “Translated by Rask AI” watermark in the top-right corner.',
  'pricing.title': 'Pricing',
  'pricing.trial.continue': 'Continue with free trial',
  'pricing.upgrade.aiRewrite.unlockAiRewriteFeature': 'Unlock AI rewrite feature',
  'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl':
    'Upgrade to Creator Pro plan for speed control and AI-driven segment alignment to match your timestamps',
  'pricing.upgrade.audioDownload.unlockAudioDownload': 'Unlock Audio download',
  'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated':
    'Upgrade to Creator to download audio with generated voice or audio with voice and background sound',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members': '1 Team space with up to 10 members',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members': '1 Team space with up to 5 members',
  'pricing.upgrade.bullets.aiScriptAdjustment': 'AI script adjustment',
  'pricing.upgrade.bullets.apiAccess': 'API access',
  'pricing.upgrade.bullets.automatedCaptionsSubtitles': 'Automated captions/subtitles',
  'pricing.upgrade.bullets.businessContractAndInvoicing': 'Business contract and invoicing',
  'pricing.upgrade.bullets.customPriceForMinutes': 'Custom price for minutes',
  'pricing.upgrade.bullets.customVoiceCloneLibrary': 'Custom Voice Clone library',
  'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices': 'Custom Voice Clone library (10 custom voices)',
  'pricing.upgrade.bullets.downloadGeneratedVoice': 'Download generated voice',
  'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound': 'Download generated voice with background sound',
  'pricing.upgrade.bullets.from100MinutesEveryMonth': 'From 100 minutes every month',
  'pricing.upgrade.bullets.from2000MinutesEveryMonth': 'From 2000 minutes every month',
  'pricing.upgrade.bullets.from25MinutesEveryMonth': 'From 25 minutes every month',
  'pricing.upgrade.bullets.from500MinutesEveryMonth': 'From 500 minutes every month',
  'pricing.upgrade.bullets.humanInTheLoop': 'Human-in-the-loop',
  'pricing.upgrade.bullets.multispeakerLipSync': 'Multispeaker Lip-Sync',
  'pricing.upgrade.bullets.noWatermark': 'No watermark',
  'pricing.upgrade.bullets.personalCustomerManager': 'Personal Customer Manager',
  'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation': 'Simultaneous multi-language translation',
  'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload': 'SRT transcript upload and SRT download',
  'pricing.upgrade.bullets.translationDictionaries': 'Translation dictionaries',
  'pricing.upgrade.bullets.translationPrompting': 'Translation prompting',
  'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers': 'Unlimited Teamspaces and members',
  'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones': 'Unlimited Custom Voice Clones',
  'pricing.upgrade.bullets.voiceCloneSettings': 'Voice Clone settings',
  'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark':
    'Add any terms with preferred translations (or mark as untranslated)',
  'pricing.upgrade.glossary.applyToAnyProjectWithOneClick': 'Apply to any project with one click',
  'pricing.upgrade.glossary.createADictionaryForYourLanguagePair': 'Create a dictionary for your language pair',
  'pricing.upgrade.glossary.howItWorks': 'How it works',
  'pricing.upgrade.glossary.howToUseDictionaryEffectively': 'about how to use the dictionary effectively',
  'pricing.upgrade.glossary.learnMore': 'Learn more',
  'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay':
    'Lock in translations once and they’ll stay consistent across all videos.',
  'pricing.upgrade.glossary.perfectFor': 'Perfect for',
  'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation':
    'Trusted by 83% of Business users for translation accuracy',
  'pricing.upgrade.glossary.unlockTranslationDictionary': 'Unlock Translation dictionary',
  'pricing.upgrade.glossary.upgradeToBusiness': 'Upgrade to Business',
  'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary':
    'Upgrade to Business to create Translation Dictionary',
  'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr':
    'videos with specific terminology and product names, or multilingual content libraries.',
  'pricing.upgrade.lipSync.aboutLipSyncFeature': 'about Lip-sync feature',
  'pricing.upgrade.lipSync.enhancedModel':
    'New Enhanced lip-sync model — studio-grade quality (deducts {multiplier} minutes per 1 minute of video)',
  'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync': 'Every face on screen, perfectly in sync',
  'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther':
    'Get professional content with Lip-sync and other Pro tools',
  'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio':
    'Lip-sync matches mouth movements to translated audio so your video looks naturally dubbed, not overlaid.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth':
    'Make dubbed videos look natural by matching mouth movements to translated audio. Available on Creator Pro and above.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookReal': 'Make dubbed videos look real',
  'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage': 'Natural-looking dubbed videos in any language',
  'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters':
    'professional content where visual authenticity matters.',
  'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility':
    'Publish to any market without losing credibility',
  'pricing.upgrade.lipSync.seePlansWithLipSync': 'See plans with Lip-sync',
  'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple':
    'Synchronized lip movements with translated audio for multiple speakers',
  'pricing.upgrade.lipSync.unlockLipSyncFeature': 'Unlock Lip-sync feature',
  'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip':
    'Upgrade to Creator Pro plan to add lip-sync to your videos and experience top-notch translation quality',
  'pricing.upgrade.lipSync.withLipSync': 'With Lip-sync:',
  'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver': 'Your content feels native, not dubbed over',
  'pricing.upgrade.multilanguage.learnMoreCaption': '(Learn more)[{link}] about how to use this feature effectively',
  'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature': 'Unlock Multi-language translation feature',
  'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer':
    'Your plan allows translation to 1 language per upload. Upgrade to translate your video into multiple languages',
  'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade':
    "You've reached your free videos limit. Upgrade to Business plan to translate your videos into multiple languages",
  'pricing.upgrade.paywallTitles.unlockAudioExportAndMore': 'Unlock Audio Export and more',
  'pricing.upgrade.paywallTitles.unlockDictionaryAndMore': 'Unlock Dictionary and more',
  'pricing.upgrade.paywallTitles.unlockGlossaryAndMore': 'Unlock Glossary and more',
  'pricing.upgrade.paywallTitles.unlockLipSyncAndMore': 'Unlock Lip-sync and more',
  'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore': 'Unlock Multi-language and more',
  'pricing.upgrade.paywallTitles.unlockPromptingAndMore': 'Unlock Prompting and more',
  'pricing.upgrade.paywallTitles.unlockSrtExportAndMore': 'Unlock SRT Export and more',
  'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore': 'Unlock SRT Upload and more',
  'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore': 'Unlock Subtitle export and more',
  'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore': 'Unlock Teamspaces and more',
  'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore': 'Unlock Translation Prompting and more',
  'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore': 'Unlock Unlimited Length and more',
  'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore': 'Unlock Video Subtitles and more',
  'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore': 'Unlock Voice Presets and more',
  'pricing.upgrade.srtDownload.aboutSrtDownload': 'about SRT Download',
  'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers':
    'Both original and translated subtitle versions with speakers',
  'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads':
    'creators who need custom subtitle variations, YouTube uploads, or external editing workflows.',
  'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize':
    'Get flexible subtitle files you can edit, customize, and use anywhere.',
  'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt':
    'Get full control over your subtitles with SRT and Pro tools',
  'pricing.upgrade.srtDownload.orUpgradeToCreatorPro': 'or Upgrade to Creator Pro',
  'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken':
    'Plain-text subtitle files with timecodes and spoken text',
  'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing':
    'Text segments formatted for video platforms or editing tools',
  'pricing.upgrade.srtDownload.unlockSrtDownload': 'Unlock .SRT download',
  'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt':
    'Upgrade to Creator Pro plan to download SRT files containing subtitles for both the original and translated videos',
  'pricing.upgrade.srtDownload.whatYouLlGet': "What you'll get",
  'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile':
    'Download SRT → Send for corrections → Upload updated file',
  'pricing.upgrade.srtUpload.howToUseSrtUpload': 'about how to use SRT upload',
  'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo':
    'Instantly refresh text, timing, and speaker info',
  'pricing.upgrade.srtUpload.noManualCopyPaste': 'No manual copy-paste',
  'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick': 'Replace hours of manual editing with one click',
  'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo':
    'teams who edit subtitles externally and want to sync updates fast.',
  'pricing.upgrade.srtUpload.unlockSrtUpload': 'Unlock SRT upload',
  'pricing.upgrade.srtUpload.unlockSrtUploadFeature': 'Unlock SRT upload feature',
  'pricing.upgrade.srtUpload.updateSubtitlesInSeconds': 'Update subtitles in seconds',
  'pricing.upgrade.srtUpload.upgradeToCreatorPro': 'Upgrade to Creator Pro',
  'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair':
    'Upgrade to Creator Pro plan to effortlessly pair your video with existing subtitles for accurate dubbing results',
  'pricing.upgrade.srtUpload.uploadAnEditedSrtFile': 'Upload an edited SRT file',
  'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick': 'Upload corrected transcript in one click.',
  'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith':
    'anyone who publishes across platforms or works with a team.',
  'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready':
    'Export translated subtitles as an SRT file — already timed, already translated, ready to drop into any workflow.',
  'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools': 'Get subtitle export with other Pro tools',
  'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra':
    'Hand off to editors or clients without extra steps',
  'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn':
    'Publish to YouTube, TikTok, or any platform in minutes',
  'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport': 'See plans with Subtitle export',
  'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens':
    'Take your subtitles wherever the work happens',
  'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo':
    'Timestamps stay perfectly aligned with your video',
  'pricing.upgrade.subtitleExport.withSubtitleExport': 'With Subtitle export:',
  'pricing.upgrade.teamspace.aboutTeamspaceCollaboration': 'about Teamspace collaboration',
  'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout':
    'agencies and teams managing multiple dubbing projects without the chaos.',
  'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace': 'Collaborate with your team in one place.',
  'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf':
    'Contact us to find the right number of Teamspaces and members for your team.',
  'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra':
    'Give full feature access for invitees without extra subscriptions',
  'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials':
    'Invite teammates with individual logins - no shared credentials',
  'pricing.upgrade.teamspace.lookingToScaleYourTeam': 'Looking to scale your team?',
  'pricing.upgrade.teamspace.orContactUs': 'or Contact us',
  'pricing.upgrade.teamspace.orUpgradeToBusiness': 'or Upgrade to Business',
  'pricing.upgrade.teamspace.scaleYourTeam': 'Scale your team',
  'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60': 'Teams cut project coordination time by 60%',
  'pricing.upgrade.teamspace.unlockTeamspaces': 'Unlock Teamspaces',
  'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5':
    'Upgrade to Business for a Teamspace with 5 seats, or add the seats you need.',
  'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith':
    'Upgrade to Creator Pro to have a Teamspace with up to 3 members',
  'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember':
    'Upgrade to Enterprise for custom Teamspaces and member limits, or add the seats you need.',
  'pricing.upgrade.teamspace.workBetterTogether': 'Work better together',
  'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd':
    'Work on shared projects seamlessly - no back and forth file transfers',
  'pricing.upgrade.texts.choosePlan': 'Choose plan',
  'pricing.upgrade.texts.contactUs': 'Contact us',
  'pricing.upgrade.texts.everythingInBusinessPlus': 'Everything in Business, plus:',
  'pricing.upgrade.texts.everythingInCreatorPlus': 'Everything in Creator, plus:',
  'pricing.upgrade.texts.everythingInCreatorProPlus': 'Everything in Creator Pro, plus:',
  'pricing.upgrade.texts.everythingInTrialPlus': 'Everything in Trial, plus:',
  'pricing.upgrade.texts.orChoosePlan': 'or Choose plan',
  'pricing.upgrade.texts.upgradeToBusinessPlan': 'Upgrade to Business Plan',
  'pricing.upgrade.texts.upgradeToCreatorPlan': 'Upgrade to Creator Plan',
  'pricing.upgrade.texts.upgradeToCreatorProPlan': 'Upgrade to Creator Pro Plan',
  'pricing.upgrade.texts.withTheBusinessPlanYouLlGet': "With the Business plan, you'll get:",
  'pricing.upgrade.texts.withTheCreatorPlanYouLlGet': "With the Creator plan, you'll get:",
  'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet': "With the Creator Pro plan, you'll get:",
  'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd':
    'Dictionary saves your brand names, product terms, and key phrases — and uses them consistently across every project.',
  'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain': 'Fix a term once, never correct it again',
  'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro':
    'Get consistent translations with Dictionary and other Pro tools',
  'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross':
    'No more re-editing the same terms across projects',
  'pricing.upgrade.translationDictionary.seePlansWithDictionary': 'See plans with Dictionary',
  'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand':
    'teams and creators with specific terminology or brand language.',
  'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect':
    'Translations that sound like you, not just correct',
  'pricing.upgrade.translationDictionary.withDictionary': 'With Dictionary:',
  'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage':
    'Your brand voice stays consistent in every language',
  'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot':
    'Content that feels written for that audience, not translated',
  'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther':
    'Get better translation control with Prompting and other Pro tools',
  'pricing.upgrade.translationTone.lessEditingAfterEveryDub': 'Less editing after every dub',
  'pricing.upgrade.translationTone.seePlansWithPrompting': 'See plans with Prompting',
  'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows': 'teams with ongoing localization workflows.',
  'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd':
    'Tell us the tone, audience, and context — and get a translation that fits your content, not just the words.',
  'pricing.upgrade.translationTone.translationsThatSoundLikeYou': 'Translations that sound like you',
  'pricing.upgrade.translationTone.withPrompting': 'With Prompting:',
  'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage': 'Your tone carries across every language',
  'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews':
    'any content longer than a minute — tutorials, interviews, courses.',
  'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview': 'Dub the whole video, not just a preview',
  'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd': 'Every word, every speaker, to the very end',
  'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools':
    'Get full-length dubbing with other Pro tools',
  'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit': 'No content cut to fit a time limit',
  'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength': 'See plans with Unlimited length',
  'pricing.upgrade.unlimitedLength.withUnlimitedLength': 'With Unlimited length:',
  'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo':
    'Your full video, fully dubbed and ready to publish',
  'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid':
    'Your trial previews 1 minute. On a paid plan, Rask dubs the entire file — nothing cut, nothing missing.',
  'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations':
    'brands and creators who need on-brand translations without heavy editing.',
  'pricing.upgrade.userPrompting.controlYourTranslation': 'Control your translation',
  'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5':
    'Enterprise users confirm translation edits up to 5× faster',
  'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology': 'Guide word choice and terminology',
  'pricing.upgrade.userPrompting.howToUsePromptingEffectively': 'about how to use prompting effectively',
  'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice':
    'Make your dubbed videos match your brand voice.',
  'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations':
    'Set the tone, style, and context for translations with prompts. Pick from our templates or write your own prompt to fit your needs.',
  'pricing.upgrade.userPrompting.setToneAndFormalityLevel': 'Set tone and formality level',
  'pricing.upgrade.userPrompting.unlockTranslationPrompting': 'Unlock Translation prompting',
  'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature': 'Unlock Translation prompting feature',
  'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts':
    'Use ready-made templates or write custom prompts',
  'pricing.upgrade.videoSubtitles.unlockCaptionsFeature': 'Unlock Captions feature',
  'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith':
    'Upgrade to Creator Pro to download videos with subtitles',
  'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary': 'about Voice Clone library',
  'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents': 'Adjust expressiveness or remove accents',
  'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining':
    'Creators dubbing in multiple languages and brands maintaining same voice across content.',
  'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro': 'Level up dubbing with this and other Pro tools',
  'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery':
    'Make your cloned voice sound exactly right - every time.',
  'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects':
    'Reuse your cloned voices across unlimited projects',
  'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes':
    'Save customized voice clones or create new ones from scratch',
  'pricing.upgrade.voicePresets.unlockMoreVoiceClones': 'Unlock more Voice Clones',
  'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary': 'Unlock Voice Clone library',
  'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10':
    'Upgrade to Business to save up to 10 Custom Voice Clones',
  'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom':
    'Upgrade to Creator Pro to create a Custom Voice Clone',
  'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice':
    'Upgrade to Enterprise to save unlimited Custom Voice Clones',
  'pricing.upgrade.voicePresets.whatYouCanDo': 'What you can do',
  'pricing.yearly.buyMinutes': 'Buy additional minutes anytime',
  'pricing.yearly.keepMinutes': 'No minutes lost at the end of the month',
  'pricing.yearly.only': 'YEARLY PLANS ONLY',
  'pricing.yearly.unlimitedEditing': 'Unlimited re-editing and redubbing',
} as const;

const es: Record<keyof typeof en, string> = {
  'billing.confirm.amountDue': 'Monto adeudado hoy',
  'billing.confirm.and': 'y',
  'billing.confirm.boostersTerms': 'las Condiciones de uso de Boosters',
  'billing.confirm.confirm': 'Confirmar',
  'billing.confirm.discountHint': 'El descuento {percent}% se aplica únicamente a la primera factura.',
  'billing.confirm.havePromo': '¿Tienes un código de promoción?',
  'billing.confirm.hideDetails': 'Ocultar detalles',
  'billing.confirm.invalidPromo': 'El código de promoción no es válido',
  'billing.confirm.monthlyFrom': 'Facturación mensual a partir del {date}',
  'billing.confirm.noCharges': 'Sin próximos cargos por Boosters',
  'billing.confirm.noChargesDescription': 'No tendrás ningún Booster activo después de la confirmación.',
  'billing.confirm.oneTimeHint': 'El pago único cubre el uso hasta el final del ciclo de facturación.',
  'billing.confirm.paymentMethod': 'Método de pago',
  'billing.confirm.perMonth': '/mes',
  'billing.confirm.perYear': '/año',
  'billing.confirm.privacy': 'la Política de privacidad',
  'billing.confirm.promoFailed': 'No se pudo aplicar el código de promoción',
  'billing.confirm.promoLine': 'Código promocional {code}',
  'billing.confirm.promoPlaceholder': 'código promocional',
  'billing.confirm.promotionTerms': 'las Condiciones de la promoción',
  'billing.confirm.remove': 'eliminar',
  'billing.confirm.removeItem': 'Eliminar {item}',
  'billing.confirm.renews': 'Se renueva automáticamente hasta que se cancele',
  'billing.confirm.subscribe': 'Suscríbete con obligación de pago',
  'billing.confirm.taxHint': 'El total incluye impuestos según tu información de facturación.',
  'billing.confirm.terms': 'los Términos del servicio',
  'billing.confirm.termsIntro': 'Al confirmar, aceptas las siguientes condiciones y políticas de Rask AI:',
  'billing.confirm.updatePayment': 'Por favor actualice el método de pago',
  'billing.confirm.vat': 'IVA {percent}',
  'billing.confirm.viewDetails': 'Ver detalles',
  'billing.confirm.yearlyFrom': 'Facturación anual a partir del {date}',
  'billing.error.authentication': 'Error de autenticación de pago. No pudimos confirmar el pago con su banco.',
  'billing.error.bankDeclined': 'Su banco rechazó el pago. El banco no aprobó esta transacción.',
  'billing.error.cardCannotBeUsed': 'Esta tarjeta no se puede utilizar',
  'billing.error.cardDetails':
    'Los datos de la tarjeta son incorrectos. Verifique el número de su tarjeta, la fecha de vencimiento y el código de seguridad.',
  'billing.error.changePayment': 'Cambia tu método de pago',
  'billing.error.editPayment': 'Editar método de pago',
  'billing.error.failed': 'Pago fallido',
  'billing.error.insufficient':
    'Error en el pago: fondos insuficientes o límite alcanzado. Su banco rechazó el pago debido a un saldo bajo o límite de gasto.',
  'billing.error.retryPayment': 'Inténtalo de nuevo o cambia el método de pago',
  'billing.result.canClose': 'Puedes cerrar este modal en cualquier momento.',
  'billing.result.closeWindow': 'Cerrar ventana',
  'billing.result.processing': 'Estamos procesando tu pedido',
  'billing.result.processingDescription':
    'Esto puede tardar unos minutos. Continuaremos procesándolo en segundo plano y activaremos tu suscripción automáticamente una vez que se complete.',
  'billing.result.success': 'Pago procesado exitosamente',
  'billing.result.viewInvoice': 'Ver factura',
  'bookDemo.booked': '¡Tu demo está reservada!',
  'bookDemo.bookedFor': 'Tu demo está reservada para {slot}',
  'bookDemo.coverDescription':
    'su caso de uso de adaptación y la mejor manera de ejecutarlo en Rask, cómo funciona en su equipo y una estructura de precios clara.',
  'bookDemo.coverTitle': 'Lo que cubriremos:',
  'bookDemo.inviteSent': 'Se ha enviado una invitación con el enlace de la reunión a su correo electrónico.',
  'bookDemo.seeYou': 'Nos vemos pronto',
  'bookDemo.subtitle':
    'Analizaremos su flujo de trabajo, mostraremos funciones ocultas y elegiremos el mejor plan para sus necesidades.',
  'bookDemo.timeBenefit': 'Una demostración de 30 minutos le ahorra unas 5 horas de exploración del producto.',
  'bookDemo.title': 'Reserve una demostración con nuestro especialista',
  'pricing.actions.contactUs': 'Contáctenos',
  'pricing.actions.downgrade': 'Cambiar a un plan inferior',
  'pricing.actions.getStarted': 'Empezar',
  'pricing.actions.renew': 'Renovar',
  'pricing.actions.switchAnnual': 'Cambiar a anual',
  'pricing.actions.switchMonthly': 'Cambiar a mensual',
  'pricing.actions.upgrade': 'Mejorar plan',
  'pricing.archived.description': 'Actualmente estás en un plan {plan} archivado con {count} minutos incluidos.',
  'pricing.archived.hint': 'Sigue usándolo o pásate al nuevo plan.',
  'pricing.billing.annual': 'Anual',
  'pricing.billing.aria': 'Periodo de facturación',
  'pricing.billing.billAnnual': 'Facturar anualmente',
  'pricing.billing.billedAnnually': 'Facturado anualmente',
  'pricing.billing.monthly': 'Mensual',
  'pricing.billing.payAnnual': 'Pagar anualmente',
  'pricing.booster.addForMonth': 'Añadir por {price} al mes',
  'pricing.buyMinutes.benefitRemain':
    'Los minutos no utilizados permanecerán en tu cuenta aunque pauses la suscripción',
  'pricing.buyMinutes.benefitRollOver': 'Transferiremos tus minutos no utilizados al mes siguiente',
  'pricing.buyMinutes.checkout': 'Ir al pago',
  'pricing.buyMinutes.minutes': 'Minutos',
  'pricing.buyMinutes.newPricingDescription':
    'Descubre nuestros nuevos precios con paquetes de minutos flexibles y nuevas funciones.',
  'pricing.buyMinutes.newPricingTitle': '¡Acabamos de lanzar nuevos precios!',
  'pricing.buyMinutes.payLess': 'Pagar menos',
  'pricing.buyMinutes.payOnly': '¡Paga solo {price} por minuto!',
  'pricing.buyMinutes.perMinute': '{price}/min',
  'pricing.buyMinutes.price': 'Precio',
  'pricing.buyMinutes.title': 'Comprar minutos adicionales',
  'pricing.buyMinutes.upgradeDescription': 'Mejora tu plan y paga menos por los minutos adicionales',
  'pricing.cancelDowngrade.button': 'Cancelar cambio a un plan inferior',
  'pricing.cancelDowngrade.currentDescription':
    'Actualmente tienes el plan {plan} por {price}, con facturación {interval}, activo hasta el {date}.',
  'pricing.cancelDowngrade.currentTitle': 'Plan actual',
  'pricing.cancelDowngrade.hint': 'Puedes volver a programar el cambio cuando quieras.',
  'pricing.cancelDowngrade.scheduledDescription':
    'Tienes programado cambiar al plan {plan} por {price}, con facturación {interval}, a partir del {date}. Si cancelas el cambio, tu suscripción actual al plan {currentPlan} continuará.',
  'pricing.cancelDowngrade.scheduledTitle': 'Plan programado',
  'pricing.cancelDowngrade.success': 'Cambio de suscripción cancelado. Tu plan {plan} seguirá activo.',
  'pricing.change.activeUntil': 'Tu plan actual permanece activo hasta el {date}.',
  'pricing.change.boosterDescription':
    'La carga y descarga de SRT ahora está incluida en tu plan sin coste adicional. Eliminaremos automáticamente el Booster de SRT de tus Boosters.',
  'pricing.change.boosterIncluded': '¡Booster incluido!',
  'pricing.change.changeSuccess': 'Tu cambio de plan ha sido procesado',
  'pricing.change.current': 'Plan actual',
  'pricing.change.currentDescription':
    'Actualmente tienes el plan {plan} con facturación {interval}, activo hasta el {date}.',
  'pricing.change.downgradeDescription':
    'Vas a cambiar al plan {plan} con facturación {interval}. El cambio entrará en vigor al final de tu período de facturación actual.',
  'pricing.change.downgradeError': 'No se pudo cambiar a un plan inferior:',
  'pricing.change.downgradeSuccess': 'El cambio a un plan inferior está programado',
  'pricing.change.featuresLost': 'Funciones que pierdes',
  'pricing.change.monthly': 'mensual',
  'pricing.change.new': 'Nuevo plan',
  'pricing.change.scheduleDowngrade': 'Programar cambio a un plan inferior',
  'pricing.change.switchBack': 'Puedes volver a tu plan anterior a partir del {date}.',
  'pricing.change.upgradeDescription':
    'Vas a cambiar al plan {plan} con facturación {interval}. Obtendrás inmediatamente nuevas funciones y {count} minutos adicionales (la diferencia entre planes).',
  'pricing.change.upgradeError': 'No se pudo cambiar a un plan superior:',
  'pricing.change.upgradeNow': 'Cambiar ahora a un plan superior',
  'pricing.change.upgradePaidSuccess': 'Pago procesado correctamente; has cambiado a un plan superior',
  'pricing.change.upgradeSuccess': 'Has cambiado a un plan superior',
  'pricing.change.yearly': 'anual',
  'pricing.compare.credits': 'Créditos y generaciones',
  'pricing.compare.editor': 'Editor',
  'pricing.compare.extraMinutes': 'Minutos extra',
  'pricing.compare.minutesIncluded': 'Minutos incluidos',
  'pricing.compare.plans': 'Comparar planes',
  'pricing.compare.row.api': 'API e integraciones',
  'pricing.compare.row.apiDescription': 'Conecte Rask a sus herramientas existentes y automatice su flujo de trabajo.',
  'pricing.compare.row.autoCut': 'Corte automático con IA',
  'pricing.compare.row.autoCutDescription':
    'Elimine automáticamente las muletillas y los silencios de las grabaciones.',
  'pricing.compare.row.autoZoom': 'Zoom automático',
  'pricing.compare.row.autoZoomDescription': 'Haga zoom automáticamente sobre la acción mientras graba.',
  'pricing.compare.row.controls': 'Controles de guion, subtítulos y voz',
  'pricing.compare.row.controlsDescription':
    'Edite directamente la transcripción, las marcas de tiempo, las etiquetas de los hablantes y los ajustes de voz.',
  'pricing.compare.row.extraDescription': 'Puede comprar minutos adicionales en cualquier momento en planes anuales.',
  'pricing.compare.row.glossary': 'Glosario y terminología',
  'pricing.compare.row.glossaryDescription':
    'Guarde términos personalizados para que las mismas palabras se traduzcan de forma coherente en todo momento.',
  'pricing.compare.row.lipSync': 'Lip-sync para varios hablantes',
  'pricing.compare.row.lipSyncDescription':
    'Combina los movimientos de la boca con el audio traducido para lograr un doblaje de apariencia más natural.',
  'pricing.compare.row.minutes': 'Minutos de adaptación incluidos al año',
  'pricing.compare.row.minutesDescription':
    'Los minutos anuales disponibles para traducción o doblaje. Los planes Business anuales incluyen todos los minutos desde el inicio.',
  'pricing.compare.row.minutesTitle': 'Minutos de adaptación incluidos al año',
  'pricing.compare.row.multiLanguage': 'Flujo de trabajo en varios idiomas',
  'pricing.compare.row.multiLanguageDescription': 'Traduzca un solo vídeo a varios idiomas en un solo proyecto.',
  'pricing.compare.row.prompting': 'Instrucciones para la traducción',
  'pricing.compare.row.promptingDescription':
    'Agregue instrucciones antes de traducir para establecer el contexto: tono, formalidad y redacción.',
  'pricing.compare.row.review': 'Flujo de revisión',
  'pricing.compare.row.reviewDescription':
    'Envíe contenido traducido a los revisores para su aprobación antes de su publicación.',
  'pricing.compare.row.screenRecorder': 'Grabador de pantalla con IA',
  'pricing.compare.row.screenRecorderDescription': 'Grabe su pantalla y su cámara directamente en Rask.',
  'pricing.compare.row.security': 'Seguridad y adquisiciones',
  'pricing.compare.row.securityDescription': 'Soporte para contratos, facturación y documentación de cumplimiento.',
  'pricing.compare.row.speed': 'Velocidad de procesamiento',
  'pricing.compare.row.speedDescription': 'Qué tan rápido se procesan y renderizan sus videos.',
  'pricing.compare.row.srt': 'Importación/exportación SRT',
  'pricing.compare.row.srtDescription':
    'Descargue archivos de subtítulos o suba los suyos para sincronizarlos con el doblaje.',
  'pricing.compare.row.srtTitle': 'Importación/exportación SRT',
  'pricing.compare.row.team': 'Espacio de trabajo en equipo',
  'pricing.compare.row.teamDescription':
    'Invite a compañeros de equipo a colaborar en proyectos en un espacio compartido.',
  'pricing.compare.row.voices': 'Voces personalizadas guardadas',
  'pricing.compare.row.voicesDescription': 'Guarde voces clonadas para poder reutilizarlas en proyectos futuros.',
  'pricing.compare.showAll': 'Ver todas las funciones',
  'pricing.compare.showLess': 'Mostrar menos',
  'pricing.compare.subtitle': 'Elija el plan que coincida con la frecuencia con la que publica.',
  'pricing.compare.support': 'Soporte y trabajo en equipo',
  'pricing.compare.title': 'Compare lo que cambia cuando escala',
  'pricing.compare.value.compliance': 'SSO, DPA, revisión de cumplimiento',
  'pricing.compare.value.customBatch': 'Canalizaciones por lotes personalizadas',
  'pricing.compare.value.customIntegrations': 'Integraciones personalizadas',
  'pricing.compare.value.customRoles': 'Roles personalizados',
  'pricing.compare.value.dedicated': 'Cola dedicada/prioritaria',
  'pricing.compare.value.extraMinute': '$3 / minuto extra',
  'pricing.compare.value.fiveMembers': 'Hasta 5 miembros + revisores invitados',
  'pricing.compare.value.fullApi': 'Acceso completo a la API',
  'pricing.compare.value.included': 'Incluido',
  'pricing.compare.value.managedQa': 'Control de calidad gestionado/aprobación de un experto en la materia',
  'pricing.compare.value.managedTerms': 'Flujo de trabajo de terminología gestionada',
  'pricing.compare.value.multiBatch': 'Lote de varios vídeos × varios idiomas',
  'pricing.compare.value.personalGlossary': 'Glosario personal',
  'pricing.compare.value.priorityQueue': 'Cola de prioridad',
  'pricing.compare.value.reviewer': 'Roles de revisor y aprobación',
  'pricing.compare.value.sandboxApi': 'API limitada/zona de pruebas',
  'pricing.compare.value.sharedGlossary': 'Glosario de marca compartido',
  'pricing.compare.value.sharedVoices': '10 voces de equipo compartidas',
  'pricing.compare.value.standard': 'Estándar',
  'pricing.compare.value.standardQueue': 'Cola estándar',
  'pricing.compare.value.three': '3',
  'pricing.compare.value.threeMembers': 'Hasta 3 miembros',
  'pricing.compare.value.unlimited': 'Ilimitado',
  'pricing.compare.value.upgradePro': 'Pásate a Pro',
  'pricing.compare.value.voiceLibrary': 'Biblioteca de voces personalizadas',
  'pricing.compare.whatChanges': 'Qué cambia',
  'pricing.enterprisePayment.contactSupport': 'Contacta con el chat de soporte o escríbenos a',
  'pricing.enterprisePayment.unknownError': 'Error desconocido',
  'pricing.feature.aiRewriter': 'Ajuste del script de IA',
  'pricing.feature.allBusiness': 'Todas las funciones de Business, además de:',
  'pricing.feature.allCreator': 'Todas las funciones de Creator, además de:',
  'pricing.feature.allCreatorPro': 'Todas las funciones de Creator Pro, además de:',
  'pricing.feature.api': 'API',
  'pricing.feature.applyChanges': 'Aplicar cambios gratis',
  'pricing.feature.businessContract': 'Contrato comercial y facturación.',
  'pricing.feature.captions': 'Subtítulos automáticos',
  'pricing.feature.customerSuccess': 'Gerente de Éxito del Cliente',
  'pricing.feature.dictionary': 'Diccionario de traducción',
  'pricing.feature.editor': 'Editor de vídeo avanzado',
  'pricing.feature.flexibleMinutes': 'Precios de minutos flexibles',
  'pricing.feature.humanReview': 'Revisión humana',
  'pricing.feature.languages': 'Traducciones en más de 135 idiomas',
  'pricing.feature.languagesDescription':
    'La disponibilidad de idiomas depende de si utiliza voces de IA o Voice Clone.',
  'pricing.feature.learnMore': 'Más información',
  'pricing.feature.lipSync': 'Lip-sync para varios hablantes',
  'pricing.feature.machineTranslation': 'Traducción automática',
  'pricing.feature.multiLanguage': 'Traducción simultánea a varios idiomas',
  'pricing.feature.noWatermark': 'Sin marca de agua',
  'pricing.feature.onlyVideoDownload': 'Solo descarga de video',
  'pricing.feature.priority': 'Procesamiento prioritario',
  'pricing.feature.prompting': 'Instrucciones para la traducción',
  'pricing.feature.readDocs': 'Leer documentación',
  'pricing.feature.speechToText': 'Transcripción automática de voz a texto',
  'pricing.feature.srtDownload': 'Descarga de SRT',
  'pricing.feature.srtDownloadUpload': 'Descarga y carga de SRT',
  'pricing.feature.srtUpload': 'Carga de SRT',
  'pricing.feature.support': 'Soporte 24 horas al día, 7 días a la semana',
  'pricing.feature.teamspace3': '1 espacio de equipo, 3 miembros',
  'pricing.feature.teamspace5': '1 espacio de equipo, 5 miembros',
  'pricing.feature.teamspaces': 'Espacios de equipo',
  'pricing.feature.voiceClones10': '10 clones de voz personalizados',
  'pricing.feature.voiceClones3': '3 clones de voz personalizados',
  'pricing.feature.voiceCloning': 'Clonación de voz en 32 idiomas',
  'pricing.feature.voiceCloningDescription':
    'Disponible en 32 idiomas, incluidos inglés, español, francés, italiano, portugués y ruso.',
  'pricing.feature.voiceLibrary': 'Biblioteca de clonación de voz',
  'pricing.feature.voiceSettings': 'Configuración de clonación de voz',
  'pricing.feature.watermark': 'Marca de agua',
  "pricing.featurePaywall.controlDownload.formats": "Cualquier formato, en cualquier momento",
  "pricing.featurePaywall.controlDownload.fullVideo": "Exporta el vídeo completo, no solo la vista previa",
  "pricing.featurePaywall.controlDownload.share": "Compartir gratis",
  "pricing.featurePaywall.controlDownload.subtitle": "Mejora tu plan para descargar el vídeo sin marca de agua y disfrutar de descargas ilimitadas, o compártelo gratis",
  "pricing.featurePaywall.controlDownload.title": "Desbloquea la exportación del vídeo completo o compártelo gratis",
  "pricing.featurePaywall.controlDownload.unlock": "Desbloquear exportación",
  "pricing.featurePaywall.controlDownload.watermark": "Elimina la marca de agua",
  'pricing.header.description':
    'Cada plan incluye traducción de video a cualquier idioma, clonación de voz que conserva las emociones y controles gratuitos y fáciles de usar.',
  'pricing.header.title': 'Planes que se adaptan a tu volumen de videos',
  'pricing.legacy.businessFeature1': 'Mantén coherente la voz de tu marca',
  'pricing.legacy.businessFeature2': 'Controla la terminología de las traducciones',
  'pricing.legacy.businessFeature3': 'Procesa grandes volúmenes más rápido que nunca',
  'pricing.legacy.creatorFeature1': 'Dobla en más de 135 idiomas con IA',
  'pricing.legacy.creatorFeature2': 'Clona voces en 32 idiomas',
  'pricing.legacy.creatorFeature3': 'Potente editor sin límites',
  'pricing.legacy.creatorFeature4': 'Transcripción y traducción automáticas',
  'pricing.legacy.creatorProFeature1': 'Añade Lip-sync y subtítulos',
  'pricing.legacy.creatorProFeature2': 'Usa herramientas profesionales de voz y guion',
  'pricing.legacy.creatorProFeature3': 'Trabaja en equipo en un espacio compartido',
  'pricing.legacy.enterpriseFeature1': 'Obtén contratos y facturación personalizados',
  'pricing.legacy.enterpriseFeature2': 'Accede a soporte prioritario dedicado',
  'pricing.legacy.enterpriseFeature3': 'Adapta todo a tus necesidades',
  'pricing.legacy.everythingBusiness': 'Todo lo incluido en Business, más:',
  'pricing.legacy.everythingCreator': 'Todo en Creator, más:',
  'pricing.legacy.everythingCreatorPro': 'Todo en Creator Pro, más:',
  'pricing.limits.enterprise.contactOrSelectPlan':
    'Contacta con nuestra especialista en colaboraciones en {email} o elige uno de nuestros planes.',
  'pricing.limits.enterprise.notEnoughMinutes': 'No tienes suficientes minutos para traducir este video.',
  'pricing.limits.enterprise.notEnoughMinutesShort': 'No hay suficientes minutos para traducir este video.',
  'pricing.limits.enterprise.purchaseMore':
    'Contacta con nuestra especialista en colaboraciones para comprar más minutos: {email}',
  'pricing.limits.enterprise.ranOut': 'Tu plan se ha quedado sin minutos.',
  'pricing.limits.enterprise.renewAccess':
    'Contacta con nuestra especialista en colaboraciones en {email} para renovar el acceso.',
  'pricing.limits.enterprise.renewOrSelectPlan':
    'Contacta con nuestra especialista en colaboraciones en {email} para renovar el acceso o elige uno de nuestros planes.',
  'pricing.limits.exploreFullVersion': 'Descubre la versión completa con funciones avanzadas',
  'pricing.limits.feature.lipSyncBeta': 'Aplica la función de Lip-sync (beta)',
  'pricing.limits.feature.noTrialLimits': 'Sube archivos sin los límites de la prueba gratuita',
  'pricing.limits.feature.proofread': 'Revisa el texto antes del doblaje',
  'pricing.limits.feature.srtUpload': 'Sube un archivo SRT junto con el video',
  'pricing.limits.feature.translation130': 'Traduce a más de 135 idiomas',
  'pricing.limits.feature.voiceClone28': 'Usa Voice Clone en 32 idiomas',
  'pricing.limits.freeVideoLimit': 'Has alcanzado el límite de videos gratuitos.',
  'pricing.limits.notEnoughMinutes': 'No hay suficientes minutos disponibles para traducir el video.',
  'pricing.limits.paymentFailed':
    'No pudimos procesar el pago para renovar tu suscripción. Actualiza los datos de pago para seguir usando Rask.',
  'pricing.limits.renewSubscription': 'Renovar suscripción',
  'pricing.limits.spaceUnsupported': 'Tu plan actual no admite este espacio. Mejora el plan para seguir usándolo.',
  'pricing.limits.subscriptionCanceled': 'Tu suscripción está cancelada.',
  'pricing.limits.subscriptionCanceledDescription':
    'Hemos congelado los minutos de tu cuenta. Renueva la suscripción para seguir usando Rask y gastar tus minutos.',
  'pricing.limits.subscriptionExpired': 'Tu suscripción ha caducado. Renuévala para seguir usando Rask.',
  'pricing.limits.subscriptionPaused':
    'Tu suscripción está en pausa y hemos congelado los minutos de tu cuenta. Renuévala para seguir usando Rask y gastar tus minutos.',
  'pricing.limits.translationMinuteLimit': 'Has alcanzado el límite de minutos de traducción.',
  'pricing.limits.unlockFullVersion': 'Desbloquear la versión completa',
  'pricing.limits.updatePayment': 'Actualizar datos de pago',
  'pricing.limits.upgradeForMoreVideos': 'Mejora el plan para traducir más videos',
  'pricing.limits.upgradeForMoreVideosTitle': 'Mejora el plan para traducir más videos:',
  'pricing.limits.upgradePlanForMoreVideos': 'Mejora tu plan para traducir más videos',
  'pricing.limits.upgradeToContinue': 'Mejora el plan para seguir generando contenido.',
  'pricing.limits.whiteLabelInactive': 'Tu suscripción ya no está activa. Contacta con {email} para obtener ayuda.',
  'pricing.limits.whiteLabelOutOfMinutes': 'Te has quedado sin minutos. Recarga tu saldo de minutos.',
  'pricing.minutes.custom': 'Minutos personalizados',
  'pricing.minutes.from': 'desde {count} minutos',
  'pricing.minutes.fromMonthly': 'Desde {count} minutos/mes',
  'pricing.minutes.included': '{count} minutos incluidos',
  'pricing.modal.closeAria': 'Cerrar',
  'pricing.notActive.checkBoosters': 'Ver otros Boosters',
  'pricing.notActive.closeAria': 'Cerrar la oferta para invitar al equipo',
  'pricing.notActive.paidDescription':
    'Añade más miembros a tu suscripción y colabora sin problemas en un espacio compartido.',
  'pricing.notActive.title': 'Mejor juntos. ¡Invita a tu equipo!',
  'pricing.notActive.trialDescription':
    'Crea espacios de trabajo dedicados, invita a colaboradores y gestiona proyectos en equipo con Teamspaces.',
  'pricing.notActive.trialPaywallTitle': 'Libera el potencial de tu equipo',
  'pricing.notActive.unlockTeamspaces': 'Desbloquea Teamspaces con Creator Pro',
  'pricing.pause.chargeDescription':
    'El cargo de la tarifa {interval} original de {price} está programado para {date}.',
  'pricing.pause.description':
    'La reactivación está programada para {date}. Tus datos se conservarán de forma segura hasta que se reanude la suscripción.',
  'pricing.pause.nextBillingDate': 'tu próxima fecha de facturación',
  'pricing.pause.resumeNow': 'Reanudar la suscripción ahora',
  'pricing.pause.resumeTitle': '¿Quieres reanudarla?',
  'pricing.pause.success': 'Suscripción reanudada.\nSe te cobrará en la próxima fecha de renovación.',
  'pricing.pause.title': 'Tu suscripción está en pausa',
  'pricing.paywall.enterpriseQuestion': '¿Traduces más de 1.000 minutos al mes?',
  'pricing.paywall.feature.api': 'Acceso a la API',
  'pricing.paywall.feature.customVoiceClone': 'Personaliza tu clon de voz y guárdalo en tu biblioteca',
  'pricing.paywall.feature.dictionary': 'Guarda traducciones personalizadas en el diccionario',
  'pricing.paywall.feature.lipSync': 'Aplica Lip-sync',
  'pricing.paywall.feature.srtDownload': 'Descarga un archivo de subtítulos SRT',
  'pricing.paywall.feature.srtUpload': 'Sube un archivo SRT junto con tu vídeo',
  'pricing.paywall.feature.subtitles': 'Añade subtítulos a tu vídeo',
  'pricing.paywall.feature.teamspacesSoon': 'Crea Teamspaces y colabora con tu equipo',
  'pricing.paywall.feature.translation130': 'Traduce tus vídeos y audios a más de 135 idiomas',
  'pricing.paywall.feature.voiceClone29': 'Clonación de voz en 32 idiomas',
  'pricing.paywall.queueTitle': 'La cola para usuarios gratuitos está saturada en este momento',
  'pricing.paywall.requestEnterpriseDemo': 'Solicitar una demo de Enterprise',
  'pricing.paywall.upgradeTitle': '¡Mejora tu plan para obtener acceso completo!',
  'pricing.paywall.viewPlans': 'Ver planes',
  'pricing.plan.bestForBeginners': 'Ideal para principiantes',
  'pricing.plan.bestForIndividuals': 'Ideal para particulares',
  'pricing.plan.bestValue': 'Mejor relación calidad-precio',
  'pricing.plan.business': 'Business',
  'pricing.plan.businessDescription': 'Para equipos con una biblioteca de vídeos en crecimiento',
  'pricing.plan.businessFeature1': 'Revisa y gestiona proyectos con tu equipo',
  'pricing.plan.businessFeature2': 'Mantén la coherencia de la marca y la terminología',
  'pricing.plan.businessFeature3': 'Sube y traduce lotes de vídeos',
  'pricing.plan.creator': 'Creator',
  'pricing.plan.creatorDescription': 'Para creadores que trabajan en proyectos más pequeños',
  'pricing.plan.creatorFeature1': 'Puesta en marcha sin configuración',
  'pricing.plan.creatorFeature2': 'Traduce un solo vídeo a varios idiomas',
  'pricing.plan.creatorFeature3': 'Pásate a un plan superior cuando la adaptación sea habitual',
  'pricing.plan.creatorPro': 'Creator Pro',
  'pricing.plan.creatorProDescription': 'Para publicar vídeos con regularidad',
  'pricing.plan.creatorProFeature1': 'Controla la precisión de la traducción y de la voz',
  'pricing.plan.creatorProFeature2': 'Preserva la identidad del hablante con Lip-sync',
  'pricing.plan.creatorProFeature3': 'Creado para proyectos recurrentes con un equipo pequeño',
  'pricing.plan.current': 'Plan actual',
  'pricing.plan.currentOutsideGrid': 'Tu plan actual: {plan}, {price}',
  'pricing.plan.currentShort': 'Actual',
  'pricing.plan.enterprise': 'Enterprise',
  'pricing.plan.enterpriseDescription':
    'Para empresas que operan a escala global y necesitan confianza y previsibilidad',
  'pricing.plan.enterpriseFeature1': 'Preparación en materia de seguridad y cumplimiento normativo',
  'pricing.plan.enterpriseFeature2': 'Fiabilidad en producción y SLA',
  'pricing.plan.enterpriseFeature3': 'Integraciones personalizadas y API',
  'pricing.plan.enterpriseFeature4': 'Garantía de calidad gestionada',
  'pricing.plan.limitedOffer': 'Oferta por tiempo limitado',
  'pricing.plan.mostPopular': 'Más popular',
  'pricing.plan.starter': 'Starter',
  'pricing.plan.starterDescription': 'Para empezar con una adaptación sencilla de videos',
  'pricing.plan.tailoredOnboarding': 'Incorporación personalizada y SLA',
  'pricing.plan.toggleDetails': 'Alternar detalles del plan',
  'pricing.plan.unlimitedRecording': 'Grabación de pantalla ilimitada',
  'pricing.price.billedMonthly': 'facturado mensualmente',
  'pricing.price.billedYearly': 'facturado {amount} anualmente',
  'pricing.price.custom': 'Personalizado',
  'pricing.price.from': 'desde',
  'pricing.price.perMonth': '/mes',
  'pricing.price.perMonthLong': 'al mes',
  'pricing.renew.happy': '¡Nos alegra tenerte de vuelta!',
  'pricing.renew.welcome': '¡Te damos la bienvenida de nuevo!',
  'pricing.savings.year': 'Ahorra {amount}/año ({percent}% de descuento)',
  'pricing.socialProof': 'Más de {count} usuarios satisfechos',
  'pricing.starter.allCreator': 'Todas las funciones del plan Creator',
  'pricing.starter.currentTitle': 'Plan {plan}: {price} al mes',
  'pricing.starter.minuteDescription':
    '1 minuto = 1 minuto de contenido traducido. Por ejemplo, traducir un video de 1 minuto a dos idiomas usa 2 minutos.',
  'pricing.starter.minuteTitle': '¿Qué significa un minuto?',
  'pricing.starter.tryTitle': 'Pruébalo por {price} al mes con el plan {plan}',
  'pricing.starter.watermarkDescription':
    'El video tendrá la marca de agua «Translated by Rask AI» en la esquina superior derecha.',
  'pricing.title': 'Precios',
  'pricing.trial.continue': 'Continuar con la prueba gratuita',
  'pricing.upgrade.aiRewrite.unlockAiRewriteFeature': 'Desbloquea la función de reescritura con IA',
  'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl':
    'Pásate al plan Creator Pro para controlar la velocidad y alinear segmentos con IA según tus marcas de tiempo',
  'pricing.upgrade.audioDownload.unlockAudioDownload': 'Desbloquea la descarga de audio',
  'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated':
    'Pásate a Creator para descargar el audio con la voz generada o con la voz y la pista de fondo',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members': '1 Teamspace con hasta 10 miembros',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members': '1 Teamspace con hasta 5 miembros',
  'pricing.upgrade.bullets.aiScriptAdjustment': 'Ajuste de guion con IA',
  'pricing.upgrade.bullets.apiAccess': 'Acceso a la API',
  'pricing.upgrade.bullets.automatedCaptionsSubtitles': 'Subtítulos automáticos',
  'pricing.upgrade.bullets.businessContractAndInvoicing': 'Contrato para empresas y facturación',
  'pricing.upgrade.bullets.customPriceForMinutes': 'Precio personalizado por minuto',
  'pricing.upgrade.bullets.customVoiceCloneLibrary': 'Biblioteca personalizada de Voice Clone',
  'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices':
    'Biblioteca personalizada de Voice Clone (10 voces personalizadas)',
  'pricing.upgrade.bullets.downloadGeneratedVoice': 'Descarga de la voz generada',
  'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound':
    'Descarga de la voz generada con la pista de fondo',
  'pricing.upgrade.bullets.from100MinutesEveryMonth': 'Desde 100 minutos al mes',
  'pricing.upgrade.bullets.from2000MinutesEveryMonth': 'Desde 2000 minutos al mes',
  'pricing.upgrade.bullets.from25MinutesEveryMonth': 'Desde 25 minutos al mes',
  'pricing.upgrade.bullets.from500MinutesEveryMonth': 'Desde 500 minutos al mes',
  'pricing.upgrade.bullets.humanInTheLoop': 'Revisión humana',
  'pricing.upgrade.bullets.multispeakerLipSync': 'Lip-sync para varios hablantes',
  'pricing.upgrade.bullets.noWatermark': 'Sin marca de agua',
  'pricing.upgrade.bullets.personalCustomerManager': 'Gestor de clientes dedicado',
  'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation': 'Traducción simultánea a varios idiomas',
  'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload':
    'Carga de transcripciones SRT y descarga de archivos SRT',
  'pricing.upgrade.bullets.translationDictionaries': 'Diccionarios de traducción',
  'pricing.upgrade.bullets.translationPrompting': 'Instrucciones para la traducción',
  'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers': 'Teamspaces y miembros ilimitados',
  'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones': 'Número ilimitado de Voice Clones personalizadas',
  'pricing.upgrade.bullets.voiceCloneSettings': 'Ajustes de Voice Clone',
  'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark':
    'Añade términos con sus traducciones preferidas (o márcalos para que no se traduzcan)',
  'pricing.upgrade.glossary.applyToAnyProjectWithOneClick': 'Aplícalo a cualquier proyecto con un clic',
  'pricing.upgrade.glossary.createADictionaryForYourLanguagePair': 'Crea un diccionario para tu par de idiomas',
  'pricing.upgrade.glossary.howItWorks': 'Cómo funciona',
  'pricing.upgrade.glossary.howToUseDictionaryEffectively': 'sobre cómo usar el diccionario de forma eficaz',
  'pricing.upgrade.glossary.learnMore': 'Más información',
  'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay':
    'Define cada traducción una sola vez y se mantendrá coherente en todos tus vídeos.',
  'pricing.upgrade.glossary.perfectFor': 'Ideal para',
  'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation':
    'El 83 % de los usuarios de Business confía en la precisión de las traducciones',
  'pricing.upgrade.glossary.unlockTranslationDictionary': 'Desbloquea el diccionario de traducción',
  'pricing.upgrade.glossary.upgradeToBusiness': 'Pásate a Business',
  'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary':
    'Pásate a Business para crear un diccionario de traducción',
  'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr':
    'vídeos con terminología y nombres de producto específicos, o bibliotecas de contenido multilingüe.',
  'pricing.upgrade.lipSync.aboutLipSyncFeature': 'sobre la función de Lip-sync',
  'pricing.upgrade.lipSync.enhancedModel':
    'Nuevo modelo mejorado de Lip-sync: calidad de estudio (descuenta {multiplier} minutos por cada 1 minuto de vídeo)',
  'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync':
    'Todos los rostros en pantalla, perfectamente sincronizados',
  'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther':
    'Consigue contenido profesional con Lip-sync y otras herramientas Pro',
  'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio':
    'Lip-sync ajusta los movimientos de la boca al audio traducido para que el vídeo parezca doblado de forma natural, no superpuesto.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth':
    'Haz que los vídeos doblados parezcan naturales ajustando los movimientos de la boca al audio traducido. Disponible en Creator Pro y planes superiores.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookReal': 'Haz que los vídeos doblados parezcan reales',
  'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage':
    'Vídeos doblados de aspecto natural en cualquier idioma',
  'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters':
    'contenido profesional donde la autenticidad visual es importante.',
  'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility':
    'Publica en cualquier mercado sin perder credibilidad',
  'pricing.upgrade.lipSync.seePlansWithLipSync': 'Ver planes con Lip-sync',
  'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple':
    'Movimientos labiales sincronizados con el audio traducido para varios hablantes',
  'pricing.upgrade.lipSync.unlockLipSyncFeature': 'Desbloquea la función de Lip-sync',
  'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip':
    'Pásate al plan Creator Pro para añadir Lip-sync a tus vídeos y disfrutar de una calidad de traducción excepcional',
  'pricing.upgrade.lipSync.withLipSync': 'Con Lip-sync:',
  'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver':
    'Tu contenido parece nativo, no un doblaje superpuesto',
  'pricing.upgrade.multilanguage.learnMoreCaption':
    '(Más información)[{link}] sobre cómo utilizar esta función eficazmente',
  'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature':
    'Desbloquea la función de traducción a varios idiomas',
  'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer':
    'Tu plan permite traducir a 1 idioma por archivo. Mejora tu plan para traducir el vídeo a varios idiomas',
  'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade':
    'Has alcanzado el límite de vídeos gratuitos. Pásate al plan Business para traducir tus vídeos a varios idiomas',
  'pricing.upgrade.paywallTitles.unlockAudioExportAndMore': 'Desbloquea la exportación de audio y mucho más',
  'pricing.upgrade.paywallTitles.unlockDictionaryAndMore': 'Desbloquea el diccionario y mucho más',
  'pricing.upgrade.paywallTitles.unlockGlossaryAndMore': 'Desbloquea el glosario y mucho más',
  'pricing.upgrade.paywallTitles.unlockLipSyncAndMore': 'Desbloquea Lip-sync y mucho más',
  'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore': 'Desbloquea la traducción a varios idiomas y mucho más',
  'pricing.upgrade.paywallTitles.unlockPromptingAndMore': 'Desbloquea las instrucciones y mucho más',
  'pricing.upgrade.paywallTitles.unlockSrtExportAndMore': 'Desbloquea la exportación SRT y mucho más',
  'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore': 'Desbloquea la carga de SRT y mucho más',
  'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore': 'Desbloquea la exportación de subtítulos y mucho más',
  'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore': 'Desbloquea Teamspaces y mucho más',
  'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore':
    'Desbloquea las instrucciones de traducción y mucho más',
  'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore': 'Desbloquea la duración ilimitada y mucho más',
  'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore': 'Desbloquea los subtítulos de vídeo y mucho más',
  'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore': 'Desbloquea los ajustes de voz y mucho más',
  'pricing.upgrade.srtDownload.aboutSrtDownload': 'sobre la descarga de SRT',
  'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers':
    'Versiones de subtítulos originales y traducidas con los hablantes',
  'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads':
    'creadores que necesitan variantes de subtítulos personalizadas, subir contenido a YouTube o trabajar con herramientas de edición externas.',
  'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize':
    'Obtén archivos de subtítulos flexibles que puedes editar, personalizar y usar en cualquier lugar.',
  'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt':
    'Controla por completo tus subtítulos con SRT y las herramientas Pro',
  'pricing.upgrade.srtDownload.orUpgradeToCreatorPro': 'o pásate a Creator Pro',
  'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken':
    'Archivos de subtítulos en texto plano con códigos de tiempo y texto hablado',
  'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing':
    'Segmentos de texto con formato para plataformas de vídeo o herramientas de edición',
  'pricing.upgrade.srtDownload.unlockSrtDownload': 'Desbloquea la descarga de archivos .SRT',
  'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt':
    'Pásate al plan Creator Pro para descargar archivos SRT con subtítulos tanto del vídeo original como del traducido',
  'pricing.upgrade.srtDownload.whatYouLlGet': 'Qué obtendrás',
  'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile':
    'Descarga el SRT → Envíalo para corregir → Sube el archivo actualizado',
  'pricing.upgrade.srtUpload.howToUseSrtUpload': 'sobre cómo usar la carga de SRT',
  'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo':
    'Actualiza al instante el texto, los tiempos y la información de los hablantes',
  'pricing.upgrade.srtUpload.noManualCopyPaste': 'Sin copiar y pegar manualmente',
  'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick':
    'Sustituye horas de edición manual por un solo clic',
  'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo':
    'equipos que editan subtítulos en otras herramientas y quieren sincronizar los cambios rápidamente.',
  'pricing.upgrade.srtUpload.unlockSrtUpload': 'Desbloquea la carga de SRT',
  'pricing.upgrade.srtUpload.unlockSrtUploadFeature': 'Desbloquea la función de carga de SRT',
  'pricing.upgrade.srtUpload.updateSubtitlesInSeconds': 'Actualiza los subtítulos en segundos',
  'pricing.upgrade.srtUpload.upgradeToCreatorPro': 'Pásate a Creator Pro',
  'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair':
    'Pásate al plan Creator Pro para combinar fácilmente tu vídeo con subtítulos existentes y obtener un doblaje preciso',
  'pricing.upgrade.srtUpload.uploadAnEditedSrtFile': 'Sube un archivo SRT editado',
  'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick': 'Sube la transcripción corregida con un solo clic.',
  'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith':
    'cualquiera que publique en varias plataformas o trabaje en equipo.',
  'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready':
    'Exporta los subtítulos traducidos como un archivo SRT: ya sincronizado, ya traducido y listo para cualquier flujo de trabajo.',
  'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools':
    'Obtén la exportación de subtítulos y otras herramientas Pro',
  'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra':
    'Entrega el contenido a editores o clientes sin pasos adicionales',
  'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn':
    'Publica en YouTube, TikTok o cualquier plataforma en minutos',
  'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport': 'Ver planes con exportación de subtítulos',
  'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens': 'Lleva tus subtítulos allí donde trabajes',
  'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo':
    'Las marcas de tiempo se mantienen perfectamente alineadas con tu vídeo',
  'pricing.upgrade.subtitleExport.withSubtitleExport': 'Con la exportación de subtítulos:',
  'pricing.upgrade.teamspace.aboutTeamspaceCollaboration': 'sobre la colaboración en Teamspace',
  'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout':
    'agencias y equipos que gestionan varios proyectos de doblaje sin caos.',
  'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace': 'Colabora con tu equipo en un solo lugar.',
  'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf':
    'Contacta con nosotros para encontrar el número adecuado de Teamspaces y miembros para tu equipo.',
  'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra':
    'Da a los invitados acceso a todas las funciones sin suscripciones adicionales',
  'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials':
    'Invita a tus compañeros con accesos individuales, sin compartir credenciales',
  'pricing.upgrade.teamspace.lookingToScaleYourTeam': '¿Quieres ampliar tu equipo?',
  'pricing.upgrade.teamspace.orContactUs': 'o contacta con nosotros',
  'pricing.upgrade.teamspace.orUpgradeToBusiness': 'o pásate a Business',
  'pricing.upgrade.teamspace.scaleYourTeam': 'Amplía tu equipo',
  'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60':
    'Los equipos reducen un 60 % el tiempo de coordinación de proyectos',
  'pricing.upgrade.teamspace.unlockTeamspaces': 'Desbloquea Teamspaces',
  'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5':
    'Pásate a Business para obtener un Teamspace con 5 plazas o añade las plazas que necesites.',
  'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith':
    'Pásate a Creator Pro para disponer de un Teamspace con hasta 3 miembros',
  'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember':
    'Pásate a Enterprise para personalizar los Teamspaces y los límites de miembros, o añade las plazas que necesites.',
  'pricing.upgrade.teamspace.workBetterTogether': 'Trabaja mejor en equipo',
  'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd':
    'Trabaja en proyectos compartidos sin interrupciones ni transferencias de archivos constantes',
  'pricing.upgrade.texts.choosePlan': 'Elegir plan',
  'pricing.upgrade.texts.contactUs': 'Contacta con nosotros',
  'pricing.upgrade.texts.everythingInBusinessPlus': 'Todo lo incluido en Business, más:',
  'pricing.upgrade.texts.everythingInCreatorPlus': 'Todo lo incluido en Creator, más:',
  'pricing.upgrade.texts.everythingInCreatorProPlus': 'Todo lo incluido en Creator Pro, más:',
  'pricing.upgrade.texts.everythingInTrialPlus': 'Todo lo incluido en Trial, más:',
  'pricing.upgrade.texts.orChoosePlan': 'o elige un plan',
  'pricing.upgrade.texts.upgradeToBusinessPlan': 'Pásate al plan Business',
  'pricing.upgrade.texts.upgradeToCreatorPlan': 'Pásate al plan Creator',
  'pricing.upgrade.texts.upgradeToCreatorProPlan': 'Pásate al plan Creator Pro',
  'pricing.upgrade.texts.withTheBusinessPlanYouLlGet': 'Con el plan Business obtendrás:',
  'pricing.upgrade.texts.withTheCreatorPlanYouLlGet': 'Con el plan Creator obtendrás:',
  'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet': 'Con el plan Creator Pro obtendrás:',
  'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd':
    'El diccionario guarda los nombres de tu marca, términos de producto y frases clave, y los utiliza de forma coherente en todos los proyectos.',
  'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain':
    'Corrige un término una vez y no vuelvas a corregirlo',
  'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro':
    'Consigue traducciones coherentes con el diccionario y otras herramientas Pro',
  'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross':
    'No tendrás que volver a editar los mismos términos en distintos proyectos',
  'pricing.upgrade.translationDictionary.seePlansWithDictionary': 'Ver planes con diccionario',
  'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand':
    'equipos y creadores con terminología específica o un lenguaje de marca propio.',
  'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect':
    'Traducciones que suenan a ti, no solo traducciones correctas',
  'pricing.upgrade.translationDictionary.withDictionary': 'Con el diccionario:',
  'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage':
    'La voz de tu marca se mantiene coherente en todos los idiomas',
  'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot':
    'Contenido que parece escrito para ese público, no traducido',
  'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther':
    'Controla mejor la traducción con instrucciones y otras herramientas Pro',
  'pricing.upgrade.translationTone.lessEditingAfterEveryDub': 'Menos edición después de cada doblaje',
  'pricing.upgrade.translationTone.seePlansWithPrompting': 'Ver planes con instrucciones',
  'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows':
    'equipos con flujos de adaptación continuos.',
  'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd':
    'Indícanos el tono, el público y el contexto para obtener una traducción adaptada a tu contenido, no solo a las palabras.',
  'pricing.upgrade.translationTone.translationsThatSoundLikeYou': 'Traducciones que suenan a ti',
  'pricing.upgrade.translationTone.withPrompting': 'Con las instrucciones:',
  'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage': 'Tu tono se mantiene en todos los idiomas',
  'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews':
    'cualquier contenido de más de un minuto: tutoriales, entrevistas o cursos.',
  'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview':
    'Dobla el vídeo completo, no solo una vista previa',
  'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd': 'Cada palabra y cada hablante, hasta el final',
  'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools':
    'Obtén doblajes completos y otras herramientas Pro',
  'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit':
    'Sin recortar contenido para cumplir un límite de tiempo',
  'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength': 'Ver planes con duración ilimitada',
  'pricing.upgrade.unlimitedLength.withUnlimitedLength': 'Con la duración ilimitada:',
  'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo':
    'Todo tu vídeo, completamente doblado y listo para publicar',
  'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid':
    'La prueba muestra 1 minuto de vista previa. Con un plan de pago, Rask dobla el archivo completo: sin cortes ni contenido omitido.',
  'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations':
    'marcas y creadores que necesitan traducciones fieles a su identidad sin una edición exhaustiva.',
  'pricing.upgrade.userPrompting.controlYourTranslation': 'Controla tu traducción',
  'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5':
    'Los usuarios de Enterprise confirman las correcciones de traducción hasta 5× más rápido',
  'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology': 'Orienta la elección de palabras y la terminología',
  'pricing.upgrade.userPrompting.howToUsePromptingEffectively': 'sobre cómo usar las instrucciones de forma eficaz',
  'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice':
    'Haz que tus vídeos doblados reflejen la voz de tu marca.',
  'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations':
    'Define el tono, el estilo y el contexto de las traducciones mediante instrucciones. Elige una plantilla o escribe una instrucción propia que se adapte a tus necesidades.',
  'pricing.upgrade.userPrompting.setToneAndFormalityLevel': 'Define el tono y el nivel de formalidad',
  'pricing.upgrade.userPrompting.unlockTranslationPrompting': 'Desbloquea las instrucciones de traducción',
  'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature':
    'Desbloquea la función de instrucciones de traducción',
  'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts':
    'Utiliza plantillas listas para usar o escribe instrucciones personalizadas',
  'pricing.upgrade.videoSubtitles.unlockCaptionsFeature': 'Desbloquea la función de subtítulos',
  'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith':
    'Pásate a Creator Pro para descargar vídeos con subtítulos',
  'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary': 'sobre la biblioteca de Voice Clone',
  'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents': 'Ajusta la expresividad o elimina acentos',
  'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining':
    'Creadores que doblan a varios idiomas y marcas que mantienen la misma voz en todo su contenido.',
  'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro':
    'Mejora tus doblajes con esta y otras herramientas Pro',
  'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery':
    'Haz que tu voz clonada suene exactamente como quieres, siempre.',
  'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects':
    'Reutiliza tus voces clonadas en proyectos ilimitados',
  'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes':
    'Guarda clones de voz personalizados o crea otros desde cero',
  'pricing.upgrade.voicePresets.unlockMoreVoiceClones': 'Desbloquea más Voice Clones',
  'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary': 'Desbloquea la biblioteca de Voice Clone',
  'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10':
    'Pásate a Business para guardar hasta 10 Voice Clones personalizadas',
  'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom':
    'Pásate a Creator Pro para crear una Voice Clone personalizada',
  'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice':
    'Pásate a Enterprise para guardar un número ilimitado de Voice Clones personalizadas',
  'pricing.upgrade.voicePresets.whatYouCanDo': 'Qué puedes hacer',
  'pricing.yearly.buyMinutes': 'Compra minutos adicionales en cualquier momento',
  'pricing.yearly.keepMinutes': 'No se pierden minutos a final de mes',
  'pricing.yearly.only': 'SOLO EN PLANES ANUALES',
  'pricing.yearly.unlimitedEditing': 'Reedición y redoblaje ilimitados',
};

const pt: Record<keyof typeof en, string> = {
  'billing.confirm.amountDue': 'Valor devido hoje',
  'billing.confirm.and': 'e',
  'billing.confirm.boostersTerms': 'os Termos de Uso dos Boosters',
  'billing.confirm.confirm': 'Confirmar',
  'billing.confirm.discountHint': 'O desconto {percent}% aplica-se apenas à primeira fatura.',
  'billing.confirm.havePromo': 'Tem um código promocional?',
  'billing.confirm.hideDetails': 'Ocultar detalhes',
  'billing.confirm.invalidPromo': 'O código promocional é inválido',
  'billing.confirm.monthlyFrom': 'Mensalmente a partir de {date}',
  'billing.confirm.noCharges': 'Nenhuma cobrança futura por Boosters',
  'billing.confirm.noChargesDescription': 'Você não terá nenhum Booster ativo após a confirmação.',
  'billing.confirm.oneTimeHint': 'O pagamento único cobre o uso até o final do ciclo de faturamento.',
  'billing.confirm.paymentMethod': 'Método de pagamento',
  'billing.confirm.perMonth': '/mês',
  'billing.confirm.perYear': '/ano',
  'billing.confirm.privacy': 'a Política de Privacidade',
  'billing.confirm.promoFailed': 'Falha ao aplicar o código promocional',
  'billing.confirm.promoLine': 'Código promocional {code}',
  'billing.confirm.promoPlaceholder': 'Código promocional',
  'billing.confirm.promotionTerms': 'os Termos da promoção',
  'billing.confirm.remove': 'remover',
  'billing.confirm.removeItem': 'Remover {item}',
  'billing.confirm.renews': 'Renovação automática até o cancelamento',
  'billing.confirm.subscribe': 'Assine com obrigação de pagar',
  'billing.confirm.taxHint': 'O total inclui impostos com base nas suas informações de faturamento.',
  'billing.confirm.terms': 'os Termos de Serviço',
  'billing.confirm.termsIntro': 'Ao confirmar, você concorda com os seguintes documentos da Rask AI:',
  'billing.confirm.updatePayment': 'Atualize a forma de pagamento',
  'billing.confirm.vat': 'IVA {percent}',
  'billing.confirm.viewDetails': 'Ver detalhes',
  'billing.confirm.yearlyFrom': 'Anualmente a partir de {date}',
  'billing.error.authentication':
    'Falha na autenticação do pagamento. Não foi possível confirmar o pagamento com seu banco.',
  'billing.error.bankDeclined': 'O pagamento foi recusado pelo seu banco. O banco não aprovou esta transação.',
  'billing.error.cardCannotBeUsed': 'Este cartão não pode ser usado',
  'billing.error.cardDetails':
    'Os dados do cartão estão incorretos. Verifique o número do seu cartão, a data de validade e o código de segurança.',
  'billing.error.changePayment': 'Altere sua forma de pagamento',
  'billing.error.editPayment': 'Editar forma de pagamento',
  'billing.error.failed': 'Falha no pagamento',
  'billing.error.insufficient':
    'Falha no pagamento — fundos insuficientes ou limite atingido. Seu banco recusou o pagamento devido ao saldo baixo ou ao limite de gastos.',
  'billing.error.retryPayment': 'Tente novamente ou altere a forma de pagamento',
  'billing.result.canClose': 'Você pode fechar este modal a qualquer momento.',
  'billing.result.closeWindow': 'Fechar modal',
  'billing.result.processing': 'Estamos processando seu pedido',
  'billing.result.processingDescription':
    'Isso pode levar alguns minutos. Continuaremos processando seu pedido em segundo plano e ativaremos sua assinatura automaticamente assim que o processamento for concluído.',
  'billing.result.success': 'Pagamento processado com sucesso',
  'billing.result.viewInvoice': 'Ver fatura',
  'bookDemo.booked': 'Sua demonstração está agendada!',
  'bookDemo.bookedFor': 'Sua demonstração está agendada para {slot}',
  'bookDemo.coverDescription':
    'seu caso de uso de adaptação e a melhor maneira de executá-lo no Rask, como funciona em sua equipe e uma estrutura de preços clara.',
  'bookDemo.coverTitle': 'O que abordaremos:',
  'bookDemo.inviteSent': 'Um convite com o link da reunião foi enviado para seu e-mail.',
  'bookDemo.seeYou': 'Até breve',
  'bookDemo.subtitle':
    'Discutiremos seu fluxo de trabalho, mostraremos recursos ocultos e escolheremos o melhor plano para suas necessidades.',
  'bookDemo.timeBenefit': 'Uma demonstração de 30 minutos economiza cerca de 5 horas na descoberta do produto.',
  'bookDemo.title': 'Agende uma demonstração com nosso especialista',
  'pricing.actions.contactUs': 'Contate-nos',
  'pricing.actions.downgrade': 'Mudar para um plano inferior',
  'pricing.actions.getStarted': 'Comece',
  'pricing.actions.renew': 'Renovar',
  'pricing.actions.switchAnnual': 'Mudar para anual',
  'pricing.actions.switchMonthly': 'Mudar para mensal',
  'pricing.actions.upgrade': 'Fazer upgrade',
  'pricing.archived.description': 'No momento, você está em um plano {plan} arquivado com {count} minutos inclusos.',
  'pricing.archived.hint': 'Continue usando-o ou mude para o novo plano.',
  'pricing.billing.annual': 'Anual',
  'pricing.billing.aria': 'Período de cobrança',
  'pricing.billing.billAnnual': 'Faturar anualmente',
  'pricing.billing.billedAnnually': 'Faturado anualmente',
  'pricing.billing.monthly': 'Mensal',
  'pricing.billing.payAnnual': 'Pagar anualmente',
  'pricing.booster.addForMonth': 'Adicionar por {price} por mês',
  'pricing.buyMinutes.benefitRemain':
    'Os minutos não utilizados permanecerão na sua conta mesmo se você pausar a assinatura',
  'pricing.buyMinutes.benefitRollOver': 'Transferiremos seus minutos não utilizados para o próximo mês',
  'pricing.buyMinutes.checkout': 'Finalizar compra',
  'pricing.buyMinutes.minutes': 'Minutos',
  'pricing.buyMinutes.newPricingDescription':
    'Confira nossos novos preços com pacotes flexíveis de minutos e novos recursos!',
  'pricing.buyMinutes.newPricingTitle': 'Acabamos de lançar novos preços!',
  'pricing.buyMinutes.payLess': 'Pagar menos',
  'pricing.buyMinutes.payOnly': 'Pague apenas {price} por minuto!',
  'pricing.buyMinutes.perMinute': '{price}/min',
  'pricing.buyMinutes.price': 'Preço',
  'pricing.buyMinutes.title': 'Comprar minutos adicionais',
  'pricing.buyMinutes.upgradeDescription': 'Faça upgrade do seu plano e pague menos pelos minutos adicionais',
  'pricing.cancelDowngrade.button': 'Cancelar downgrade',
  'pricing.cancelDowngrade.currentDescription':
    'Você está no plano {plan} por {price}, com cobrança {interval}, ativo até {date}.',
  'pricing.cancelDowngrade.currentTitle': 'Plano atual',
  'pricing.cancelDowngrade.hint': 'Você pode programar o downgrade novamente quando quiser.',
  'pricing.cancelDowngrade.scheduledDescription':
    'A mudança para o plano {plan} por {price}, com cobrança {interval}, está programada para {date}. Se você cancelar a mudança, sua assinatura atual do {currentPlan} continuará.',
  'pricing.cancelDowngrade.scheduledTitle': 'Plano programado',
  'pricing.cancelDowngrade.success': 'Mudança de assinatura cancelada. Seu plano {plan} permanecerá ativo.',
  'pricing.change.activeUntil': 'Seu plano atual permanece ativo até {date}.',
  'pricing.change.boosterDescription':
    'O Booster de envio e download de SRT agora está incluído no seu plano sem custo extra. Iremos removê-lo dos seus Boosters automaticamente.',
  'pricing.change.boosterIncluded': 'Booster incluído!',
  'pricing.change.changeSuccess': 'A alteração do seu plano foi processada',
  'pricing.change.current': 'Plano atual',
  'pricing.change.currentDescription': 'Você está no plano {plan}, com cobrança {interval}, ativo até {date}.',
  'pricing.change.downgradeDescription':
    'Você está mudando para o plano {plan}, com cobrança {interval}. A alteração entrará em vigor no final do seu período de faturamento atual.',
  'pricing.change.downgradeError': 'Falha ao mudar para um plano inferior:',
  'pricing.change.downgradeSuccess': 'A mudança para um plano inferior foi agendada',
  'pricing.change.featuresLost': 'Recursos que você perde',
  'pricing.change.monthly': 'mensal',
  'pricing.change.new': 'Novo plano',
  'pricing.change.scheduleDowngrade': 'Agendar mudança para um plano inferior',
  'pricing.change.switchBack': 'Você poderá voltar ao plano anterior a partir de {date}.',
  'pricing.change.upgradeDescription':
    'Você está mudando para o plano {plan}, com cobrança {interval}. Você receberá imediatamente novos recursos e mais {count} min (a diferença entre os planos).',
  'pricing.change.upgradeError': 'Falha ao fazer upgrade do plano:',
  'pricing.change.upgradeNow': 'Fazer upgrade agora',
  'pricing.change.upgradePaidSuccess': 'Pagamento processado com sucesso; upgrade da assinatura concluído',
  'pricing.change.upgradeSuccess': 'Upgrade do plano concluído',
  'pricing.change.yearly': 'anual',
  'pricing.compare.credits': 'Créditos e gerações',
  'pricing.compare.editor': 'Editor',
  'pricing.compare.extraMinutes': 'Minutos extras',
  'pricing.compare.minutesIncluded': 'Minutos inclusos',
  'pricing.compare.plans': 'Comparar planos',
  'pricing.compare.row.api': 'API e integrações',
  'pricing.compare.row.apiDescription':
    'Conecte o Rask às suas ferramentas existentes e automatize seu fluxo de trabalho.',
  'pricing.compare.row.autoCut': 'Corte automático com IA',
  'pricing.compare.row.autoCutDescription':
    'Remova automaticamente palavras de preenchimento e silêncios das gravações.',
  'pricing.compare.row.autoZoom': 'Zoom automático',
  'pricing.compare.row.autoZoomDescription': 'Dê zoom automaticamente na ação enquanto você grava.',
  'pricing.compare.row.controls': 'Controles de roteiro, legenda e voz',
  'pricing.compare.row.controlsDescription':
    'Edite diretamente a transcrição, as marcações de tempo, a identificação dos locutores e as configurações de voz.',
  'pricing.compare.row.extraDescription': 'Você pode comprar minutos adicionais a qualquer momento nos planos anuais.',
  'pricing.compare.row.glossary': 'Glossário e terminologia',
  'pricing.compare.row.glossaryDescription':
    'Salve termos personalizados para que as mesmas palavras sejam sempre traduzidas de forma consistente.',
  'pricing.compare.row.lipSync': 'Lip-sync para vários locutores',
  'pricing.compare.row.lipSyncDescription':
    'Combina os movimentos da boca com o áudio traduzido para uma dublagem com aparência mais natural.',
  'pricing.compare.row.minutes': 'Minutos de adaptação inclusos por ano',
  'pricing.compare.row.minutesDescription':
    'Os minutos anuais disponíveis para tradução ou dublagem. Os planos Business anuais disponibilizam todos os minutos no início.',
  'pricing.compare.row.minutesTitle': 'Minutos de adaptação inclusos por ano',
  'pricing.compare.row.multiLanguage': 'Fluxo de trabalho multilíngue',
  'pricing.compare.row.multiLanguageDescription': 'Traduza um único vídeo para vários idiomas em um único projeto.',
  'pricing.compare.row.prompting': 'Instruções de tradução',
  'pricing.compare.row.promptingDescription':
    'Adicione instruções antes de traduzir para definir o contexto: tom, formalidade e texto.',
  'pricing.compare.row.review': 'Fluxo de revisão',
  'pricing.compare.row.reviewDescription':
    'Envie o conteúdo traduzido aos revisores para aprovação antes de ser publicado.',
  'pricing.compare.row.screenRecorder': 'Gravador de tela com IA',
  'pricing.compare.row.screenRecorderDescription': 'Grave sua tela e sua câmera diretamente no Rask.',
  'pricing.compare.row.security': 'Segurança e compras',
  'pricing.compare.row.securityDescription': 'Suporte para contratos, faturamento e documentação de conformidade.',
  'pricing.compare.row.speed': 'Velocidade de processamento',
  'pricing.compare.row.speedDescription': 'A rapidez com que seus vídeos são processados e renderizados.',
  'pricing.compare.row.srt': 'Importação/exportação SRT',
  'pricing.compare.row.srtDescription':
    'Baixe arquivos de legenda ou carregue os seus próprios para sincronizar com a dublagem.',
  'pricing.compare.row.srtTitle': 'Importação/exportação SRT',
  'pricing.compare.row.team': 'Espaço de trabalho da equipe',
  'pricing.compare.row.teamDescription':
    'Convide colegas de equipe para colaborar em projetos em um espaço compartilhado.',
  'pricing.compare.row.voices': 'Vozes personalizadas salvas',
  'pricing.compare.row.voicesDescription': 'Salve vozes clonadas para poder reutilizá-las em projetos futuros.',
  'pricing.compare.showAll': 'Veja todos os recursos',
  'pricing.compare.showLess': 'Mostrar menos',
  'pricing.compare.subtitle': 'Escolha o plano que corresponde à frequência com que você publica.',
  'pricing.compare.support': 'Suporte e trabalho em equipe',
  'pricing.compare.title': 'Compare o que muda à medida que você cresce',
  'pricing.compare.value.compliance': 'SSO, DPA, revisão de conformidade',
  'pricing.compare.value.customBatch': 'Pipelines em lote personalizados',
  'pricing.compare.value.customIntegrations': 'Integrações personalizadas',
  'pricing.compare.value.customRoles': 'Funções personalizadas',
  'pricing.compare.value.dedicated': 'Dedicado/prioritário',
  'pricing.compare.value.extraMinute': 'US$ 3/minuto extra',
  'pricing.compare.value.fiveMembers': 'Até 5 membros + revisores convidados',
  'pricing.compare.value.fullApi': 'Acesso completo à API',
  'pricing.compare.value.included': 'Incluído',
  'pricing.compare.value.managedQa': 'Controle de qualidade gerenciado/aprovação por especialista no assunto',
  'pricing.compare.value.managedTerms': 'Fluxo de trabalho de terminologia gerenciado',
  'pricing.compare.value.multiBatch': 'Processamento em lote de vários vídeos e idiomas',
  'pricing.compare.value.personalGlossary': 'Glossário pessoal',
  'pricing.compare.value.priorityQueue': 'Fila prioritária',
  'pricing.compare.value.reviewer': 'Funções e aprovação do revisor',
  'pricing.compare.value.sandboxApi': 'API limitada/sandbox',
  'pricing.compare.value.sharedGlossary': 'Glossário de marca compartilhado',
  'pricing.compare.value.sharedVoices': '10 vozes compartilhadas pela equipe',
  'pricing.compare.value.standard': 'Padrão',
  'pricing.compare.value.standardQueue': 'Fila padrão',
  'pricing.compare.value.three': '3',
  'pricing.compare.value.threeMembers': 'Até 3 membros',
  'pricing.compare.value.unlimited': 'Ilimitado',
  'pricing.compare.value.upgradePro': 'Fazer upgrade para o Pro',
  'pricing.compare.value.voiceLibrary': 'Biblioteca de vozes personalizadas',
  'pricing.compare.whatChanges': 'O que muda',
  'pricing.enterprisePayment.contactSupport': 'Entre em contato pelo chat de suporte ou envie um e-mail para',
  'pricing.enterprisePayment.unknownError': 'Erro desconhecido',
  'pricing.feature.aiRewriter': 'Ajuste de script de IA',
  'pricing.feature.allBusiness': 'Todos os recursos do Business, mais:',
  'pricing.feature.allCreator': 'Todos os recursos do Creator, mais:',
  'pricing.feature.allCreatorPro': 'Todos os recursos do Creator Pro, mais:',
  'pricing.feature.api': 'API',
  'pricing.feature.applyChanges': 'Aplique alterações gratuitamente',
  'pricing.feature.businessContract': 'Contrato comercial e faturamento',
  'pricing.feature.captions': 'Legendas automáticas',
  'pricing.feature.customerSuccess': 'Gerente de sucesso do cliente',
  'pricing.feature.dictionary': 'Dicionário de tradução',
  'pricing.feature.editor': 'Editor de vídeo avançado',
  'pricing.feature.flexibleMinutes': 'Preços flexíveis de minutos',
  'pricing.feature.humanReview': 'Revisão humana',
  'pricing.feature.languages': 'Traduções em mais de 135 idiomas',
  'pricing.feature.languagesDescription':
    'A disponibilidade de idiomas depende do uso de vozes de IA ou do Voice Clone.',
  'pricing.feature.learnMore': 'Saiba mais',
  'pricing.feature.lipSync': 'Lip-sync para vários locutores',
  'pricing.feature.machineTranslation': 'Tradução automática',
  'pricing.feature.multiLanguage': 'Tradução simultânea em vários idiomas',
  'pricing.feature.noWatermark': 'Sem marca d’água',
  'pricing.feature.onlyVideoDownload': 'Apenas download de vídeo',
  'pricing.feature.priority': 'Processamento prioritário',
  'pricing.feature.prompting': 'Instruções de tradução',
  'pricing.feature.readDocs': 'Leia a documentação',
  'pricing.feature.speechToText': 'Transcrição automática de fala para texto',
  'pricing.feature.srtDownload': 'Baixar SRT',
  'pricing.feature.srtDownloadUpload': 'Baixar e enviar SRT',
  'pricing.feature.srtUpload': 'Carregar SRT',
  'pricing.feature.support': 'Suporte 24 horas por dia, 7 dias por semana',
  'pricing.feature.teamspace3': '1 Teamspace, 3 membros',
  'pricing.feature.teamspace5': '1 Teamspace, 5 membros',
  'pricing.feature.teamspaces': 'Teamspaces',
  'pricing.feature.voiceClones10': '10 clones de voz personalizados',
  'pricing.feature.voiceClones3': '3 clones de voz personalizados',
  'pricing.feature.voiceCloning': 'Clonagem de voz em 32 idiomas',
  'pricing.feature.voiceCloningDescription':
    'Disponível em 32 idiomas, incluindo inglês, espanhol, francês, italiano, português e russo.',
  'pricing.feature.voiceLibrary': 'Biblioteca de clones de voz',
  'pricing.feature.voiceSettings': 'Configurações de clone de voz',
  'pricing.feature.watermark': "Marca-d'água",
  "pricing.featurePaywall.controlDownload.formats": "Qualquer formato, a qualquer momento",
  "pricing.featurePaywall.controlDownload.fullVideo": "Exporte o vídeo completo, não apenas a prévia",
  "pricing.featurePaywall.controlDownload.share": "Compartilhar grátis",
  "pricing.featurePaywall.controlDownload.subtitle": "Faça upgrade para baixar vídeos sem marca-d'água e ter downloads ilimitados ou compartilhe grátis",
  "pricing.featurePaywall.controlDownload.title": "Desbloqueie a exportação do vídeo completo ou compartilhe grátis",
  "pricing.featurePaywall.controlDownload.unlock": "Desbloquear exportação",
  "pricing.featurePaywall.controlDownload.watermark": "Remova a marca-d’água",
  'pricing.header.description':
    'Cada plano inclui tradução de vídeo para qualquer idioma, clonagem de voz que preserva emoções e controles gratuitos e fáceis de usar.',
  'pricing.header.title': 'Planos que acompanham seu volume de vídeos',
  'pricing.legacy.businessFeature1': 'Garanta a consistência da voz da marca',
  'pricing.legacy.businessFeature2': 'Controle a terminologia nas traduções',
  'pricing.legacy.businessFeature3': 'Processe volumes mais rápido do que nunca',
  'pricing.legacy.creatorFeature1': 'Duble em mais de 135 idiomas com IA',
  'pricing.legacy.creatorFeature2': 'Clone vozes em 32 idiomas',
  'pricing.legacy.creatorFeature3': 'Editor poderoso e ilimitado',
  'pricing.legacy.creatorFeature4': 'Transcrição e tradução automáticas',
  'pricing.legacy.creatorProFeature1': 'Adicione Lip-sync e legendas',
  'pricing.legacy.creatorProFeature2': 'Use ferramentas de voz e script de nível profissional',
  'pricing.legacy.creatorProFeature3': 'Trabalhe junto em um espaço compartilhado',
  'pricing.legacy.enterpriseFeature1': 'Obtenha contratos e faturamento personalizados',
  'pricing.legacy.enterpriseFeature2': 'Acesse suporte prioritário dedicado',
  'pricing.legacy.enterpriseFeature3': 'Personalize tudo para atender às suas necessidades',
  'pricing.legacy.everythingBusiness': 'Tudo incluído no Business, além de:',
  'pricing.legacy.everythingCreator': 'Tudo incluído no Creator, além de:',
  'pricing.legacy.everythingCreatorPro': 'Tudo incluído no Creator Pro, além de:',
  'pricing.limits.enterprise.contactOrSelectPlan':
    'Entre em contato com nossa especialista em parcerias pelo e-mail {email} ou escolha um de nossos planos.',
  'pricing.limits.enterprise.notEnoughMinutes': 'Você não tem minutos suficientes para traduzir este vídeo.',
  'pricing.limits.enterprise.notEnoughMinutesShort': 'Não há minutos suficientes para traduzir este vídeo.',
  'pricing.limits.enterprise.purchaseMore':
    'Entre em contato com nossa especialista em parcerias para comprar mais minutos: {email}',
  'pricing.limits.enterprise.ranOut': 'Os minutos do seu plano acabaram.',
  'pricing.limits.enterprise.renewAccess':
    'Entre em contato com nossa especialista em parcerias pelo e-mail {email} para renovar seu acesso.',
  'pricing.limits.enterprise.renewOrSelectPlan':
    'Entre em contato com nossa especialista em parcerias pelo e-mail {email} para renovar seu acesso ou escolher um de nossos planos.',
  'pricing.limits.exploreFullVersion': 'Explore a versão completa com recursos avançados',
  'pricing.limits.feature.lipSyncBeta': 'Aplique o recurso de Lip-sync (beta)',
  'pricing.limits.feature.noTrialLimits': 'Envie arquivos sem os limites do teste grátis',
  'pricing.limits.feature.proofread': 'Revise o texto antes da dublagem',
  'pricing.limits.feature.srtUpload': 'Envie um arquivo SRT junto com o vídeo',
  'pricing.limits.feature.translation130': 'Traduza para mais de 135 idiomas',
  'pricing.limits.feature.voiceClone28': 'Use o Voice Clone em 32 idiomas',
  'pricing.limits.freeVideoLimit': 'Você atingiu o limite de vídeos gratuitos.',
  'pricing.limits.notEnoughMinutes': 'Não há minutos disponíveis suficientes para traduzir o vídeo.',
  'pricing.limits.paymentFailed':
    'Não foi possível processar o pagamento da renovação. Atualize os dados de pagamento para continuar usando o Rask.',
  'pricing.limits.renewSubscription': 'Renovar assinatura',
  'pricing.limits.spaceUnsupported':
    'Seu plano atual não oferece suporte a este espaço. Faça upgrade para continuar usando-o.',
  'pricing.limits.subscriptionCanceled': 'Sua assinatura foi cancelada.',
  'pricing.limits.subscriptionCanceledDescription':
    'Congelamos os minutos da sua conta. Renove a assinatura para continuar usando o Rask e gastar seus minutos.',
  'pricing.limits.subscriptionExpired': 'Sua assinatura expirou. Renove-a para continuar usando o Rask.',
  'pricing.limits.subscriptionPaused':
    'Sua assinatura está pausada e congelamos os minutos da sua conta. Renove-a para continuar usando o Rask e gastar seus minutos.',
  'pricing.limits.translationMinuteLimit': 'Você atingiu o limite de minutos de tradução.',
  'pricing.limits.unlockFullVersion': 'Desbloquear versão completa',
  'pricing.limits.updatePayment': 'Atualizar dados de pagamento',
  'pricing.limits.upgradeForMoreVideos': 'Faça upgrade para traduzir mais vídeos',
  'pricing.limits.upgradeForMoreVideosTitle': 'Faça upgrade para traduzir mais vídeos:',
  'pricing.limits.upgradePlanForMoreVideos': 'Faça upgrade do plano para traduzir mais vídeos',
  'pricing.limits.upgradeToContinue': 'Faça upgrade para continuar gerando conteúdo.',
  'pricing.limits.whiteLabelInactive':
    'Sua assinatura não está mais ativa. Entre em contato com {email} para obter ajuda.',
  'pricing.limits.whiteLabelOutOfMinutes': 'Seus minutos acabaram. Recarregue o saldo de minutos.',
  'pricing.minutes.custom': 'Minutos personalizados',
  'pricing.minutes.from': 'a partir de {count} minutos',
  'pricing.minutes.fromMonthly': 'A partir de {count} minutos/mês',
  'pricing.minutes.included': '{count} minutos inclusos',
  'pricing.modal.closeAria': 'Fechar',
  'pricing.notActive.checkBoosters': 'Ver outros Boosters',
  'pricing.notActive.closeAria': 'Fechar oferta de convite para a equipe',
  'pricing.notActive.paidDescription':
    'Adicione mais membros à sua assinatura e colabore sem complicações no espaço compartilhado!',
  'pricing.notActive.title': 'Juntos, somos melhores. Convide sua equipe!',
  'pricing.notActive.trialDescription':
    'Crie espaços de trabalho dedicados, convide colaboradores e gerencie projetos em conjunto nos Teamspaces.',
  'pricing.notActive.trialPaywallTitle': 'Libere o potencial da sua equipe',
  'pricing.notActive.unlockTeamspaces': 'Desbloqueie os Teamspaces com o Creator Pro',
  'pricing.pause.chargeDescription': 'Em {date}, será cobrada a tarifa {interval} original de {price}.',
  'pricing.pause.description':
    'A reativação está programada para {date}. Os dados da sua conta ficarão seguros até a assinatura ser retomada.',
  'pricing.pause.nextBillingDate': 'sua próxima data de cobrança',
  'pricing.pause.resumeNow': 'Retomar assinatura agora',
  'pricing.pause.resumeTitle': 'Quer retomar?',
  'pricing.pause.success': 'Assinatura retomada.\nA cobrança será feita na próxima data de renovação.',
  'pricing.pause.title': 'Sua assinatura está pausada',
  'pricing.paywall.enterpriseQuestion': 'Traduz mais de 1.000 minutos por mês?',
  'pricing.paywall.feature.api': 'Acesso à API',
  'pricing.paywall.feature.customVoiceClone': 'Personalize a clonagem de voz e salve-a na sua biblioteca',
  'pricing.paywall.feature.dictionary': 'Salve traduções personalizadas no Dicionário',
  'pricing.paywall.feature.lipSync': 'Aplicar Lip-sync',
  'pricing.paywall.feature.srtDownload': 'Baixe um arquivo de legendas SRT',
  'pricing.paywall.feature.srtUpload': 'Envie um arquivo SRT com seu vídeo',
  'pricing.paywall.feature.subtitles': 'Adicione legendas ao seu vídeo',
  'pricing.paywall.feature.teamspacesSoon': 'Crie Teamspaces e colabore com sua equipe',
  'pricing.paywall.feature.translation130': 'Traduza seus vídeos e áudios para mais de 135 idiomas',
  'pricing.paywall.feature.voiceClone29': 'Clonagem de voz em 32 idiomas',
  'pricing.paywall.queueTitle': 'A fila para usuários gratuitos está sobrecarregada no momento',
  'pricing.paywall.requestEnterpriseDemo': 'Solicitar uma demonstração do Enterprise',
  'pricing.paywall.upgradeTitle': 'Faça upgrade para ter acesso completo!',
  'pricing.paywall.viewPlans': 'Ver planos',
  'pricing.plan.bestForBeginners': 'Ideal para iniciantes',
  'pricing.plan.bestForIndividuals': 'Ideal para pessoas',
  'pricing.plan.bestValue': 'Melhor custo-benefício',
  'pricing.plan.business': 'Business',
  'pricing.plan.businessDescription': 'Para equipes com uma videoteca crescente',
  'pricing.plan.businessFeature1': 'Revise e gerencie projetos com sua equipe',
  'pricing.plan.businessFeature2': 'Mantenha a marca e a terminologia consistentes',
  'pricing.plan.businessFeature3': 'Envie e traduza lotes de vídeos',
  'pricing.plan.creator': 'Creator',
  'pricing.plan.creatorDescription': 'Para criadores que trabalham em projetos menores',
  'pricing.plan.creatorFeature1': 'Comece sem precisar configurar nada',
  'pricing.plan.creatorFeature2': 'Traduza um único vídeo para vários idiomas',
  'pricing.plan.creatorFeature3': 'Faça upgrade se precisar de adaptar conteúdos regularmente',
  'pricing.plan.creatorPro': 'Creator Pro',
  'pricing.plan.creatorProDescription': 'Para publicar vídeos com frequência',
  'pricing.plan.creatorProFeature1': 'Controle a tradução e a precisão da fala',
  'pricing.plan.creatorProFeature2': 'Preserve a identidade de quem fala com Lip-sync',
  'pricing.plan.creatorProFeature3': 'Criado para projetos recorrentes com uma equipe pequena',
  'pricing.plan.current': 'Plano atual',
  'pricing.plan.currentOutsideGrid': 'Seu plano atual: {plan}, {price}',
  'pricing.plan.currentShort': 'Atual',
  'pricing.plan.enterprise': 'Enterprise',
  'pricing.plan.enterpriseDescription': 'Para operações em escala global que exigem confiança e previsibilidade',
  'pricing.plan.enterpriseFeature1': 'Prontidão em segurança e conformidade',
  'pricing.plan.enterpriseFeature2': 'Confiabilidade em produção e SLA',
  'pricing.plan.enterpriseFeature3': 'Integrações personalizadas e API',
  'pricing.plan.enterpriseFeature4': 'Garantia de qualidade gerenciada',
  'pricing.plan.limitedOffer': 'Oferta por tempo limitado',
  'pricing.plan.mostPopular': 'Mais popular',
  'pricing.plan.starter': 'Starter',
  'pricing.plan.starterDescription': 'Para começar com uma adaptação simples de vídeos',
  'pricing.plan.tailoredOnboarding': 'Integração personalizada e SLA',
  'pricing.plan.toggleDetails': 'Alternar detalhes do plano',
  'pricing.plan.unlimitedRecording': 'Gravação de tela ilimitada',
  'pricing.price.billedMonthly': 'faturado mensalmente',
  'pricing.price.billedYearly': 'faturado {amount} anualmente',
  'pricing.price.custom': 'Personalizado',
  'pricing.price.from': 'a partir de',
  'pricing.price.perMonth': '/mês',
  'pricing.price.perMonthLong': 'por mês',
  'pricing.renew.happy': 'Que bom ter você aqui novamente!',
  'pricing.renew.welcome': 'Que bom ter você de volta!',
  'pricing.savings.year': 'Economize {amount}/ano ({percent}% de desconto)',
  'pricing.socialProof': 'Mais de {count} usuários satisfeitos',
  'pricing.starter.allCreator': 'Todos os recursos do plano Creator',
  'pricing.starter.currentTitle': 'Plano {plan}: {price} por mês',
  'pricing.starter.minuteDescription':
    '1 minuto = 1 minuto de conteúdo traduzido. Por exemplo, traduzir um vídeo de 1 minuto para dois idiomas usa 2 minutos.',
  'pricing.starter.minuteTitle': 'O que significa um minuto?',
  'pricing.starter.tryTitle': 'Experimente por {price} ao mês com o plano {plan}',
  'pricing.starter.watermarkDescription':
    'O vídeo terá a marca-d’água “Translated by Rask AI” no canto superior direito.',
  'pricing.title': 'Preços',
  'pricing.trial.continue': 'Continuar com o teste grátis',
  'pricing.upgrade.aiRewrite.unlockAiRewriteFeature': 'Desbloqueie o recurso de reescrita com IA',
  'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl':
    'Faça upgrade para o plano Creator Pro para controlar a velocidade e alinhar segmentos com IA às suas marcações de tempo',
  'pricing.upgrade.audioDownload.unlockAudioDownload': 'Desbloqueie o download de áudio',
  'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated':
    'Faça upgrade para o Creator para baixar o áudio com a voz gerada ou com a voz e a trilha de fundo',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members': '1 Teamspace com até 10 membros',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members': '1 Teamspace com até 5 membros',
  'pricing.upgrade.bullets.aiScriptAdjustment': 'Ajuste de roteiro com IA',
  'pricing.upgrade.bullets.apiAccess': 'Acesso à API',
  'pricing.upgrade.bullets.automatedCaptionsSubtitles': 'Legendas automáticas',
  'pricing.upgrade.bullets.businessContractAndInvoicing': 'Contrato empresarial e faturamento',
  'pricing.upgrade.bullets.customPriceForMinutes': 'Preço personalizado por minuto',
  'pricing.upgrade.bullets.customVoiceCloneLibrary': 'Biblioteca personalizada de Voice Clone',
  'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices':
    'Biblioteca personalizada de Voice Clone (10 vozes personalizadas)',
  'pricing.upgrade.bullets.downloadGeneratedVoice': 'Download da voz gerada',
  'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound': 'Download da voz gerada com a trilha de fundo',
  'pricing.upgrade.bullets.from100MinutesEveryMonth': 'A partir de 100 minutos por mês',
  'pricing.upgrade.bullets.from2000MinutesEveryMonth': 'A partir de 2000 minutos por mês',
  'pricing.upgrade.bullets.from25MinutesEveryMonth': 'A partir de 25 minutos por mês',
  'pricing.upgrade.bullets.from500MinutesEveryMonth': 'A partir de 500 minutos por mês',
  'pricing.upgrade.bullets.humanInTheLoop': 'Revisão humana',
  'pricing.upgrade.bullets.multispeakerLipSync': 'Lip-sync para vários locutores',
  'pricing.upgrade.bullets.noWatermark': "Sem marca-d'água",
  'pricing.upgrade.bullets.personalCustomerManager': 'Gerente de Sucesso do Cliente dedicado',
  'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation': 'Tradução simultânea para vários idiomas',
  'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload': 'Upload de transcrição SRT e download de SRT',
  'pricing.upgrade.bullets.translationDictionaries': 'Dicionários de tradução',
  'pricing.upgrade.bullets.translationPrompting': 'Instruções para tradução',
  'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers': 'Teamspaces e membros ilimitados',
  'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones': 'Quantidade ilimitada de Voice Clones personalizadas',
  'pricing.upgrade.bullets.voiceCloneSettings': 'Configurações de Voice Clone',
  'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark':
    'Adicione termos com as traduções desejadas (ou marque-os para não serem traduzidos)',
  'pricing.upgrade.glossary.applyToAnyProjectWithOneClick': 'Aplique a qualquer projeto com um clique',
  'pricing.upgrade.glossary.createADictionaryForYourLanguagePair': 'Crie um dicionário para o seu par de idiomas',
  'pricing.upgrade.glossary.howItWorks': 'Como funciona',
  'pricing.upgrade.glossary.howToUseDictionaryEffectively': 'sobre como usar o dicionário de forma eficaz',
  'pricing.upgrade.glossary.learnMore': 'Saiba mais',
  'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay':
    'Defina as traduções uma vez e elas permanecerão consistentes em todos os vídeos.',
  'pricing.upgrade.glossary.perfectFor': 'Ideal para',
  'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation':
    '83% dos usuários do Business confiam na precisão das traduções',
  'pricing.upgrade.glossary.unlockTranslationDictionary': 'Desbloqueie o dicionário de tradução',
  'pricing.upgrade.glossary.upgradeToBusiness': 'Faça upgrade para o Business',
  'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary':
    'Faça upgrade para o Business para criar um dicionário de tradução',
  'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr':
    'vídeos com terminologia e nomes de produtos específicos ou bibliotecas de conteúdo multilíngue.',
  'pricing.upgrade.lipSync.aboutLipSyncFeature': 'sobre o recurso de Lip-sync',
  'pricing.upgrade.lipSync.enhancedModel':
    'Novo modelo aprimorado de Lip-sync: qualidade de estúdio (desconta {multiplier} minutos por 1 minuto de vídeo)',
  'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync': 'Todos os rostos na tela, perfeitamente sincronizados',
  'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther':
    'Crie conteúdo profissional com Lip-sync e outras ferramentas Pro',
  'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio':
    'O Lip-sync sincroniza os movimentos da boca com o áudio traduzido para que o vídeo pareça dublado de forma natural, e não sobreposto.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth':
    'Faça os vídeos dublados parecerem naturais sincronizando os movimentos da boca com o áudio traduzido. Disponível no Creator Pro e em planos superiores.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookReal': 'Faça os vídeos dublados parecerem reais',
  'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage':
    'Vídeos dublados com aparência natural em qualquer idioma',
  'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters':
    'conteúdo profissional em que a autenticidade visual é essencial.',
  'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility':
    'Publique em qualquer mercado sem perder credibilidade',
  'pricing.upgrade.lipSync.seePlansWithLipSync': 'Ver planos com Lip-sync',
  'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple':
    'Movimentos labiais sincronizados com o áudio traduzido para vários locutores',
  'pricing.upgrade.lipSync.unlockLipSyncFeature': 'Desbloqueie o recurso de Lip-sync',
  'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip':
    'Faça upgrade para o plano Creator Pro para adicionar Lip-sync aos seus vídeos e obter traduções com qualidade excepcional',
  'pricing.upgrade.lipSync.withLipSync': 'Com Lip-sync:',
  'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver':
    'Seu conteúdo parece nativo, não uma dublagem sobreposta',
  'pricing.upgrade.multilanguage.learnMoreCaption': '(Saiba mais)[{link}] sobre como usar este recurso de forma eficaz',
  'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature':
    'Desbloqueie o recurso de tradução para vários idiomas',
  'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer':
    'Seu plano permite traduzir para 1 idioma por upload. Faça upgrade para traduzir o vídeo para vários idiomas',
  'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade':
    'Você atingiu o limite de vídeos gratuitos. Faça upgrade para o plano Business para traduzir seus vídeos para vários idiomas',
  'pricing.upgrade.paywallTitles.unlockAudioExportAndMore': 'Desbloqueie a exportação de áudio e muito mais',
  'pricing.upgrade.paywallTitles.unlockDictionaryAndMore': 'Desbloqueie o dicionário e muito mais',
  'pricing.upgrade.paywallTitles.unlockGlossaryAndMore': 'Desbloqueie o glossário e muito mais',
  'pricing.upgrade.paywallTitles.unlockLipSyncAndMore': 'Desbloqueie o Lip-sync e muito mais',
  'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore': 'Desbloqueie a tradução para vários idiomas e muito mais',
  'pricing.upgrade.paywallTitles.unlockPromptingAndMore': 'Desbloqueie as instruções e muito mais',
  'pricing.upgrade.paywallTitles.unlockSrtExportAndMore': 'Desbloqueie a exportação de SRT e muito mais',
  'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore': 'Desbloqueie o upload de SRT e muito mais',
  'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore': 'Desbloqueie a exportação de legendas e muito mais',
  'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore': 'Desbloqueie Teamspaces e muito mais',
  'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore':
    'Desbloqueie as instruções de tradução e muito mais',
  'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore': 'Desbloqueie a duração ilimitada e muito mais',
  'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore': 'Desbloqueie as legendas no vídeo e muito mais',
  'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore': 'Desbloqueie as predefinições de voz e muito mais',
  'pricing.upgrade.srtDownload.aboutSrtDownload': 'sobre o download de SRT',
  'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers':
    'Versões originais e traduzidas das legendas com identificação dos locutores',
  'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads':
    'criadores que precisam de variações personalizadas de legendas, uploads no YouTube ou fluxos de edição externos.',
  'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize':
    'Tenha arquivos de legenda flexíveis para editar, personalizar e usar onde quiser.',
  'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt':
    'Tenha controle total das suas legendas com SRT e ferramentas Pro',
  'pricing.upgrade.srtDownload.orUpgradeToCreatorPro': 'ou faça upgrade para o Creator Pro',
  'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken':
    'Arquivos de legenda em texto simples com marcações de tempo e texto falado',
  'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing':
    'Segmentos de texto formatados para plataformas de vídeo ou ferramentas de edição',
  'pricing.upgrade.srtDownload.unlockSrtDownload': 'Desbloqueie o download de arquivos .SRT',
  'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt':
    'Faça upgrade para o plano Creator Pro para baixar arquivos SRT com legendas dos vídeos original e traduzido',
  'pricing.upgrade.srtDownload.whatYouLlGet': 'O que você terá',
  'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile':
    'Baixe o SRT → Envie para correção → Faça upload do arquivo atualizado',
  'pricing.upgrade.srtUpload.howToUseSrtUpload': 'sobre como usar o upload de SRT',
  'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo':
    'Atualize instantaneamente texto, tempo e informações dos locutores',
  'pricing.upgrade.srtUpload.noManualCopyPaste': 'Sem copiar e colar manualmente',
  'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick': 'Substitua horas de edição manual por um clique',
  'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo':
    'equipes que editam legendas externamente e querem sincronizar as alterações com rapidez.',
  'pricing.upgrade.srtUpload.unlockSrtUpload': 'Desbloqueie o upload de SRT',
  'pricing.upgrade.srtUpload.unlockSrtUploadFeature': 'Desbloqueie o recurso de upload de SRT',
  'pricing.upgrade.srtUpload.updateSubtitlesInSeconds': 'Atualize as legendas em segundos',
  'pricing.upgrade.srtUpload.upgradeToCreatorPro': 'Faça upgrade para o Creator Pro',
  'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair':
    'Faça upgrade para o plano Creator Pro para combinar facilmente o vídeo com legendas existentes e obter uma dublagem precisa',
  'pricing.upgrade.srtUpload.uploadAnEditedSrtFile': 'Faça upload de um arquivo SRT editado',
  'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick':
    'Faça upload da transcrição corrigida com um clique.',
  'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith':
    'quem publica em várias plataformas ou trabalha em equipe.',
  'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready':
    'Exporte as legendas traduzidas como um arquivo SRT: já sincronizado, já traduzido e pronto para qualquer fluxo de trabalho.',
  'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools':
    'Tenha exportação de legendas e outras ferramentas Pro',
  'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra':
    'Entregue aos editores ou clientes sem etapas extras',
  'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn':
    'Publique no YouTube, TikTok ou em qualquer plataforma em poucos minutos',
  'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport': 'Ver planos com exportação de legendas',
  'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens':
    'Leve suas legendas para onde o trabalho acontece',
  'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo':
    'As marcações de tempo permanecem perfeitamente alinhadas ao vídeo',
  'pricing.upgrade.subtitleExport.withSubtitleExport': 'Com a exportação de legendas:',
  'pricing.upgrade.teamspace.aboutTeamspaceCollaboration': 'sobre a colaboração no Teamspace',
  'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout':
    'agências e equipes que gerenciam vários projetos de dublagem sem confusão.',
  'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace': 'Colabore com sua equipe em um só lugar.',
  'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf':
    'Fale conosco para encontrar a quantidade ideal de Teamspaces e membros para sua equipe.',
  'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra':
    'Dê aos convidados acesso a todos os recursos sem assinaturas adicionais',
  'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials':
    'Convide colegas com logins individuais, sem compartilhar credenciais',
  'pricing.upgrade.teamspace.lookingToScaleYourTeam': 'Quer expandir sua equipe?',
  'pricing.upgrade.teamspace.orContactUs': 'ou fale conosco',
  'pricing.upgrade.teamspace.orUpgradeToBusiness': 'ou faça upgrade para o Business',
  'pricing.upgrade.teamspace.scaleYourTeam': 'Expanda sua equipe',
  'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60':
    'As equipes reduzem em 60% o tempo de coordenação dos projetos',
  'pricing.upgrade.teamspace.unlockTeamspaces': 'Desbloqueie Teamspaces',
  'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5':
    'Faça upgrade para o Business e tenha um Teamspace com 5 licenças ou adicione as licenças necessárias.',
  'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith':
    'Faça upgrade para o Creator Pro e tenha um Teamspace com até 3 membros',
  'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember':
    'Faça upgrade para o Enterprise e personalize os Teamspaces e limites de membros ou adicione as licenças necessárias.',
  'pricing.upgrade.teamspace.workBetterTogether': 'Trabalhem melhor juntos',
  'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd':
    'Trabalhe em projetos compartilhados sem complicações nem troca constante de arquivos',
  'pricing.upgrade.texts.choosePlan': 'Escolher plano',
  'pricing.upgrade.texts.contactUs': 'Fale conosco',
  'pricing.upgrade.texts.everythingInBusinessPlus': 'Tudo do Business, mais:',
  'pricing.upgrade.texts.everythingInCreatorPlus': 'Tudo do Creator, mais:',
  'pricing.upgrade.texts.everythingInCreatorProPlus': 'Tudo do Creator Pro, mais:',
  'pricing.upgrade.texts.everythingInTrialPlus': 'Tudo do Trial, mais:',
  'pricing.upgrade.texts.orChoosePlan': 'ou escolha um plano',
  'pricing.upgrade.texts.upgradeToBusinessPlan': 'Faça upgrade para o plano Business',
  'pricing.upgrade.texts.upgradeToCreatorPlan': 'Faça upgrade para o plano Creator',
  'pricing.upgrade.texts.upgradeToCreatorProPlan': 'Faça upgrade para o plano Creator Pro',
  'pricing.upgrade.texts.withTheBusinessPlanYouLlGet': 'Com o plano Business, você terá:',
  'pricing.upgrade.texts.withTheCreatorPlanYouLlGet': 'Com o plano Creator, você terá:',
  'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet': 'Com o plano Creator Pro, você terá:',
  'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd':
    'O dicionário salva nomes da marca, termos de produtos e frases importantes e os usa de forma consistente em todos os projetos.',
  'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain':
    'Corrija um termo uma vez e não precise corrigi-lo novamente',
  'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro':
    'Tenha traduções consistentes com o dicionário e outras ferramentas Pro',
  'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross':
    'Chega de reeditar os mesmos termos em projetos diferentes',
  'pricing.upgrade.translationDictionary.seePlansWithDictionary': 'Ver planos com dicionário',
  'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand':
    'equipes e criadores com terminologia específica ou linguagem própria da marca.',
  'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect':
    'Traduções que soam como você, não apenas corretas',
  'pricing.upgrade.translationDictionary.withDictionary': 'Com o dicionário:',
  'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage':
    'A voz da sua marca permanece consistente em todos os idiomas',
  'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot':
    'Conteúdo que parece escrito para esse público, e não traduzido',
  'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther':
    'Controle melhor as traduções com instruções e outras ferramentas Pro',
  'pricing.upgrade.translationTone.lessEditingAfterEveryDub': 'Menos edição depois de cada dublagem',
  'pricing.upgrade.translationTone.seePlansWithPrompting': 'Ver planos com instruções',
  'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows': 'equipes com fluxos contínuos de adaptação.',
  'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd':
    'Informe o tom, o público e o contexto para receber uma tradução que combine com seu conteúdo, não apenas com as palavras.',
  'pricing.upgrade.translationTone.translationsThatSoundLikeYou': 'Traduções que soam como você',
  'pricing.upgrade.translationTone.withPrompting': 'Com as instruções:',
  'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage': 'Seu tom é preservado em todos os idiomas',
  'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews':
    'qualquer conteúdo com mais de um minuto: tutoriais, entrevistas ou cursos.',
  'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview': 'Duble o vídeo inteiro, não apenas uma prévia',
  'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd': 'Cada palavra e cada locutor, até o fim',
  'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools':
    'Tenha dublagem completa e outras ferramentas Pro',
  'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit':
    'Nenhum conteúdo cortado para caber em um limite de tempo',
  'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength': 'Ver planos com duração ilimitada',
  'pricing.upgrade.unlimitedLength.withUnlimitedLength': 'Com a duração ilimitada:',
  'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo':
    'Seu vídeo inteiro, totalmente dublado e pronto para publicar',
  'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid':
    'O Trial mostra uma prévia de 1 minuto. Em um plano pago, a Rask dubla o arquivo inteiro: nada cortado, nada faltando.',
  'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations':
    'marcas e criadores que precisam de traduções alinhadas à marca sem muita edição.',
  'pricing.upgrade.userPrompting.controlYourTranslation': 'Controle sua tradução',
  'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5':
    'Usuários do Enterprise confirmam ajustes de tradução até 5× mais rápido',
  'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology': 'Oriente a escolha de palavras e a terminologia',
  'pricing.upgrade.userPrompting.howToUsePromptingEffectively': 'sobre como usar as instruções de forma eficaz',
  'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice':
    'Faça seus vídeos dublados refletirem a voz da sua marca.',
  'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations':
    'Defina o tom, o estilo e o contexto das traduções com instruções. Escolha um dos nossos modelos ou escreva sua própria instrução de acordo com suas necessidades.',
  'pricing.upgrade.userPrompting.setToneAndFormalityLevel': 'Defina o tom e o nível de formalidade',
  'pricing.upgrade.userPrompting.unlockTranslationPrompting': 'Desbloqueie as instruções de tradução',
  'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature': 'Desbloqueie o recurso de instruções de tradução',
  'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts':
    'Use modelos prontos ou escreva instruções personalizadas',
  'pricing.upgrade.videoSubtitles.unlockCaptionsFeature': 'Desbloqueie o recurso de legendas',
  'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith':
    'Faça upgrade para o Creator Pro para baixar vídeos com legendas',
  'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary': 'sobre a biblioteca de Voice Clone',
  'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents': 'Ajuste a expressividade ou remova sotaques',
  'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining':
    'Criadores que dublam em vários idiomas e marcas que mantêm a mesma voz em todo o conteúdo.',
  'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro':
    'Eleve o nível das dublagens com esta e outras ferramentas Pro',
  'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery':
    'Faça sua voz clonada soar exatamente como você deseja, sempre.',
  'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects':
    'Reutilize suas vozes clonadas em projetos ilimitados',
  'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes':
    'Salve clones de voz personalizados ou crie novos do zero',
  'pricing.upgrade.voicePresets.unlockMoreVoiceClones': 'Desbloqueie mais Voice Clones',
  'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary': 'Desbloqueie a biblioteca de Voice Clone',
  'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10':
    'Faça upgrade para o Business para salvar até 10 Voice Clones personalizadas',
  'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom':
    'Faça upgrade para o Creator Pro para criar uma Voice Clone personalizada',
  'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice':
    'Faça upgrade para o Enterprise para salvar uma quantidade ilimitada de Voice Clones personalizadas',
  'pricing.upgrade.voicePresets.whatYouCanDo': 'O que você pode fazer',
  'pricing.yearly.buyMinutes': 'Compre minutos adicionais a qualquer momento',
  'pricing.yearly.keepMinutes': 'Nenhum minuto perdido no final do mês',
  'pricing.yearly.only': 'SOMENTE PLANOS ANUAIS',
  'pricing.yearly.unlimitedEditing': 'Reedição e redublagem ilimitadas',
};

const fr: Record<keyof typeof en, string> = {
  'billing.confirm.amountDue': "Montant dû aujourd'hui",
  'billing.confirm.and': 'et',
  'billing.confirm.boostersTerms': "Conditions d'utilisation des Boosters",
  'billing.confirm.confirm': 'Confirmer',
  'billing.confirm.discountHint': "La remise de {percent} % s'applique uniquement à la première facture.",
  'billing.confirm.havePromo': 'Vous avez un code promo ?',
  'billing.confirm.hideDetails': 'Masquer les détails',
  'billing.confirm.invalidPromo': "Le code promo n'est pas valide",
  'billing.confirm.monthlyFrom': 'Tous les mois à partir du {date}',
  'billing.confirm.noCharges': 'Aucuns frais à venir pour les Boosters',
  'billing.confirm.noChargesDescription': "Vous n'aurez plus de Boosters actifs après confirmation.",
  'billing.confirm.oneTimeHint': "Le paiement unique couvre l'utilisation jusqu'à la fin du cycle de facturation.",
  'billing.confirm.paymentMethod': 'Mode de paiement',
  'billing.confirm.perMonth': '/mois',
  'billing.confirm.perYear': '/an',
  'billing.confirm.privacy': 'Politique de confidentialité',
  'billing.confirm.promoFailed': "Échec de l'application du code promotionnel",
  'billing.confirm.promoLine': 'Code promotionnel {code}',
  'billing.confirm.promoPlaceholder': 'Code promotionnel',
  'billing.confirm.promotionTerms': 'Conditions de promotion',
  'billing.confirm.remove': 'supprimer',
  'billing.confirm.removeItem': 'Supprimer : {item}',
  'billing.confirm.renews': "Se renouvelle automatiquement jusqu'à annulation",
  'billing.confirm.subscribe': 'S’abonner avec obligation de paiement',
  'billing.confirm.taxHint': 'Le total inclut les taxes calculées en fonction de vos informations de facturation.',
  'billing.confirm.terms': "Conditions d'utilisation",
  'billing.confirm.termsIntro': 'En confirmant, vous acceptez les documents suivants de Rask AI :',
  'billing.confirm.updatePayment': 'Veuillez mettre à jour le mode de paiement',
  'billing.confirm.vat': 'TVA {percent}',
  'billing.confirm.viewDetails': 'Afficher les détails',
  'billing.confirm.yearlyFrom': 'Tous les ans à partir du {date}',
  'billing.error.authentication':
    "L'authentification du paiement a échoué. Nous n'avons pas pu confirmer le paiement auprès de votre banque.",
  'billing.error.bankDeclined':
    "Le paiement a été refusé par votre banque. La banque n'a pas approuvé cette transaction.",
  'billing.error.cardCannotBeUsed': 'Cette carte ne peut pas être utilisée',
  'billing.error.cardDetails':
    "Les détails de la carte sont incorrects. Veuillez vérifier votre numéro de carte, la date d'expiration et le code de sécurité.",
  'billing.error.changePayment': 'Changez votre mode de paiement',
  'billing.error.editPayment': 'Modifier le mode de paiement',
  'billing.error.failed': 'Échec du paiement',
  'billing.error.insufficient':
    "Échec du paiement : fonds insuffisants ou limite atteinte. Votre banque a refusé le paiement en raison d'un solde faible ou d'une limite de dépenses.",
  'billing.error.retryPayment': 'Réessayez ou changez de mode de paiement',
  'billing.result.canClose': 'Vous pouvez fermer cette fenêtre modale à tout moment.',
  'billing.result.closeWindow': 'Fermer la fenêtre',
  'billing.result.processing': 'Nous traitons votre commande',
  'billing.result.processingDescription':
    'Cela peut prendre quelques minutes. Nous continuerons à le traiter en arrière-plan et activerons votre abonnement automatiquement une fois terminé.',
  'billing.result.success': 'Paiement traité avec succès',
  'billing.result.viewInvoice': 'Afficher la facture',
  'bookDemo.booked': 'Votre démo est réservée !',
  'bookDemo.bookedFor': 'Votre démo est réservée pour {slot}',
  'bookDemo.coverDescription':
    'vos besoins d’adaptation, la meilleure façon d’y répondre avec Rask, l’intégration de Rask à votre flux de travail et une structure tarifaire claire.',
  'bookDemo.coverTitle': 'Ce que nous couvrirons :',
  'bookDemo.inviteSent': 'Une invitation avec le lien de la réunion a été envoyée à votre adresse e-mail.',
  'bookDemo.seeYou': 'À bientôt',
  'bookDemo.subtitle':
    'Nous discuterons de votre flux de travail, vous présenterons les fonctionnalités cachées et choisirons le forfait le mieux adapté à vos besoins.',
  'bookDemo.timeBenefit': 'Une démo de 30 minutes vous fait gagner environ 5 heures de découverte du produit.',
  'bookDemo.title': 'Réservez une démo avec notre spécialiste',
  'pricing.actions.contactUs': 'Contactez-nous',
  'pricing.actions.downgrade': 'Passer à une offre inférieure',
  'pricing.actions.getStarted': 'Commencer',
  'pricing.actions.renew': 'Renouveler',
  'pricing.actions.switchAnnual': "Passer à l'annuel",
  'pricing.actions.switchMonthly': 'Passer au mensuel',
  'pricing.actions.upgrade': 'Passer à une offre supérieure',
  'pricing.archived.description':
    "Vous bénéficiez actuellement d'un forfait {plan} archivé avec {count} minutes incluses.",
  'pricing.archived.hint': 'Continuez à l’utiliser ou passez au nouveau plan.',
  'pricing.billing.annual': 'Annuel',
  'pricing.billing.aria': 'Période de facturation',
  'pricing.billing.billAnnual': 'Facturer annuellement',
  'pricing.billing.billedAnnually': 'Facturé annuellement',
  'pricing.billing.monthly': 'Mensuel',
  'pricing.billing.payAnnual': 'Paiement annuel',
  'pricing.booster.addForMonth': 'Ajouter pour {price} par mois',
  'pricing.buyMinutes.benefitRemain':
    "Les minutes inutilisées resteront sur votre compte même si vous suspendez l'abonnement",
  'pricing.buyMinutes.benefitRollOver': 'Nous reporterons vos minutes inutilisées au mois suivant',
  'pricing.buyMinutes.checkout': 'Passer au paiement',
  'pricing.buyMinutes.minutes': 'Minutes',
  'pricing.buyMinutes.newPricingDescription':
    'Découvrez nos nouveaux tarifs, avec des forfaits de minutes flexibles et de nouvelles fonctionnalités !',
  'pricing.buyMinutes.newPricingTitle': 'Nous venons de lancer de nouveaux tarifs !',
  'pricing.buyMinutes.payLess': 'Payer moins',
  'pricing.buyMinutes.payOnly': 'Payez seulement {price} par minute !',
  'pricing.buyMinutes.perMinute': '{price}/min',
  'pricing.buyMinutes.price': 'Prix',
  'pricing.buyMinutes.title': 'Acheter des minutes supplémentaires',
  'pricing.buyMinutes.upgradeDescription':
    'Passez au forfait supérieur et payez moins pour les minutes supplémentaires',
  'pricing.cancelDowngrade.button': 'Annuler le passage au forfait inférieur',
  'pricing.cancelDowngrade.currentDescription':
    "Vous utilisez actuellement le forfait {plan} à {price}, facturé {interval} et actif jusqu'au {date}.",
  'pricing.cancelDowngrade.currentTitle': 'Forfait actuel',
  'pricing.cancelDowngrade.hint': 'Vous pourrez reprogrammer ce changement à tout moment.',
  'pricing.cancelDowngrade.scheduledDescription':
    'Vous passerez au forfait {plan} à {price}, facturé {interval}, à partir du {date}. Si vous annulez ce changement, votre abonnement {currentPlan} actuel continuera.',
  'pricing.cancelDowngrade.scheduledTitle': 'Forfait programmé',
  'pricing.cancelDowngrade.success': "Changement d'abonnement annulé. Votre forfait {plan} restera actif.",
  'pricing.change.activeUntil': "Votre forfait actuel reste actif jusqu'au {date}.",
  'pricing.change.boosterDescription':
    'L’import et le téléchargement SRT sont désormais inclus dans votre forfait sans frais supplémentaires. Nous supprimerons automatiquement ce Booster de votre abonnement.',
  'pricing.change.boosterIncluded': 'Booster inclus !',
  'pricing.change.changeSuccess': 'Votre changement de forfait a été traité',
  'pricing.change.current': 'Forfait actuel',
  'pricing.change.currentDescription':
    "Vous utilisez actuellement le forfait {plan}, facturé {interval} et actif jusqu'au {date}.",
  'pricing.change.downgradeDescription':
    'Vous passez au forfait {plan}, facturé {interval}. Le changement prendra effet à la fin de votre période de facturation en cours.',
  'pricing.change.downgradeError': 'Échec du passage à une offre inférieure :',
  'pricing.change.downgradeSuccess': 'Votre passage à une offre inférieure a été programmé',
  'pricing.change.featuresLost': 'Fonctionnalités que vous perdez',
  'pricing.change.monthly': 'mensuellement',
  'pricing.change.new': 'Nouveau forfait',
  'pricing.change.scheduleDowngrade': 'Programmer le passage à une offre inférieure',
  'pricing.change.switchBack': 'Vous pouvez revenir à votre forfait précédent à partir du {date}.',
  'pricing.change.upgradeDescription':
    'Vous passez au forfait {plan}, facturé {interval}. Vous bénéficierez immédiatement de nouvelles fonctionnalités et de {count} minutes supplémentaires (la différence entre les forfaits).',
  'pricing.change.upgradeError': 'Échec du passage au forfait supérieur :',
  'pricing.change.upgradeNow': 'Passer au forfait supérieur',
  'pricing.change.upgradePaidSuccess': 'Paiement traité avec succès, votre abonnement est passé au forfait supérieur',
  'pricing.change.upgradeSuccess': 'Votre forfait a été mis à jour',
  'pricing.change.yearly': 'annuellement',
  'pricing.compare.credits': 'Crédits et générations',
  'pricing.compare.editor': 'Éditeur',
  'pricing.compare.extraMinutes': 'Minutes supplémentaires',
  'pricing.compare.minutesIncluded': 'Minutes incluses',
  'pricing.compare.plans': 'Comparez les forfaits',
  'pricing.compare.row.api': 'API et intégrations',
  'pricing.compare.row.apiDescription': 'Connectez Rask à vos outils existants et automatisez votre flux de travail.',
  'pricing.compare.row.autoCut': 'Découpe automatique par IA',
  'pricing.compare.row.autoCutDescription':
    'Supprimez automatiquement les mots parasites et les silences de vos enregistrements.',
  'pricing.compare.row.autoZoom': 'Zoom auto',
  'pricing.compare.row.autoZoomDescription': 'Zoomez automatiquement sur l’action pendant l’enregistrement.',
  'pricing.compare.row.controls': 'Script, sous-titres et réglages vocaux',
  'pricing.compare.row.controlsDescription':
    'Modifiez directement la transcription, les horodatages, les étiquettes des locuteurs et les paramètres vocaux.',
  'pricing.compare.row.extraDescription':
    'Vous pouvez acheter des minutes supplémentaires à tout moment avec les forfaits annuels.',
  'pricing.compare.row.glossary': 'Glossaire et terminologie',
  'pricing.compare.row.glossaryDescription':
    'Enregistrez les termes personnalisés afin que les mêmes mots soient traduits de manière cohérente à chaque fois.',
  'pricing.compare.row.lipSync': 'Lip-sync pour plusieurs locuteurs',
  'pricing.compare.row.lipSyncDescription':
    "Fait correspondre les mouvements de la bouche à l'audio traduit pour un doublage plus naturel.",
  'pricing.compare.row.minutes': 'Minutes d’adaptation incluses / an',
  'pricing.compare.row.minutesDescription':
    'Les minutes annuelles disponibles pour la traduction ou le doublage. Les forfaits Business annuels donnent accès à toutes les minutes dès le départ.',
  'pricing.compare.row.minutesTitle': 'Minutes d’adaptation incluses par an',
  'pricing.compare.row.multiLanguage': 'Flux de travail multilingue',
  'pricing.compare.row.multiLanguageDescription': 'Traduisez une seule vidéo en plusieurs langues dans un seul projet.',
  'pricing.compare.row.prompting': 'Instructions de traduction',
  'pricing.compare.row.promptingDescription':
    'Ajoutez des instructions avant de traduire pour définir le contexte : ton, formalité et formulation.',
  'pricing.compare.row.review': 'Processus de validation',
  'pricing.compare.row.reviewDescription':
    'Envoyez le contenu traduit à des relecteurs pour validation avant sa publication.',
  'pricing.compare.row.screenRecorder': 'Enregistreur d’écran IA',
  'pricing.compare.row.screenRecorderDescription': 'Enregistrez votre écran et votre webcam directement dans Rask.',
  'pricing.compare.row.security': 'Sécurité et approvisionnement',
  'pricing.compare.row.securityDescription':
    'Prise en charge des contrats, de la facturation et de la documentation de conformité.',
  'pricing.compare.row.speed': 'Vitesse de traitement',
  'pricing.compare.row.speedDescription': 'La rapidité avec laquelle vos vidéos sont traitées et rendues.',
  'pricing.compare.row.srt': 'Importation/exportation SRT',
  'pricing.compare.row.srtDescription':
    'Téléchargez les fichiers de sous-titres ou importez les vôtres pour les synchroniser avec le doublage.',
  'pricing.compare.row.srtTitle': 'Importation/exportation SRT',
  'pricing.compare.row.team': "Espace de travail d'équipe",
  'pricing.compare.row.teamDescription': 'Invitez vos coéquipiers à collaborer sur des projets dans un espace partagé.',
  'pricing.compare.row.voices': 'Voix personnalisées enregistrées',
  'pricing.compare.row.voicesDescription':
    'Enregistrez les voix clonées afin de pouvoir les réutiliser dans de futurs projets.',
  'pricing.compare.showAll': 'Voir toutes les fonctionnalités',
  'pricing.compare.showLess': 'Afficher moins',
  'pricing.compare.subtitle': 'Choisissez le forfait qui correspond à la fréquence à laquelle vous publiez.',
  'pricing.compare.support': "Accompagnement et travail d'équipe",
  'pricing.compare.title': 'Comparez ce qui change à mesure que votre activité se développe',
  'pricing.compare.value.compliance': 'SSO, DPA, vérification de la conformité',
  'pricing.compare.value.customBatch': 'Pipelines par lots personnalisés',
  'pricing.compare.value.customIntegrations': 'Intégrations personnalisées',
  'pricing.compare.value.customRoles': 'Rôles personnalisés',
  'pricing.compare.value.dedicated': 'Dédié / prioritaire',
  'pricing.compare.value.extraMinute': '3 $ / minute supplémentaire',
  'pricing.compare.value.fiveMembers': 'Jusqu’à 5 membres + relecteurs invités',
  'pricing.compare.value.fullApi': "Accès complet à l'API",
  'pricing.compare.value.included': 'Inclus',
  'pricing.compare.value.managedQa': 'Contrôle qualité géré / validation par un expert métier',
  'pricing.compare.value.managedTerms': 'Flux de travail terminologique géré',
  'pricing.compare.value.multiBatch': 'Lot multi-vidéo × multilingue',
  'pricing.compare.value.personalGlossary': 'Glossaire personnel',
  'pricing.compare.value.priorityQueue': "File d'attente prioritaire",
  'pricing.compare.value.reviewer': 'Rôles de relecteur et validation',
  'pricing.compare.value.sandboxApi': 'API limitée/bac à sable',
  'pricing.compare.value.sharedGlossary': 'Glossaire de marque partagé',
  'pricing.compare.value.sharedVoices': "10 voix d'équipe partagées",
  'pricing.compare.value.standard': 'Standard',
  'pricing.compare.value.standardQueue': "File d'attente standard",
  'pricing.compare.value.three': '3',
  'pricing.compare.value.threeMembers': "Jusqu'à 3 membres",
  'pricing.compare.value.unlimited': 'Illimité',
  'pricing.compare.value.upgradePro': 'Passer à Pro',
  'pricing.compare.value.voiceLibrary': 'Bibliothèque vocale personnalisée',
  'pricing.compare.whatChanges': 'Ce qui change',
  'pricing.enterprisePayment.contactSupport': "Contactez l'assistance par chat ou écrivez-nous à",
  'pricing.enterprisePayment.unknownError': 'Erreur inconnue',
  'pricing.feature.aiRewriter': 'Ajustement du script IA',
  'pricing.feature.allBusiness': 'Toutes les fonctionnalités Business, plus :',
  'pricing.feature.allCreator': 'Toutes les fonctionnalités de Creator, plus :',
  'pricing.feature.allCreatorPro': 'Toutes les fonctionnalités de Creator Pro, plus :',
  'pricing.feature.api': 'API',
  'pricing.feature.applyChanges': 'Appliquer les modifications gratuitement',
  'pricing.feature.businessContract': 'Contrat commercial et facturation',
  'pricing.feature.captions': 'Sous-titres automatiques',
  'pricing.feature.customerSuccess': 'Responsable de la réussite client',
  'pricing.feature.dictionary': 'Dictionnaire de traduction',
  'pricing.feature.editor': 'Éditeur vidéo avancé',
  'pricing.feature.flexibleMinutes': 'Tarification des minutes flexibles',
  'pricing.feature.humanReview': 'Validation humaine',
  'pricing.feature.languages': 'Traductions dans plus de 135 langues',
  'pricing.feature.languagesDescription':
    "La disponibilité des langues dépend de l'utilisation des voix IA ou de Voice Clone.",
  'pricing.feature.learnMore': 'En savoir plus',
  'pricing.feature.lipSync': 'Lip-sync pour plusieurs locuteurs',
  'pricing.feature.machineTranslation': 'Traduction automatique',
  'pricing.feature.multiLanguage': 'Traduction multilingue simultanée',
  'pricing.feature.noWatermark': 'Pas de filigrane',
  'pricing.feature.onlyVideoDownload': 'Téléchargement de la vidéo uniquement',
  'pricing.feature.priority': 'Traitement prioritaire',
  'pricing.feature.prompting': 'Instructions de traduction',
  'pricing.feature.readDocs': 'Lire la documentation',
  'pricing.feature.speechToText': 'Transcription automatique de la parole en texte',
  'pricing.feature.srtDownload': 'Téléchargement SRT',
  'pricing.feature.srtDownloadUpload': 'Téléchargement et import SRT',
  'pricing.feature.srtUpload': 'Import SRT',
  'pricing.feature.support': 'Assistance 24h/24 et 7j/7',
  'pricing.feature.teamspace3': '1 Teamspace, 3 membres',
  'pricing.feature.teamspace5': '1 Teamspace, 5 membres',
  'pricing.feature.teamspaces': 'Teamspaces',
  'pricing.feature.voiceClones10': '10 clones de voix personnalisés',
  'pricing.feature.voiceClones3': '3 clones de voix personnalisés',
  'pricing.feature.voiceCloning': 'Clonage vocal en 32 langues',
  'pricing.feature.voiceCloningDescription':
    "Disponible dans 32 langues, dont l'anglais, l'espagnol, le français, l'italien, le portugais et le russe.",
  'pricing.feature.voiceLibrary': 'Bibliothèque de clonage vocal',
  'pricing.feature.voiceSettings': 'Paramètres de clonage vocal',
  'pricing.feature.watermark': 'Filigrane',
  "pricing.featurePaywall.controlDownload.formats": "Tous les formats, à tout moment",
  "pricing.featurePaywall.controlDownload.fullVideo": "Exportez la vidéo entière, pas seulement l’aperçu",
  "pricing.featurePaywall.controlDownload.share": "Partager gratuitement",
  "pricing.featurePaywall.controlDownload.subtitle": "Passez à une offre supérieure pour télécharger la vidéo sans filigrane et profiter de téléchargements illimités, ou partagez-la gratuitement",
  "pricing.featurePaywall.controlDownload.title": "Débloquez l’exportation de la vidéo complète ou partagez-la gratuitement",
  "pricing.featurePaywall.controlDownload.unlock": "Débloquer l’exportation",
  "pricing.featurePaywall.controlDownload.watermark": "Supprimez le filigrane",
  'pricing.header.description':
    "Chaque plan comprend la traduction vidéo dans n'importe quelle langue, le clonage vocal préservant les émotions et des commandes gratuites et faciles à utiliser.",
  'pricing.header.title': 'Des forfaits qui évoluent avec votre production vidéo',
  'pricing.legacy.businessFeature1': 'Préservez la cohérence de la voix de votre marque',
  'pricing.legacy.businessFeature2': 'Maîtrisez la terminologie des traductions',
  'pricing.legacy.businessFeature3': 'Traitez les volumes plus rapidement que jamais',
  'pricing.legacy.creatorFeature1': "Doublez dans plus de 135 langues avec l'IA",
  'pricing.legacy.creatorFeature2': 'Clonez des voix en 32 langues',
  'pricing.legacy.creatorFeature3': 'Éditeur puissant à utilisation illimitée',
  'pricing.legacy.creatorFeature4': 'Transcription et traduction automatiques',
  'pricing.legacy.creatorProFeature1': 'Ajoutez le Lip-sync et des sous-titres',
  'pricing.legacy.creatorProFeature2': 'Utilisez des outils vocaux et de script de niveau professionnel',
  'pricing.legacy.creatorProFeature3': 'Travaillez ensemble dans un espace partagé',
  'pricing.legacy.enterpriseFeature1': 'Obtenez des contrats et une facturation personnalisés',
  'pricing.legacy.enterpriseFeature2': 'Accédez à un support prioritaire dédié',
  'pricing.legacy.enterpriseFeature3': 'Adaptez tout à vos besoins',
  'pricing.legacy.everythingBusiness': 'Tout ce qui est inclus dans Business, plus :',
  'pricing.legacy.everythingCreator': 'Tout ce qui est inclus dans Creator, plus :',
  'pricing.legacy.everythingCreatorPro': 'Tout ce qui est inclus dans Creator Pro, plus :',
  'pricing.limits.enterprise.contactOrSelectPlan':
    "Contactez notre spécialiste des partenariats à {email} ou choisissez l'un de nos forfaits.",
  'pricing.limits.enterprise.notEnoughMinutes': "Vous n'avez pas assez de minutes pour traduire cette vidéo.",
  'pricing.limits.enterprise.notEnoughMinutesShort': 'Pas assez de minutes pour traduire cette vidéo.',
  'pricing.limits.enterprise.purchaseMore':
    'Contactez notre spécialiste des partenariats pour acheter plus de minutes : {email}',
  'pricing.limits.enterprise.ranOut': "Votre forfait n'a plus de minutes.",
  'pricing.limits.enterprise.renewAccess':
    'Contactez notre spécialiste des partenariats à {email} pour renouveler votre accès.',
  'pricing.limits.enterprise.renewOrSelectPlan':
    "Contactez notre spécialiste des partenariats à {email} pour renouveler votre accès ou choisir l'un de nos forfaits.",
  'pricing.limits.exploreFullVersion': 'Découvrez la version complète et ses fonctionnalités avancées',
  'pricing.limits.feature.lipSyncBeta': 'Appliquez le Lip-sync (bêta)',
  'pricing.limits.feature.noTrialLimits': "Importez des fichiers sans les limites de l'essai gratuit",
  'pricing.limits.feature.proofread': 'Relisez le texte avant le doublage',
  'pricing.limits.feature.srtUpload': 'Importez un fichier SRT avec votre vidéo',
  'pricing.limits.feature.translation130': 'Traduisez dans plus de 135 langues',
  'pricing.limits.feature.voiceClone28': 'Utilisez Voice Clone dans 32 langues',
  'pricing.limits.freeVideoLimit': 'Vous avez atteint la limite de vidéos gratuites.',
  'pricing.limits.notEnoughMinutes': "Il n'y a pas assez de minutes disponibles pour traduire la vidéo.",
  'pricing.limits.paymentFailed':
    "Nous n'avons pas pu traiter le paiement du renouvellement. Mettez à jour vos informations de paiement pour continuer à utiliser Rask.",
  'pricing.limits.renewSubscription': "Renouveler l'abonnement",
  'pricing.limits.spaceUnsupported':
    "Votre forfait actuel ne prend pas en charge cet espace. Passez au forfait supérieur pour continuer à l'utiliser.",
  'pricing.limits.subscriptionCanceled': 'Votre abonnement est annulé.',
  'pricing.limits.subscriptionCanceledDescription':
    "Nous avons gelé les minutes de votre compte. Renouvelez l'abonnement pour continuer à utiliser Rask et vos minutes.",
  'pricing.limits.subscriptionExpired': 'Votre abonnement a expiré. Renouvelez-le pour continuer à utiliser Rask.',
  'pricing.limits.subscriptionPaused':
    'Votre abonnement est suspendu et nous avons gelé les minutes de votre compte. Renouvelez-le pour continuer à utiliser Rask et vos minutes.',
  'pricing.limits.translationMinuteLimit': 'Vous avez atteint votre limite de minutes de traduction.',
  'pricing.limits.unlockFullVersion': 'Débloquer la version complète',
  'pricing.limits.updatePayment': 'Mettre à jour les informations de paiement',
  'pricing.limits.upgradeForMoreVideos': 'Passez au forfait supérieur pour traduire plus de vidéos',
  'pricing.limits.upgradeForMoreVideosTitle': 'Passez au forfait supérieur pour traduire plus de vidéos :',
  'pricing.limits.upgradePlanForMoreVideos': 'Passez au forfait supérieur pour traduire plus de vidéos',
  'pricing.limits.upgradeToContinue': 'Passez au forfait supérieur pour continuer à générer du contenu.',
  'pricing.limits.whiteLabelInactive': "Votre abonnement n'est plus actif. Contactez {email} pour obtenir de l'aide.",
  'pricing.limits.whiteLabelOutOfMinutes': "Vous n'avez plus de minutes. Rechargez votre solde de minutes.",
  'pricing.minutes.custom': 'Minutes personnalisées',
  'pricing.minutes.from': 'à partir de {count} minutes',
  'pricing.minutes.fromMonthly': 'À partir de {count} minutes/mois',
  'pricing.minutes.included': '{count} minutes incluses',
  'pricing.modal.closeAria': 'Fermer',
  'pricing.notActive.checkBoosters': 'Découvrir les autres Boosters',
  'pricing.notActive.closeAria': 'Fermer l’offre d’invitation d’équipe',
  'pricing.notActive.paidDescription':
    'Ajoutez des membres à votre abonnement et collaborez facilement dans votre espace partagé !',
  'pricing.notActive.title': 'Ensemble, c’est mieux. Invitez votre équipe !',
  'pricing.notActive.trialDescription':
    'Créez des espaces de travail dédiés, invitez des collaborateurs et gérez vos projets ensemble avec Teamspaces.',
  'pricing.notActive.trialPaywallTitle': 'Libérez le potentiel de votre équipe',
  'pricing.notActive.unlockTeamspaces': 'Débloquez Teamspaces avec Creator Pro',
  'pricing.pause.chargeDescription':
    'Le débit de {price}, selon votre tarif initial facturé {interval}, est prévu à la date suivante : {date}.',
  'pricing.pause.description':
    "Sa réactivation est prévue à la date suivante : {date}. Les données de votre compte resteront en sécurité jusqu'à la reprise de votre abonnement.",
  'pricing.pause.nextBillingDate': 'votre prochaine date de facturation',
  'pricing.pause.resumeNow': "Reprendre l'abonnement maintenant",
  'pricing.pause.resumeTitle': 'Vous souhaitez reprendre votre abonnement ?',
  'pricing.pause.success': 'Abonnement repris.\nVous serez facturé à la prochaine date de renouvellement.',
  'pricing.pause.title': 'Votre abonnement est suspendu',
  'pricing.paywall.enterpriseQuestion': 'Vous traduisez plus de 1 000 minutes par mois ?',
  'pricing.paywall.feature.api': 'Accès à l’API',
  'pricing.paywall.feature.customVoiceClone':
    'Personnalisez votre clone vocal et enregistrez-le dans votre bibliothèque',
  'pricing.paywall.feature.dictionary': 'Enregistrez des traductions personnalisées dans le dictionnaire',
  'pricing.paywall.feature.lipSync': 'Appliquez le Lip-sync',
  'pricing.paywall.feature.srtDownload': 'Téléchargez un fichier de sous-titres SRT',
  'pricing.paywall.feature.srtUpload': 'Importez un fichier SRT avec votre vidéo',
  'pricing.paywall.feature.subtitles': 'Ajoutez des sous-titres à votre vidéo',
  'pricing.paywall.feature.teamspacesSoon': 'Créez des Teamspaces et collaborez avec votre équipe',
  'pricing.paywall.feature.translation130': 'Traduisez vos vidéos et vos fichiers audio dans plus de 135 langues',
  'pricing.paywall.feature.voiceClone29': 'Clonage vocal dans 32 langues',
  'pricing.paywall.queueTitle': 'La file d’attente des utilisateurs gratuits est actuellement saturée',
  'pricing.paywall.requestEnterpriseDemo': 'Demander une démo Enterprise',
  'pricing.paywall.upgradeTitle': 'Passez à une offre supérieure pour obtenir un accès complet !',
  'pricing.paywall.viewPlans': 'Voir les offres',
  'pricing.plan.bestForBeginners': 'Idéal pour débuter',
  'pricing.plan.bestForIndividuals': 'Idéal pour les particuliers',
  'pricing.plan.bestValue': 'Meilleur rapport qualité-prix',
  'pricing.plan.business': 'Business',
  'pricing.plan.businessDescription': 'Pour les équipes disposant d’une vidéothèque en pleine croissance',
  'pricing.plan.businessFeature1': 'Examinez et gérez les projets avec votre équipe',
  'pricing.plan.businessFeature2': 'Préservez la cohérence de votre marque et de votre terminologie',
  'pricing.plan.businessFeature3': 'Importez et traduisez des lots de vidéos',
  'pricing.plan.creator': 'Creator',
  'pricing.plan.creatorDescription': 'Pour les créateurs qui travaillent sur des projets de moindre envergure',
  'pricing.plan.creatorFeature1': 'Démarrez sans configuration',
  'pricing.plan.creatorFeature2': 'Traduisez une vidéo en quelques langues',
  'pricing.plan.creatorFeature3': 'Passez au forfait supérieur lorsque l’adaptation devient régulière',
  'pricing.plan.creatorPro': 'Creator Pro',
  'pricing.plan.creatorProDescription': 'Pour publier régulièrement des vidéos',
  'pricing.plan.creatorProFeature1': 'Maîtrisez la précision de la traduction et de la synthèse vocale',
  'pricing.plan.creatorProFeature2': 'Préservez l’identité du locuteur grâce au Lip-sync',
  'pricing.plan.creatorProFeature3': 'Conçu pour les projets récurrents avec une petite équipe',
  'pricing.plan.current': 'Forfait actuel',
  'pricing.plan.currentOutsideGrid': 'Votre forfait actuel : {plan}, {price}',
  'pricing.plan.currentShort': 'Actuel',
  'pricing.plan.enterprise': 'Enterprise',
  'pricing.plan.enterpriseDescription': 'Pour des opérations à l’échelle mondiale exigeant confiance et prévisibilité',
  'pricing.plan.enterpriseFeature1': 'Préparation aux exigences de sécurité et de conformité',
  'pricing.plan.enterpriseFeature2': 'Fiabilité de la production et SLA',
  'pricing.plan.enterpriseFeature3': 'Intégrations personnalisées et API',
  'pricing.plan.enterpriseFeature4': 'Assurance qualité supervisée',
  'pricing.plan.limitedOffer': 'Offre à durée limitée',
  'pricing.plan.mostPopular': 'Le plus populaire',
  'pricing.plan.starter': 'Starter',
  'pricing.plan.starterDescription': 'Pour débuter avec une adaptation vidéo simple',
  'pricing.plan.tailoredOnboarding': 'Intégration personnalisée et SLA',
  'pricing.plan.toggleDetails': 'Afficher ou masquer les détails du forfait',
  'pricing.plan.unlimitedRecording': 'Enregistrement d’écran illimité',
  'pricing.price.billedMonthly': 'facturé mensuellement',
  'pricing.price.billedYearly': 'facturé {amount} par an',
  'pricing.price.custom': 'Personnalisé',
  'pricing.price.from': 'à partir de',
  'pricing.price.perMonth': '/mois',
  'pricing.price.perMonthLong': 'par mois',
  'pricing.renew.happy': 'Nous sommes ravis de vous revoir !',
  'pricing.renew.welcome': 'Bon retour parmi nous !',
  'pricing.savings.year': 'Économisez {amount}/an ({percent} % de réduction)',
  'pricing.socialProof': 'Plus de {count} utilisateurs satisfaits',
  'pricing.starter.allCreator': 'Toutes les fonctionnalités du forfait Creator',
  'pricing.starter.currentTitle': 'Forfait {plan} : {price} par mois',
  'pricing.starter.minuteDescription':
    '1 minute = 1 minute de contenu traduit. Par exemple, traduire une vidéo d’une minute en deux langues consomme 2 minutes.',
  'pricing.starter.minuteTitle': 'Que signifie une minute ?',
  'pricing.starter.tryTitle': 'Essayez-le pour {price} par mois avec le forfait {plan}',
  'pricing.starter.watermarkDescription':
    'La vidéo comportera le filigrane « Translated by Rask AI » dans le coin supérieur droit.',
  'pricing.title': 'Tarifs',
  'pricing.trial.continue': "Continuer avec l'essai gratuit",
  'pricing.upgrade.aiRewrite.unlockAiRewriteFeature': 'Débloquez la réécriture par IA',
  'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl':
    'Passez au forfait Creator Pro pour contrôler la vitesse et aligner les segments par IA sur vos horodatages',
  'pricing.upgrade.audioDownload.unlockAudioDownload': 'Débloquez le téléchargement audio',
  'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated':
    'Passez à Creator pour télécharger l’audio avec la voix générée ou avec la voix et le fond sonore',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members': '1 Teamspace avec jusqu’à 10 membres',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members': '1 Teamspace avec jusqu’à 5 membres',
  'pricing.upgrade.bullets.aiScriptAdjustment': 'Ajustement du script par IA',
  'pricing.upgrade.bullets.apiAccess': 'Accès à l’API',
  'pricing.upgrade.bullets.automatedCaptionsSubtitles': 'Sous-titres automatiques',
  'pricing.upgrade.bullets.businessContractAndInvoicing': 'Contrat professionnel et facturation',
  'pricing.upgrade.bullets.customPriceForMinutes': 'Tarif personnalisé à la minute',
  'pricing.upgrade.bullets.customVoiceCloneLibrary': 'Bibliothèque personnalisée de Voice Clone',
  'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices':
    'Bibliothèque personnalisée de Voice Clone (10 voix personnalisées)',
  'pricing.upgrade.bullets.downloadGeneratedVoice': 'Téléchargement de la voix générée',
  'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound':
    'Téléchargement de la voix générée avec le fond sonore',
  'pricing.upgrade.bullets.from100MinutesEveryMonth': 'À partir de 100 minutes par mois',
  'pricing.upgrade.bullets.from2000MinutesEveryMonth': 'À partir de 2000 minutes par mois',
  'pricing.upgrade.bullets.from25MinutesEveryMonth': 'À partir de 25 minutes par mois',
  'pricing.upgrade.bullets.from500MinutesEveryMonth': 'À partir de 500 minutes par mois',
  'pricing.upgrade.bullets.humanInTheLoop': 'Validation humaine',
  'pricing.upgrade.bullets.multispeakerLipSync': 'Lip-sync pour plusieurs intervenants',
  'pricing.upgrade.bullets.noWatermark': 'Sans filigrane',
  'pricing.upgrade.bullets.personalCustomerManager': 'Responsable clientèle dédié',
  'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation': 'Traduction simultanée dans plusieurs langues',
  'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload': 'Import de transcription SRT et export SRT',
  'pricing.upgrade.bullets.translationDictionaries': 'Dictionnaires de traduction',
  'pricing.upgrade.bullets.translationPrompting': 'Instructions de traduction',
  'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers': 'Teamspaces et membres illimités',
  'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones': 'Nombre illimité de Voice Clones personnalisées',
  'pricing.upgrade.bullets.voiceCloneSettings': 'Réglages de Voice Clone',
  'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark':
    'Ajoutez les termes et leurs traductions préférées (ou indiquez qu’ils ne doivent pas être traduits)',
  'pricing.upgrade.glossary.applyToAnyProjectWithOneClick': 'Appliquez-le à n’importe quel projet en un clic',
  'pricing.upgrade.glossary.createADictionaryForYourLanguagePair': 'Créez un dictionnaire pour votre paire de langues',
  'pricing.upgrade.glossary.howItWorks': 'Fonctionnement',
  'pricing.upgrade.glossary.howToUseDictionaryEffectively': 'comment utiliser efficacement le dictionnaire',
  'pricing.upgrade.glossary.learnMore': 'En savoir plus',
  'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay':
    'Définissez vos traductions une fois : elles resteront cohérentes dans toutes vos vidéos.',
  'pricing.upgrade.glossary.perfectFor': 'Idéal pour',
  'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation':
    '83 % des utilisateurs Business font confiance à Rask pour la précision de ses traductions',
  'pricing.upgrade.glossary.unlockTranslationDictionary': 'Débloquez le dictionnaire de traduction',
  'pricing.upgrade.glossary.upgradeToBusiness': 'Passez à Business',
  'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary':
    'Passez à Business pour créer un dictionnaire de traduction',
  'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr':
    'les vidéos contenant une terminologie et des noms de produits spécifiques, ou les bibliothèques de contenu multilingues.',
  'pricing.upgrade.lipSync.aboutLipSyncFeature': 'sur la fonctionnalité Lip-sync',
  'pricing.upgrade.lipSync.enhancedModel':
    'Nouveau modèle Lip-sync amélioré : qualité studio (déduit {multiplier} minutes pour 1 minute de vidéo)',
  'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync': 'Chaque visage à l’écran est parfaitement synchronisé',
  'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther':
    'Créez du contenu professionnel avec le Lip-sync et d’autres outils Pro',
  'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio':
    'Le Lip-sync synchronise les mouvements de la bouche avec l’audio traduit pour un doublage naturel, sans effet de superposition.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth':
    'Donnez un rendu naturel à vos vidéos doublées en synchronisant les mouvements de la bouche avec l’audio traduit. Disponible avec Creator Pro et les forfaits supérieurs.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookReal': 'Donnez un rendu réaliste à vos vidéos doublées',
  'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage':
    'Vidéos doublées au rendu naturel dans toutes les langues',
  'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters':
    'les contenus professionnels pour lesquels l’authenticité visuelle est essentielle.',
  'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility':
    'Publiez sur tous les marchés sans perdre en crédibilité',
  'pricing.upgrade.lipSync.seePlansWithLipSync': 'Voir les forfaits avec le Lip-sync',
  'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple':
    'Mouvements des lèvres synchronisés avec l’audio traduit pour plusieurs intervenants',
  'pricing.upgrade.lipSync.unlockLipSyncFeature': 'Débloquez la fonctionnalité Lip-sync',
  'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip':
    'Passez au forfait Creator Pro pour ajouter le Lip-sync à vos vidéos et profiter d’une qualité de traduction exceptionnelle',
  'pricing.upgrade.lipSync.withLipSync': 'Avec le Lip-sync :',
  'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver': 'Votre contenu semble natif, pas simplement doublé',
  'pricing.upgrade.multilanguage.learnMoreCaption':
    '(En savoir plus)[{link}] sur la meilleure façon d’utiliser cette fonctionnalité',
  'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature': 'Débloquez la traduction multilingue',
  'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer':
    'Votre forfait permet de traduire chaque import dans 1 langue. Passez à un forfait supérieur pour traduire votre vidéo dans plusieurs langues',
  'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade':
    'Vous avez atteint votre limite de vidéos gratuites. Passez au forfait Business pour traduire vos vidéos dans plusieurs langues',
  'pricing.upgrade.paywallTitles.unlockAudioExportAndMore': 'Débloquez l’export audio et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockDictionaryAndMore': 'Débloquez le dictionnaire et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockGlossaryAndMore': 'Débloquez le glossaire et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockLipSyncAndMore': 'Débloquez le Lip-sync et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore': 'Débloquez la traduction multilingue et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockPromptingAndMore': 'Débloquez les instructions et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockSrtExportAndMore': 'Débloquez l’export SRT et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore': 'Débloquez l’import SRT et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore': 'Débloquez l’export des sous-titres et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore': 'Débloquez les Teamspaces et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore':
    'Débloquez les instructions de traduction et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore': 'Débloquez la durée illimitée et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore': 'Débloquez les sous-titres vidéo et bien plus encore',
  'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore': 'Débloquez les préréglages vocaux et bien plus encore',
  'pricing.upgrade.srtDownload.aboutSrtDownload': 'sur le téléchargement SRT',
  'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers':
    'Les versions originales et traduites des sous-titres avec les intervenants',
  'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads':
    'les créateurs qui ont besoin de variantes de sous-titres personnalisées, d’imports sur YouTube ou de processus de montage externes.',
  'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize':
    'Obtenez des fichiers de sous-titres flexibles à modifier, personnaliser et utiliser partout.',
  'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt':
    'Gardez le contrôle total de vos sous-titres avec les fichiers SRT et les outils Pro',
  'pricing.upgrade.srtDownload.orUpgradeToCreatorPro': 'ou passez à Creator Pro',
  'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken':
    'Des fichiers de sous-titres en texte brut avec horodatages et texte prononcé',
  'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing':
    'Des segments de texte formatés pour les plateformes vidéo ou les outils de montage',
  'pricing.upgrade.srtDownload.unlockSrtDownload': 'Débloquez le téléchargement de fichiers .SRT',
  'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt':
    'Passez au forfait Creator Pro pour télécharger des fichiers SRT contenant les sous-titres des vidéos d’origine et traduites',
  'pricing.upgrade.srtDownload.whatYouLlGet': 'Ce que vous obtenez',
  'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile':
    'Téléchargez le SRT → Envoyez-le pour correction → Importez le fichier mis à jour',
  'pricing.upgrade.srtUpload.howToUseSrtUpload': 'comment utiliser l’import SRT',
  'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo':
    'Actualisez instantanément le texte, les timings et les informations sur les intervenants',
  'pricing.upgrade.srtUpload.noManualCopyPaste': 'Aucun copier-coller manuel',
  'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick':
    'Remplacez des heures de montage manuel par un seul clic',
  'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo':
    'les équipes qui modifient leurs sous-titres dans des outils externes et souhaitent synchroniser rapidement les changements.',
  'pricing.upgrade.srtUpload.unlockSrtUpload': 'Débloquez l’import SRT',
  'pricing.upgrade.srtUpload.unlockSrtUploadFeature': 'Débloquez l’import SRT',
  'pricing.upgrade.srtUpload.updateSubtitlesInSeconds': 'Mettez à jour les sous-titres en quelques secondes',
  'pricing.upgrade.srtUpload.upgradeToCreatorPro': 'Passez à Creator Pro',
  'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair':
    'Passez au forfait Creator Pro pour associer facilement votre vidéo à des sous-titres existants et obtenir un doublage précis',
  'pricing.upgrade.srtUpload.uploadAnEditedSrtFile': 'Importez un fichier SRT modifié',
  'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick': 'Importez la transcription corrigée en un clic.',
  'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith':
    'toute personne qui publie sur plusieurs plateformes ou travaille en équipe.',
  'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready':
    'Exportez les sous-titres traduits au format SRT : déjà synchronisés, déjà traduits et prêts pour tous vos processus.',
  'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools':
    'Profitez de l’export des sous-titres et d’autres outils Pro',
  'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra':
    'Transmettez le contenu aux monteurs ou aux clients sans étape supplémentaire',
  'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn':
    'Publiez sur YouTube, TikTok ou toute autre plateforme en quelques minutes',
  'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport': 'Voir les forfaits avec export des sous-titres',
  'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens':
    'Emportez vos sous-titres partout où vous travaillez',
  'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo':
    'Les horodatages restent parfaitement alignés sur votre vidéo',
  'pricing.upgrade.subtitleExport.withSubtitleExport': 'Avec l’export des sous-titres :',
  'pricing.upgrade.teamspace.aboutTeamspaceCollaboration': 'sur la collaboration dans Teamspace',
  'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout':
    'les agences et équipes qui gèrent plusieurs projets de doublage sans désorganisation.',
  'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace': 'Collaborez avec votre équipe au même endroit.',
  'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf':
    'Contactez-nous pour déterminer le nombre de Teamspaces et de membres adapté à votre équipe.',
  'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra':
    'Donnez aux invités accès à toutes les fonctionnalités sans abonnement supplémentaire',
  'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials':
    'Invitez vos collègues avec des identifiants individuels, sans partager de compte',
  'pricing.upgrade.teamspace.lookingToScaleYourTeam': 'Vous souhaitez agrandir votre équipe ?',
  'pricing.upgrade.teamspace.orContactUs': 'ou contactez-nous',
  'pricing.upgrade.teamspace.orUpgradeToBusiness': 'ou passez à Business',
  'pricing.upgrade.teamspace.scaleYourTeam': 'Agrandissez votre équipe',
  'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60':
    'Les équipes réduisent de 60 % le temps consacré à la coordination des projets',
  'pricing.upgrade.teamspace.unlockTeamspaces': 'Débloquez les Teamspaces',
  'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5':
    'Passez à Business pour obtenir un Teamspace avec 5 places, ou ajoutez les places nécessaires.',
  'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith':
    'Passez à Creator Pro pour disposer d’un Teamspace comptant jusqu’à 3 membres',
  'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember':
    'Passez à Enterprise pour personnaliser les Teamspaces et les limites de membres, ou ajoutez les places nécessaires.',
  'pricing.upgrade.teamspace.workBetterTogether': 'Travaillez mieux ensemble',
  'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd':
    'Travaillez facilement sur des projets partagés, sans échanges incessants de fichiers',
  'pricing.upgrade.texts.choosePlan': 'Choisir un forfait',
  'pricing.upgrade.texts.contactUs': 'Nous contacter',
  'pricing.upgrade.texts.everythingInBusinessPlus': 'Tout ce qui est inclus dans Business, plus :',
  'pricing.upgrade.texts.everythingInCreatorPlus': 'Tout ce qui est inclus dans Creator, plus :',
  'pricing.upgrade.texts.everythingInCreatorProPlus': 'Tout ce qui est inclus dans Creator Pro, plus :',
  'pricing.upgrade.texts.everythingInTrialPlus': 'Tout ce qui est inclus dans Trial, plus :',
  'pricing.upgrade.texts.orChoosePlan': 'ou choisir un forfait',
  'pricing.upgrade.texts.upgradeToBusinessPlan': 'Passer au forfait Business',
  'pricing.upgrade.texts.upgradeToCreatorPlan': 'Passer au forfait Creator',
  'pricing.upgrade.texts.upgradeToCreatorProPlan': 'Passer au forfait Creator Pro',
  'pricing.upgrade.texts.withTheBusinessPlanYouLlGet': 'Avec le forfait Business, vous bénéficiez de :',
  'pricing.upgrade.texts.withTheCreatorPlanYouLlGet': 'Avec le forfait Creator, vous bénéficiez de :',
  'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet': 'Avec le forfait Creator Pro, vous bénéficiez de :',
  'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd':
    'Le dictionnaire enregistre vos noms de marque, termes de produits et expressions clés, puis les utilise de façon cohérente dans chaque projet.',
  'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain':
    'Corrigez un terme une fois pour ne plus jamais avoir à le corriger',
  'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro':
    'Obtenez des traductions cohérentes avec le dictionnaire et d’autres outils Pro',
  'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross':
    'Plus besoin de corriger les mêmes termes d’un projet à l’autre',
  'pricing.upgrade.translationDictionary.seePlansWithDictionary': 'Voir les forfaits avec dictionnaire',
  'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand':
    'les équipes et créateurs utilisant une terminologie précise ou le langage propre à leur marque.',
  'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect':
    'Des traductions qui vous ressemblent, pas seulement des traductions correctes',
  'pricing.upgrade.translationDictionary.withDictionary': 'Avec le dictionnaire :',
  'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage':
    'La voix de votre marque reste cohérente dans toutes les langues',
  'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot':
    'Un contenu qui semble écrit pour ce public, et non traduit',
  'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther':
    'Maîtrisez mieux vos traductions grâce aux instructions et aux autres outils Pro',
  'pricing.upgrade.translationTone.lessEditingAfterEveryDub': 'Moins de modifications après chaque doublage',
  'pricing.upgrade.translationTone.seePlansWithPrompting': 'Voir les forfaits avec instructions',
  'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows':
    'les équipes disposant de flux de travail d’adaptation continus.',
  'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd':
    'Indiquez-nous le ton, le public et le contexte pour obtenir une traduction adaptée à votre contenu, au-delà des mots.',
  'pricing.upgrade.translationTone.translationsThatSoundLikeYou': 'Des traductions qui vous ressemblent',
  'pricing.upgrade.translationTone.withPrompting': 'Avec les instructions :',
  'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage':
    'Votre ton est préservé dans toutes les langues',
  'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews':
    'tout contenu de plus d’une minute : tutoriels, entretiens ou cours.',
  'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview': 'Doublez toute la vidéo, pas seulement un aperçu',
  'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd':
    'Chaque mot et chaque intervenant, jusqu’à la toute fin',
  'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools':
    'Profitez du doublage intégral et d’autres outils Pro',
  'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit':
    'Aucun contenu coupé pour respecter une limite de temps',
  'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength': 'Voir les forfaits avec durée illimitée',
  'pricing.upgrade.unlimitedLength.withUnlimitedLength': 'Avec la durée illimitée :',
  'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo':
    'Votre vidéo entière, entièrement doublée et prête à être publiée',
  'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid':
    'Votre essai propose un aperçu de 1 minute. Avec un forfait payant, Rask double le fichier entier : aucune coupure, aucun élément manquant.',
  'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations':
    'les marques et créateurs qui ont besoin de traductions conformes à leur identité sans révisions importantes.',
  'pricing.upgrade.userPrompting.controlYourTranslation': 'Maîtrisez votre traduction',
  'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5':
    'Les utilisateurs Enterprise valident les corrections de traduction jusqu’à 5× plus vite',
  'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology': 'Orientez le choix des mots et de la terminologie',
  'pricing.upgrade.userPrompting.howToUsePromptingEffectively': 'comment utiliser efficacement les instructions',
  'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice':
    'Faites correspondre vos vidéos doublées à la voix de votre marque.',
  'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations':
    'Définissez le ton, le style et le contexte des traductions à l’aide d’instructions. Choisissez l’un de nos modèles ou rédigez votre propre instruction selon vos besoins.',
  'pricing.upgrade.userPrompting.setToneAndFormalityLevel': 'Définissez le ton et le niveau de formalité',
  'pricing.upgrade.userPrompting.unlockTranslationPrompting': 'Débloquez les instructions de traduction',
  'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature': 'Débloquez les instructions de traduction',
  'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts':
    'Utilisez des modèles prêts à l’emploi ou rédigez des instructions personnalisées',
  'pricing.upgrade.videoSubtitles.unlockCaptionsFeature': 'Débloquez les sous-titres',
  'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith':
    'Passez à Creator Pro pour télécharger des vidéos avec sous-titres',
  'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary': 'sur la bibliothèque de Voice Clone',
  'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents': 'Ajustez l’expressivité ou supprimez les accents',
  'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining':
    'Les créateurs qui doublent dans plusieurs langues et les marques qui conservent la même voix dans tous leurs contenus.',
  'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro':
    'Améliorez vos doublages avec cet outil et d’autres outils Pro',
  'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery':
    'Obtenez à chaque fois exactement le rendu souhaité pour votre voix clonée.',
  'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects':
    'Réutilisez vos voix clonées dans un nombre illimité de projets',
  'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes':
    'Enregistrez des clones vocaux personnalisés ou créez-en de nouveaux',
  'pricing.upgrade.voicePresets.unlockMoreVoiceClones': 'Débloquez davantage de Voice Clones',
  'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary': 'Débloquez la bibliothèque de Voice Clone',
  'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10':
    'Passez à Business pour enregistrer jusqu’à 10 Voice Clones personnalisées',
  'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom':
    'Passez à Creator Pro pour créer une Voice Clone personnalisée',
  'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice':
    'Passez à Enterprise pour enregistrer un nombre illimité de Voice Clones personnalisées',
  'pricing.upgrade.voicePresets.whatYouCanDo': 'Ce que vous pouvez faire',
  'pricing.yearly.buyMinutes': 'Achetez des minutes supplémentaires à tout moment',
  'pricing.yearly.keepMinutes': 'Aucune minute perdue en fin de mois',
  'pricing.yearly.only': 'PLANS ANNUELS UNIQUEMENT',
  'pricing.yearly.unlimitedEditing': 'Réédition et redoublage illimités',
};

const it: Record<keyof typeof en, string> = {
  'billing.confirm.amountDue': 'Importo dovuto oggi',
  'billing.confirm.and': 'e',
  'billing.confirm.boostersTerms': 'i Termini di utilizzo dei Booster',
  'billing.confirm.confirm': 'Conferma',
  'billing.confirm.discountHint': 'Lo sconto del {percent}% si applica solo alla prima fattura.',
  'billing.confirm.havePromo': 'Hai un codice promozionale?',
  'billing.confirm.hideDetails': 'Nascondi dettagli',
  'billing.confirm.invalidPromo': 'Il codice promozionale non è valido',
  'billing.confirm.monthlyFrom': 'Fatturazione mensile a partire dal {date}',
  'billing.confirm.noCharges': 'Nessun addebito futuro per i Booster',
  'billing.confirm.noChargesDescription': 'Non avrai alcun Booster attivo dopo la conferma.',
  'billing.confirm.oneTimeHint': "Il pagamento una tantum copre l'utilizzo fino alla fine del ciclo di fatturazione.",
  'billing.confirm.paymentMethod': 'Metodo di pagamento',
  'billing.confirm.perMonth': '/mese',
  'billing.confirm.perYear': '/anno',
  'billing.confirm.privacy': 'l’Informativa sulla privacy',
  'billing.confirm.promoFailed': 'Impossibile applicare il codice promozionale',
  'billing.confirm.promoLine': 'Codice promozionale {code}',
  'billing.confirm.promoPlaceholder': 'Codice promozionale',
  'billing.confirm.promotionTerms': 'i Termini della promozione',
  'billing.confirm.remove': '(rimosso)',
  'billing.confirm.removeItem': 'Rimozione di {item}',
  'billing.confirm.renews': 'Si rinnova automaticamente fino alla cancellazione',
  'billing.confirm.subscribe': 'Abbonati con obbligo di pagamento',
  'billing.confirm.taxHint': 'Il totale include le tasse in base ai dati di fatturazione.',
  'billing.confirm.terms': 'i Termini di servizio',
  'billing.confirm.termsIntro': 'Confermando, accetti i seguenti documenti di Rask AI:',
  'billing.confirm.updatePayment': 'Aggiorna il metodo di pagamento',
  'billing.confirm.vat': 'IVA {percent}',
  'billing.confirm.viewDetails': 'Visualizza i dettagli',
  'billing.confirm.yearlyFrom': 'Fatturazione annuale a partire dal {date}',
  'billing.error.authentication':
    'Autenticazione del pagamento non riuscita. Non è stato possibile confermare il pagamento con la tua banca.',
  'billing.error.bankDeclined':
    'Il pagamento è stato rifiutato dalla tua banca. La banca non ha approvato questa transazione.',
  'billing.error.cardCannotBeUsed': 'Questa carta non può essere utilizzata',
  'billing.error.cardDetails':
    'I dettagli della carta non sono corretti. Controlla il numero della carta, la data di scadenza e il codice di sicurezza.',
  'billing.error.changePayment': 'Cambia il tuo metodo di pagamento',
  'billing.error.editPayment': 'Modifica metodo di pagamento',
  'billing.error.failed': 'Pagamento non riuscito',
  'billing.error.insufficient':
    'Pagamento non riuscito: fondi insufficienti o limite raggiunto. La tua banca ha rifiutato il pagamento a causa di un saldo basso o di un limite di spesa basso.',
  'billing.error.retryPayment': 'Riprova o cambia metodo di pagamento',
  'billing.result.canClose': 'Puoi chiudere questa finestra modale in qualsiasi momento.',
  'billing.result.closeWindow': 'Chiudi la finestra',
  'billing.result.processing': 'Stiamo elaborando il tuo ordine',
  'billing.result.processingDescription':
    "L'operazione potrebbe richiedere alcuni minuti. Continueremo a elaborarla in background e attiveremo automaticamente il tuo abbonamento una volta completata.",
  'billing.result.success': 'Pagamento elaborato con successo',
  'billing.result.viewInvoice': 'Visualizza fattura',
  'bookDemo.booked': 'Demo prenotata!',
  'bookDemo.bookedFor': 'Demo prenotata per {slot}',
  'bookDemo.coverDescription':
    "il tuo caso d'uso per la localizzazione, il modo migliore per gestirlo in Rask, come utilizzarlo con tutto il team e una struttura dei prezzi chiara.",
  'bookDemo.coverTitle': 'Di cosa parleremo:',
  'bookDemo.inviteSent': 'Un invito con il collegamento alla riunione è stato inviato al tuo indirizzo email.',
  'bookDemo.seeYou': 'A presto',
  'bookDemo.subtitle':
    'Discuteremo il tuo flusso di lavoro, mostreremo le funzionalità nascoste e sceglieremo il piano migliore per le tue esigenze.',
  'bookDemo.timeBenefit': "Una demo di 30 minuti ti fa risparmiare circa 5 ore nell'esplorazione del prodotto.",
  'bookDemo.title': 'Prenota una demo con il nostro specialista',
  'pricing.actions.contactUs': 'Contattaci',
  'pricing.actions.downgrade': 'Passa a un piano inferiore',
  'pricing.actions.getStarted': 'Inizia',
  'pricing.actions.renew': 'Rinnova',
  'pricing.actions.switchAnnual': "Passa all'annuale",
  'pricing.actions.switchMonthly': 'Passa al mensile',
  'pricing.actions.upgrade': 'Passa a un piano superiore',
  'pricing.archived.description': 'Attualmente utilizzi un piano {plan} archiviato. Minuti inclusi: {count}.',
  'pricing.archived.hint': 'Continua a usarlo o passa al nuovo piano.',
  'pricing.billing.annual': 'Annuale',
  'pricing.billing.aria': 'Periodo di fatturazione',
  'pricing.billing.billAnnual': 'Fatturazione annuale',
  'pricing.billing.billedAnnually': 'Fatturazione annuale',
  'pricing.billing.monthly': 'Mensile',
  'pricing.billing.payAnnual': 'Paga annualmente',
  'pricing.booster.addForMonth': 'Aggiungi per {price} al mese',
  'pricing.buyMinutes.benefitRemain':
    "I minuti inutilizzati resteranno nel tuo account anche se metti in pausa l'abbonamento",
  'pricing.buyMinutes.benefitRollOver': 'Trasferiremo i minuti inutilizzati al mese successivo',
  'pricing.buyMinutes.checkout': 'Vai al pagamento',
  'pricing.buyMinutes.minutes': 'Minuti',
  'pricing.buyMinutes.newPricingDescription':
    'Scopri le nostre nuove tariffe, con pacchetti di minuti flessibili e nuove funzionalità!',
  'pricing.buyMinutes.newPricingTitle': 'Abbiamo appena lanciato nuove tariffe!',
  'pricing.buyMinutes.payLess': 'Paga meno',
  'pricing.buyMinutes.payOnly': 'Paga solo {price} al minuto!',
  'pricing.buyMinutes.perMinute': '{price}/min',
  'pricing.buyMinutes.price': 'Prezzo',
  'pricing.buyMinutes.title': 'Acquista minuti aggiuntivi',
  'pricing.buyMinutes.upgradeDescription': 'Passa a un piano superiore e paga meno per i minuti aggiuntivi',
  'pricing.cancelDowngrade.button': 'Annulla il downgrade',
  'pricing.cancelDowngrade.currentDescription':
    'Attualmente usi il piano {plan} al prezzo di {price}, con fatturazione {interval}, attivo fino a {date}.',
  'pricing.cancelDowngrade.currentTitle': 'Piano attuale',
  'pricing.cancelDowngrade.hint': 'Puoi programmare di nuovo il downgrade in qualsiasi momento.',
  'pricing.cancelDowngrade.scheduledDescription':
    'Il passaggio al piano {plan} al prezzo di {price}, con fatturazione {interval}, è previsto a partire da {date}. Se annulli la modifica, il tuo attuale abbonamento {currentPlan} continuerà.',
  'pricing.cancelDowngrade.scheduledTitle': 'Piano programmato',
  'pricing.cancelDowngrade.success': "Modifica dell'abbonamento annullata. Il piano {plan} resterà attivo.",
  'pricing.change.activeUntil': 'Il tuo piano attuale rimane attivo fino al giorno {date}.',
  'pricing.change.boosterDescription':
    'Il caricamento e il download di SRT sono ora inclusi nel tuo piano senza costi aggiuntivi. Lo rimuoveremo automaticamente dai tuoi booster.',
  'pricing.change.boosterIncluded': 'Booster incluso!',
  'pricing.change.changeSuccess': 'La modifica del tuo piano è stata elaborata',
  'pricing.change.current': 'Piano attuale',
  'pricing.change.currentDescription':
    'Attualmente usi il piano {plan} con fatturazione {interval}, attivo fino al {date}.',
  'pricing.change.downgradeDescription':
    'Stai passando al piano {plan} con fatturazione {interval}. La modifica avrà effetto alla fine del periodo di fatturazione corrente.',
  'pricing.change.downgradeError': 'Impossibile passare a un piano inferiore:',
  'pricing.change.downgradeSuccess': 'Il tuo downgrade è stato programmato',
  'pricing.change.featuresLost': 'Funzionalità che perdi',
  'pricing.change.monthly': 'mensile',
  'pricing.change.new': 'Nuovo piano',
  'pricing.change.scheduleDowngrade': 'Pianifica il downgrade',
  'pricing.change.switchBack': 'Puoi tornare al tuo piano precedente a partire dal giorno {date}.',
  'pricing.change.upgradeDescription':
    'Stai passando al piano {plan} con fatturazione {interval}. Riceverai immediatamente nuove funzionalità e {count} minuti extra (la differenza tra i piani).',
  'pricing.change.upgradeError': 'Impossibile passare a un piano superiore:',
  'pricing.change.upgradeNow': 'Passa ora a un piano superiore',
  'pricing.change.upgradePaidSuccess': 'Pagamento elaborato correttamente. Passaggio al piano superiore completato',
  'pricing.change.upgradeSuccess': 'Passaggio al piano superiore completato',
  'pricing.change.yearly': 'annuale',
  'pricing.compare.credits': 'Crediti e generazioni',
  'pricing.compare.editor': 'Editor',
  'pricing.compare.extraMinutes': 'Minuti extra',
  'pricing.compare.minutesIncluded': 'Minuti inclusi',
  'pricing.compare.plans': 'Confronta i piani',
  'pricing.compare.row.api': 'API e integrazioni',
  'pricing.compare.row.apiDescription':
    'Connetti Rask ai tuoi strumenti esistenti e automatizza il tuo flusso di lavoro.',
  'pricing.compare.row.autoCut': 'Taglio automatico con IA',
  'pricing.compare.row.autoCutDescription': 'Rimuovi automaticamente intercalari e silenzi dalle registrazioni.',
  'pricing.compare.row.autoZoom': 'Zoom automatico',
  'pricing.compare.row.autoZoomDescription': 'Esegue automaticamente lo zoom sull’azione mentre registri.',
  'pricing.compare.row.controls': 'Script, sottotitoli e controlli della voce',
  'pricing.compare.row.controlsDescription':
    'Modifica direttamente la trascrizione, i timestamp, le etichette dei locutori e le impostazioni vocali.',
  'pricing.compare.row.extraDescription': 'Puoi acquistare minuti aggiuntivi in qualsiasi momento con i piani annuali.',
  'pricing.compare.row.glossary': 'Glossario e terminologia',
  'pricing.compare.row.glossaryDescription':
    'Salva i termini personalizzati in modo che le stesse parole vengano tradotte in modo coerente ogni volta.',
  'pricing.compare.row.lipSync': 'Lip-sync per più locutori',
  'pricing.compare.row.lipSyncDescription':
    "Abbina i movimenti della bocca all'audio tradotto per ottenere un doppiaggio più naturale.",
  'pricing.compare.row.minutes': 'Minuti di localizzazione inclusi all’anno',
  'pricing.compare.row.minutesDescription':
    'I minuti annuali disponibili per la traduzione o il doppiaggio. I piani Business annuali rendono disponibili tutti i minuti fin da subito.',
  'pricing.compare.row.minutesTitle': 'Minuti di localizzazione inclusi all’anno',
  'pricing.compare.row.multiLanguage': 'Flusso di lavoro multilingue',
  'pricing.compare.row.multiLanguageDescription': 'Traduci un singolo video in più lingue in un unico progetto.',
  'pricing.compare.row.prompting': 'Prompt di traduzione',
  'pricing.compare.row.promptingDescription':
    'Aggiungi istruzioni prima della traduzione per impostare il contesto: tono, formalità e formulazione.',
  'pricing.compare.row.review': 'Flusso di revisione',
  'pricing.compare.row.reviewDescription':
    "Invia il contenuto tradotto ai revisori per l'approvazione prima della pubblicazione.",
  'pricing.compare.row.screenRecorder': 'Registratore dello schermo con IA',
  'pricing.compare.row.screenRecorderDescription': 'Registra schermo e videocamera direttamente in Rask.',
  'pricing.compare.row.security': 'Sicurezza e acquisti',
  'pricing.compare.row.securityDescription': 'Supporto per contratti, fatturazione e documentazione di conformità.',
  'pricing.compare.row.speed': 'Velocità di elaborazione',
  'pricing.compare.row.speedDescription': 'La velocità con cui i tuoi video vengono elaborati e renderizzati.',
  'pricing.compare.row.srt': 'Importazione/esportazione SRT',
  'pricing.compare.row.srtDescription':
    'Scarica i file dei sottotitoli o carica i tuoi per sincronizzarli con il doppiaggio.',
  'pricing.compare.row.srtTitle': 'Importazione/esportazione SRT',
  'pricing.compare.row.team': 'Spazio di lavoro del team',
  'pricing.compare.row.teamDescription': 'Invita i membri del team a collaborare ai progetti in uno spazio condiviso.',
  'pricing.compare.row.voices': 'Voci personalizzate salvate',
  'pricing.compare.row.voicesDescription': 'Salva le voci clonate in modo da poterle riutilizzare in progetti futuri.',
  'pricing.compare.showAll': 'Vedi tutte le funzionalità',
  'pricing.compare.showLess': 'Mostra meno',
  'pricing.compare.subtitle': 'Scegli il piano che corrisponde alla frequenza con cui pubblichi.',
  'pricing.compare.support': 'Supporto e lavoro di squadra',
  'pricing.compare.title': 'Confronta cosa cambia con la crescita delle tue esigenze',
  'pricing.compare.value.compliance': 'SSO, DPA, revisione della conformità',
  'pricing.compare.value.customBatch': 'Pipeline batch personalizzate',
  'pricing.compare.value.customIntegrations': 'Integrazioni personalizzate',
  'pricing.compare.value.customRoles': 'Ruoli personalizzati',
  'pricing.compare.value.dedicated': 'Dedicato / prioritario',
  'pricing.compare.value.extraMinute': '3 $ per minuto extra',
  'pricing.compare.value.fiveMembers': 'Fino a 5 membri + revisori ospiti',
  'pricing.compare.value.fullApi': "Accesso completo all'API",
  'pricing.compare.value.included': 'Incluso',
  'pricing.compare.value.managedQa': 'Controllo qualità gestito e approvazione di un esperto della materia',
  'pricing.compare.value.managedTerms': 'Flusso di lavoro terminologico gestito',
  'pricing.compare.value.multiBatch': 'Batch multi-video × multi-lingua',
  'pricing.compare.value.personalGlossary': 'Glossario personale',
  'pricing.compare.value.priorityQueue': 'Coda prioritaria',
  'pricing.compare.value.reviewer': 'Ruoli del revisore e approvazione',
  'pricing.compare.value.sandboxApi': 'API limitata/sandbox',
  'pricing.compare.value.sharedGlossary': 'Glossario condiviso del marchio',
  'pricing.compare.value.sharedVoices': '10 voci condivise dal team',
  'pricing.compare.value.standard': 'Standard',
  'pricing.compare.value.standardQueue': 'Coda standard',
  'pricing.compare.value.three': '3',
  'pricing.compare.value.threeMembers': 'Fino a 3 membri',
  'pricing.compare.value.unlimited': 'Illimitato',
  'pricing.compare.value.upgradePro': 'Passa a Pro',
  'pricing.compare.value.voiceLibrary': 'Libreria vocale personalizzata',
  'pricing.compare.whatChanges': 'Cosa cambia',
  'pricing.enterprisePayment.contactSupport': 'Contatta la chat di assistenza o scrivici a',
  'pricing.enterprisePayment.unknownError': 'Errore sconosciuto',
  'pricing.feature.aiRewriter': 'Regolazione dello script AI',
  'pricing.feature.allBusiness': 'Tutte le funzionalità di Business, più:',
  'pricing.feature.allCreator': 'Tutte le funzionalità di Creator, più:',
  'pricing.feature.allCreatorPro': 'Tutte le funzionalità di Creator Pro, più:',
  'pricing.feature.api': 'API',
  'pricing.feature.applyChanges': 'Applica le modifiche gratuitamente',
  'pricing.feature.businessContract': 'Contratto commerciale e fatturazione',
  'pricing.feature.captions': 'Didascalie/sottotitoli automatizzati',
  'pricing.feature.customerSuccess': 'Responsabile del successo del cliente',
  'pricing.feature.dictionary': 'Dizionario di traduzione',
  'pricing.feature.editor': 'Editor video avanzato',
  'pricing.feature.flexibleMinutes': 'Tariffe flessibili per i minuti',
  'pricing.feature.humanReview': 'Revisione umana',
  'pricing.feature.languages': 'Traduzioni in oltre 135 lingue',
  'pricing.feature.languagesDescription':
    "La disponibilità delle lingue dipende dall'uso delle voci IA o di Voice Clone.",
  'pricing.feature.learnMore': 'Scopri di più',
  'pricing.feature.lipSync': 'Lip-sync per più locutori',
  'pricing.feature.machineTranslation': 'Traduzione automatica',
  'pricing.feature.multiLanguage': 'Traduzione simultanea in più lingue',
  'pricing.feature.noWatermark': 'Nessuna filigrana',
  'pricing.feature.onlyVideoDownload': 'Solo download di video',
  'pricing.feature.priority': 'Elaborazione prioritaria',
  'pricing.feature.prompting': 'Prompt di traduzione',
  'pricing.feature.readDocs': 'Leggi la documentazione',
  'pricing.feature.speechToText': 'Trascrizione automatica da voce a testo',
  'pricing.feature.srtDownload': 'Scarica SRT',
  'pricing.feature.srtDownloadUpload': 'Scarica e carica SRT',
  'pricing.feature.srtUpload': 'Caricamento SRT',
  'pricing.feature.support': 'Supporto 24 ore su 24, 7 giorni su 7',
  'pricing.feature.teamspace3': '1 Teamspace, 3 membri',
  'pricing.feature.teamspace5': '1 Teamspace, 5 membri',
  'pricing.feature.teamspaces': 'Teamspace',
  'pricing.feature.voiceClones10': '10 cloni vocali personalizzati',
  'pricing.feature.voiceClones3': '3 cloni vocali personalizzati',
  'pricing.feature.voiceCloning': 'Clonazione vocale in 32 lingue',
  'pricing.feature.voiceCloningDescription':
    'Disponibile in 32 lingue, tra cui inglese, spagnolo, francese, italiano, portoghese e russo.',
  'pricing.feature.voiceLibrary': 'Libreria di cloni vocali',
  'pricing.feature.voiceSettings': 'Impostazioni di clone vocale',
  'pricing.feature.watermark': 'Filigrana',
  "pricing.featurePaywall.controlDownload.formats": "Any format anytime",
  "pricing.featurePaywall.controlDownload.fullVideo": "Export the full video, not just the preview",
  "pricing.featurePaywall.controlDownload.share": "Share for free",
  "pricing.featurePaywall.controlDownload.subtitle": "It's time to upgrade to download video without watermark and have unlimited downloading or you can share for free",
  "pricing.featurePaywall.controlDownload.title": "Unlock full video export or share for free",
  "pricing.featurePaywall.controlDownload.unlock": "Unlock video export",
  "pricing.featurePaywall.controlDownload.watermark": "Remove watermark",
  'pricing.header.description':
    'Ogni piano include la traduzione video in qualsiasi lingua, la clonazione vocale che preserva le emozioni e controlli gratuiti e facili da usare.',
  'pricing.header.title': 'Piani che crescono con il tuo volume di video',
  'pricing.legacy.businessFeature1': 'Garantisci la coerenza del tono di voce del brand',
  'pricing.legacy.businessFeature2': 'Controlla la terminologia nella traduzione',
  'pricing.legacy.businessFeature3': 'Elabora i volumi più velocemente che mai',
  'pricing.legacy.creatorFeature1': 'Doppiaggio con IA in oltre 135 lingue',
  'pricing.legacy.creatorFeature2': 'Clona voci in 32 lingue',
  'pricing.legacy.creatorFeature3': 'Potente editor illimitato',
  'pricing.legacy.creatorFeature4': 'Trascrizione e traduzione automatica',
  'pricing.legacy.creatorProFeature1': 'Aggiungi sincronizzazione labiale e sottotitoli',
  'pricing.legacy.creatorProFeature2': 'Utilizza strumenti vocali e di script di livello professionale',
  'pricing.legacy.creatorProFeature3': 'Collabora con il tuo team in uno spazio condiviso',
  'pricing.legacy.enterpriseFeature1': 'Ottieni contratti e fatturazione personalizzati',
  'pricing.legacy.enterpriseFeature2': 'Accedi al supporto prioritario dedicato',
  'pricing.legacy.enterpriseFeature3': 'Personalizza tutto in base alle tue esigenze',
  'pricing.legacy.everythingBusiness': 'Tutto ciò che include Business, più:',
  'pricing.legacy.everythingCreator': 'Tutto ciò che include Creator, più:',
  'pricing.legacy.everythingCreatorPro': 'Tutto ciò che include Creator Pro, più:',
  'pricing.limits.enterprise.contactOrSelectPlan':
    "Contatta la nostra specialista delle partnership all'indirizzo {email} o scegli uno dei nostri piani.",
  'pricing.limits.enterprise.notEnoughMinutes': 'Non hai abbastanza minuti per tradurre questo video.',
  'pricing.limits.enterprise.notEnoughMinutesShort': 'Minuti insufficienti per tradurre questo video.',
  'pricing.limits.enterprise.purchaseMore':
    'Contatta la nostra specialista delle partnership per acquistare altri minuti: {email}',
  'pricing.limits.enterprise.ranOut': 'Il tuo piano ha esaurito i minuti.',
  'pricing.limits.enterprise.renewAccess':
    "Contatta la nostra specialista delle partnership all'indirizzo {email} per rinnovare l'accesso.",
  'pricing.limits.enterprise.renewOrSelectPlan':
    "Contatta la nostra specialista delle partnership all'indirizzo {email} per rinnovare l'accesso o scegliere uno dei nostri piani.",
  'pricing.limits.exploreFullVersion': 'Esplora la versione completa con funzionalità avanzate',
  'pricing.limits.feature.lipSyncBeta': 'Applica la sincronizzazione labiale (beta)',
  'pricing.limits.feature.noTrialLimits': 'Carica file senza i limiti della prova gratuita',
  'pricing.limits.feature.proofread': 'Rileggi il testo prima del doppiaggio',
  'pricing.limits.feature.srtUpload': 'Carica un file SRT insieme al video',
  'pricing.limits.feature.translation130': 'Traduci in oltre 135 lingue',
  'pricing.limits.feature.voiceClone28': 'Usa Voice Clone in 32 lingue',
  'pricing.limits.freeVideoLimit': 'Hai raggiunto il limite di video gratuiti.',
  'pricing.limits.notEnoughMinutes': 'Non ci sono abbastanza minuti disponibili per tradurre il video.',
  'pricing.limits.paymentFailed':
    'Non siamo riusciti a elaborare il pagamento del rinnovo. Aggiorna i dati di pagamento per continuare a usare Rask.',
  'pricing.limits.renewSubscription': 'Rinnova abbonamento',
  'pricing.limits.spaceUnsupported':
    'Il tuo piano attuale non supporta questo spazio. Passa a un piano superiore per continuare a usarlo.',
  'pricing.limits.subscriptionCanceled': 'Il tuo abbonamento è stato annullato.',
  'pricing.limits.subscriptionCanceledDescription':
    "Abbiamo bloccato i minuti del tuo account. Rinnova l'abbonamento per continuare a usare Rask e i tuoi minuti.",
  'pricing.limits.subscriptionExpired': 'Il tuo abbonamento è scaduto. Rinnovalo per continuare a usare Rask.',
  'pricing.limits.subscriptionPaused':
    'Il tuo abbonamento è in pausa e abbiamo bloccato i minuti del tuo account. Rinnovalo per continuare a usare Rask e i tuoi minuti.',
  'pricing.limits.translationMinuteLimit': 'Hai raggiunto il limite di minuti per la traduzione.',
  'pricing.limits.unlockFullVersion': 'Sblocca la versione completa',
  'pricing.limits.updatePayment': 'Aggiorna i dati di pagamento',
  'pricing.limits.upgradeForMoreVideos': 'Passa a un piano superiore per tradurre più video',
  'pricing.limits.upgradeForMoreVideosTitle': 'Passa a un piano superiore per tradurre più video:',
  'pricing.limits.upgradePlanForMoreVideos': 'Passa a un piano superiore per tradurre più video',
  'pricing.limits.upgradeToContinue': 'Passa a un piano superiore per continuare a generare contenuti.',
  'pricing.limits.whiteLabelInactive': 'Il tuo abbonamento non è più attivo. Contatta {email} per ricevere assistenza.',
  'pricing.limits.whiteLabelOutOfMinutes': 'Hai esaurito i minuti. Ricarica il saldo dei minuti.',
  'pricing.minutes.custom': 'Minuti personalizzati',
  'pricing.minutes.from': 'A partire da {count} min',
  'pricing.minutes.fromMonthly': 'A partire da {count} min/mese',
  'pricing.minutes.included': 'Minuti inclusi: {count}',
  'pricing.modal.closeAria': 'Chiudi',
  'pricing.notActive.checkBoosters': 'Scopri gli altri booster',
  'pricing.notActive.closeAria': "Chiudi l'offerta di invito al team",
  'pricing.notActive.paidDescription':
    'Aggiungi altri membri al tuo abbonamento e collabora senza interruzioni nello spazio condiviso!',
  'pricing.notActive.title': 'Insieme è meglio. Invita il tuo team!',
  'pricing.notActive.trialDescription':
    'Crea spazi di lavoro dedicati, invita collaboratori e gestisci i progetti insieme nei Teamspace.',
  'pricing.notActive.trialPaywallTitle': 'Libera il potenziale del tuo team',
  'pricing.notActive.unlockTeamspaces': 'Sblocca i Teamspace con Creator Pro',
  'pricing.pause.chargeDescription':
    'La tariffa {interval} originale di {price} verrà addebitata alla data seguente: {date}.',
  'pricing.pause.description':
    "La riattivazione è prevista per la data seguente: {date}. I dati del tuo account resteranno al sicuro finché l'abbonamento non riprenderà.",
  'pricing.pause.nextBillingDate': 'la prossima data di fatturazione',
  'pricing.pause.resumeNow': "Riprendi subito l'abbonamento",
  'pricing.pause.resumeTitle': 'Vuoi riprenderlo?',
  'pricing.pause.success': "Abbonamento ripreso.\nL'addebito avverrà alla prossima data di rinnovo.",
  'pricing.pause.title': 'Il tuo abbonamento è in pausa',
  'pricing.paywall.enterpriseQuestion': 'Traduci più di 1.000 minuti al mese?',
  'pricing.paywall.feature.api': 'Accesso API',
  'pricing.paywall.feature.customVoiceClone': 'Personalizza il clone vocale e salvalo nella tua libreria',
  'pricing.paywall.feature.dictionary': 'Salva traduzioni personalizzate nel Dizionario',
  'pricing.paywall.feature.lipSync': 'Applica la sincronizzazione labiale',
  'pricing.paywall.feature.srtDownload': 'Scarica un file di sottotitoli SRT',
  'pricing.paywall.feature.srtUpload': 'Carica un file SRT insieme al video',
  'pricing.paywall.feature.subtitles': 'Aggiungi sottotitoli al video',
  'pricing.paywall.feature.teamspacesSoon': 'Crea dei Teamspace e collabora con il tuo team',
  'pricing.paywall.feature.translation130': 'Traduci video e audio in oltre 135 lingue',
  'pricing.paywall.feature.voiceClone29': 'Clonazione vocale in 32 lingue',
  'pricing.paywall.queueTitle': 'La coda per gli utenti gratuiti è al momento sovraccarica',
  'pricing.paywall.requestEnterpriseDemo': 'Richiedi una demo Enterprise',
  'pricing.paywall.upgradeTitle': "Esegui l'upgrade per ottenere l'accesso completo!",
  'pricing.paywall.viewPlans': 'Vedi i piani',
  'pricing.plan.bestForBeginners': 'Ideale per iniziare',
  'pricing.plan.bestForIndividuals': 'Ideale per i singoli',
  'pricing.plan.bestValue': 'Miglior rapporto qualità-prezzo',
  'pricing.plan.business': 'Business',
  'pricing.plan.businessDescription': 'Per i team con una libreria video in crescita',
  'pricing.plan.businessFeature1': 'Rivedi e gestisci i progetti con il tuo team',
  'pricing.plan.businessFeature2': 'Mantieni la coerenza del marchio e della terminologia',
  'pricing.plan.businessFeature3': 'Carica e traduci batch di video',
  'pricing.plan.creator': 'Creator',
  'pricing.plan.creatorDescription': 'Per creator che lavorano su progetti più piccoli',
  'pricing.plan.creatorFeature1': 'Onboarding senza configurazione',
  'pricing.plan.creatorFeature2': 'Traduci un singolo video in poche lingue',
  'pricing.plan.creatorFeature3': 'Passa a un piano superiore quando localizzi regolarmente',
  'pricing.plan.creatorPro': 'Creator Pro',
  'pricing.plan.creatorProDescription': 'Per chi pubblica video con regolarità',
  'pricing.plan.creatorProFeature1': "Controlla la traduzione e l'accuratezza del parlato",
  'pricing.plan.creatorProFeature2': "Preserva l'identità del locutore con il lip-sync",
  'pricing.plan.creatorProFeature3': 'Costruito per progetti ricorrenti con un piccolo team',
  'pricing.plan.current': 'Piano attuale',
  'pricing.plan.currentOutsideGrid': 'Il tuo piano attuale: {plan}, {price}',
  'pricing.plan.currentShort': 'Attuale',
  'pricing.plan.enterprise': 'Enterprise',
  'pricing.plan.enterpriseDescription': 'Per operare su scala globale con affidabilità e prevedibilità',
  'pricing.plan.enterpriseFeature1': 'Predisposizione alla sicurezza e alla conformità',
  'pricing.plan.enterpriseFeature2': 'Affidabilità in produzione e SLA',
  'pricing.plan.enterpriseFeature3': 'Integrazioni personalizzate e API',
  'pricing.plan.enterpriseFeature4': 'Garanzia di qualità gestita',
  'pricing.plan.limitedOffer': 'Offerta a tempo limitato',
  'pricing.plan.mostPopular': 'Il più popolare',
  'pricing.plan.starter': 'Starter',
  'pricing.plan.starterDescription': 'Per iniziare con una semplice localizzazione video',
  'pricing.plan.tailoredOnboarding': 'Onboarding personalizzato e SLA',
  'pricing.plan.toggleDetails': 'Mostra o nascondi i dettagli del piano',
  'pricing.plan.unlimitedRecording': 'Registrazione dello schermo illimitata',
  'pricing.price.billedMonthly': 'con fatturazione mensile',
  'pricing.price.billedYearly': '{amount} con fatturazione annuale',
  'pricing.price.custom': 'Personalizzato',
  'pricing.price.from': 'da',
  'pricing.price.perMonth': '/mese',
  'pricing.price.perMonthLong': 'al mese',
  'pricing.renew.happy': 'Siamo felici che tu sia di nuovo qui!',
  'pricing.renew.welcome': 'Che bello rivederti!',
  'pricing.savings.year': 'Risparmia {amount}/anno ({percent}% di sconto)',
  'pricing.socialProof': 'Oltre {count} utenti soddisfatti',
  'pricing.starter.allCreator': 'Tutte le funzionalità del piano Creator',
  'pricing.starter.currentTitle': 'Piano {plan}: {price} al mese',
  'pricing.starter.minuteDescription':
    '1 minuto = 1 minuto di contenuti tradotti. Ad esempio, tradurre un video di 1 minuto in due lingue utilizza 2 minuti.',
  'pricing.starter.minuteTitle': 'Cosa significa un minuto?',
  'pricing.starter.tryTitle': 'Provalo a {price} al mese con il piano {plan}',
  'pricing.starter.watermarkDescription':
    'Il video avrà la filigrana “Translated by Rask AI” nell’angolo in alto a destra.',
  'pricing.title': 'Prezzi',
  'pricing.trial.continue': 'Continua con la prova gratuita',
  'pricing.upgrade.aiRewrite.unlockAiRewriteFeature': 'Sblocca la funzione di riscrittura con l’IA',
  'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl':
    'Passa al piano Creator Pro per controllare la velocità e allineare i segmenti con l’IA in base ai tuoi timestamp',
  'pricing.upgrade.audioDownload.unlockAudioDownload': 'Sblocca il download dell’audio',
  'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated':
    'Passa a Creator per scaricare l’audio con la voce generata o con la voce e il sottofondo',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members': '1 Teamspace con un massimo di 10 membri',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members': '1 Teamspace con un massimo di 5 membri',
  'pricing.upgrade.bullets.aiScriptAdjustment': 'Adattamento del copione con l’IA',
  'pricing.upgrade.bullets.apiAccess': 'Accesso API',
  'pricing.upgrade.bullets.automatedCaptionsSubtitles': 'Sottotitoli automatici',
  'pricing.upgrade.bullets.businessContractAndInvoicing': 'Contratto aziendale e fatturazione',
  'pricing.upgrade.bullets.customPriceForMinutes': 'Prezzo personalizzato al minuto',
  'pricing.upgrade.bullets.customVoiceCloneLibrary': 'Libreria personalizzata di Voice Clone',
  'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices':
    'Libreria personalizzata di Voice Clone (10 voci personalizzate)',
  'pricing.upgrade.bullets.downloadGeneratedVoice': 'Download della voce generata',
  'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound': 'Download della voce generata con il sottofondo',
  'pricing.upgrade.bullets.from100MinutesEveryMonth': 'Da 100 minuti al mese',
  'pricing.upgrade.bullets.from2000MinutesEveryMonth': 'Da 2000 minuti al mese',
  'pricing.upgrade.bullets.from25MinutesEveryMonth': 'Da 25 minuti al mese',
  'pricing.upgrade.bullets.from500MinutesEveryMonth': 'Da 500 minuti al mese',
  'pricing.upgrade.bullets.humanInTheLoop': 'Revisione umana',
  'pricing.upgrade.bullets.multispeakerLipSync': 'Lip-sync per più locutori',
  'pricing.upgrade.bullets.noWatermark': 'Senza filigrana',
  'pricing.upgrade.bullets.personalCustomerManager': 'Customer Manager dedicato',
  'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation': 'Traduzione simultanea in più lingue',
  'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload':
    'Caricamento della trascrizione SRT e download del file SRT',
  'pricing.upgrade.bullets.translationDictionaries': 'Dizionari di traduzione',
  'pricing.upgrade.bullets.translationPrompting': 'Istruzioni per la traduzione',
  'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers': 'Teamspace e membri illimitati',
  'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones': 'Numero illimitato di Voice Clone personalizzate',
  'pricing.upgrade.bullets.voiceCloneSettings': 'Impostazioni di Voice Clone',
  'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark':
    'Aggiungi i termini con le traduzioni preferite (oppure contrassegnali come da non tradurre)',
  'pricing.upgrade.glossary.applyToAnyProjectWithOneClick': 'Applicalo a qualsiasi progetto con un clic',
  'pricing.upgrade.glossary.createADictionaryForYourLanguagePair': 'Crea un dizionario per la tua coppia di lingue',
  'pricing.upgrade.glossary.howItWorks': 'Come funziona',
  'pricing.upgrade.glossary.howToUseDictionaryEffectively': 'su come usare efficacemente il dizionario',
  'pricing.upgrade.glossary.learnMore': 'Scopri di più',
  'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay':
    'Imposta le traduzioni una volta sola: rimarranno coerenti in tutti i video.',
  'pricing.upgrade.glossary.perfectFor': 'Ideale per',
  'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation':
    'L’83% degli utenti Business si affida a questa funzione per la precisione delle traduzioni',
  'pricing.upgrade.glossary.unlockTranslationDictionary': 'Sblocca il dizionario di traduzione',
  'pricing.upgrade.glossary.upgradeToBusiness': 'Passa a Business',
  'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary':
    'Passa a Business per creare un dizionario di traduzione',
  'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr':
    'video con terminologia e nomi di prodotto specifici o raccolte di contenuti multilingue.',
  'pricing.upgrade.lipSync.aboutLipSyncFeature': 'sulla funzione Lip-sync',
  'pricing.upgrade.lipSync.enhancedModel':
    'Nuovo modello Lip-sync avanzato: qualità da studio (consuma {multiplier} minuti per 1 minuto di video)',
  'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync': 'Ogni volto sullo schermo è perfettamente sincronizzato',
  'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther':
    'Crea contenuti professionali con il Lip-sync e altri strumenti Pro',
  'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio':
    'Il Lip-sync sincronizza i movimenti della bocca con l’audio tradotto, per un doppiaggio naturale e non sovrapposto.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth':
    'Rendi naturali i video doppiati sincronizzando i movimenti della bocca con l’audio tradotto. Disponibile con Creator Pro e i piani superiori.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookReal': 'Rendi realistici i video doppiati',
  'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage':
    'Video doppiati dall’aspetto naturale in qualsiasi lingua',
  'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters':
    'contenuti professionali in cui l’autenticità visiva è importante.',
  'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility':
    'Pubblica in qualsiasi mercato senza perdere credibilità',
  'pricing.upgrade.lipSync.seePlansWithLipSync': 'Vedi i piani con Lip-sync',
  'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple':
    'Movimenti delle labbra sincronizzati con l’audio tradotto per più locutori',
  'pricing.upgrade.lipSync.unlockLipSyncFeature': 'Sblocca la funzione Lip-sync',
  'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip':
    'Passa al piano Creator Pro per aggiungere il Lip-sync ai tuoi video e ottenere traduzioni di altissima qualità',
  'pricing.upgrade.lipSync.withLipSync': 'Con il Lip-sync:',
  'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver':
    'I tuoi contenuti sembrano nativi, non semplicemente doppiati',
  'pricing.upgrade.multilanguage.learnMoreCaption':
    '(Scopri di più)[{link}] su come usare efficacemente questa funzione',
  'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature': 'Sblocca la traduzione multilingue',
  'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer':
    'Il tuo piano consente la traduzione in 1 lingua per ogni caricamento. Passa a un piano superiore per tradurre il video in più lingue',
  'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade':
    'Hai raggiunto il limite di video gratuiti. Passa al piano Business per tradurre i tuoi video in più lingue',
  'pricing.upgrade.paywallTitles.unlockAudioExportAndMore': 'Sblocca l’esportazione dell’audio e molto altro',
  'pricing.upgrade.paywallTitles.unlockDictionaryAndMore': 'Sblocca il dizionario e molto altro',
  'pricing.upgrade.paywallTitles.unlockGlossaryAndMore': 'Sblocca il glossario e molto altro',
  'pricing.upgrade.paywallTitles.unlockLipSyncAndMore': 'Sblocca il Lip-sync e molto altro',
  'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore': 'Sblocca la traduzione multilingue e molto altro',
  'pricing.upgrade.paywallTitles.unlockPromptingAndMore': 'Sblocca le istruzioni e molto altro',
  'pricing.upgrade.paywallTitles.unlockSrtExportAndMore': 'Sblocca l’esportazione SRT e molto altro',
  'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore': 'Sblocca il caricamento SRT e molto altro',
  'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore': 'Sblocca l’esportazione dei sottotitoli e molto altro',
  'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore': 'Sblocca i Teamspace e molto altro',
  'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore':
    'Sblocca le istruzioni di traduzione e molto altro',
  'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore': 'Sblocca la durata illimitata e molto altro',
  'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore': 'Sblocca i sottotitoli video e molto altro',
  'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore': 'Sblocca le preimpostazioni vocali e molto altro',
  'pricing.upgrade.srtDownload.aboutSrtDownload': 'sul download SRT',
  'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers':
    'Versioni originali e tradotte dei sottotitoli con i locutori',
  'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads':
    'creator che hanno bisogno di varianti personalizzate dei sottotitoli, caricamenti su YouTube o flussi di montaggio esterni.',
  'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize':
    'Ottieni file di sottotitoli flessibili da modificare, personalizzare e usare ovunque.',
  'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt':
    'Ottieni il pieno controllo dei sottotitoli con i file SRT e gli strumenti Pro',
  'pricing.upgrade.srtDownload.orUpgradeToCreatorPro': 'oppure passa a Creator Pro',
  'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken':
    'File di sottotitoli in testo semplice con timestamp e testo parlato',
  'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing':
    'Segmenti di testo formattati per piattaforme video o strumenti di montaggio',
  'pricing.upgrade.srtDownload.unlockSrtDownload': 'Sblocca il download dei file .SRT',
  'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt':
    'Passa al piano Creator Pro per scaricare file SRT con i sottotitoli del video originale e di quello tradotto',
  'pricing.upgrade.srtDownload.whatYouLlGet': 'Cosa otterrai',
  'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile':
    'Scarica il file SRT → Invialo per la correzione → Carica il file aggiornato',
  'pricing.upgrade.srtUpload.howToUseSrtUpload': 'su come usare il caricamento SRT',
  'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo':
    'Aggiorna subito il testo, i tempi e le informazioni sui locutori',
  'pricing.upgrade.srtUpload.noManualCopyPaste': 'Nessun copia e incolla manuale',
  'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick':
    'Sostituisci ore di modifiche manuali con un solo clic',
  'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo':
    'team che modificano i sottotitoli esternamente e vogliono sincronizzare rapidamente gli aggiornamenti.',
  'pricing.upgrade.srtUpload.unlockSrtUpload': 'Sblocca il caricamento SRT',
  'pricing.upgrade.srtUpload.unlockSrtUploadFeature': 'Sblocca il caricamento SRT',
  'pricing.upgrade.srtUpload.updateSubtitlesInSeconds': 'Aggiorna i sottotitoli in pochi secondi',
  'pricing.upgrade.srtUpload.upgradeToCreatorPro': 'Passa a Creator Pro',
  'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair':
    'Passa al piano Creator Pro per abbinare facilmente il video ai sottotitoli esistenti e ottenere un doppiaggio accurato',
  'pricing.upgrade.srtUpload.uploadAnEditedSrtFile': 'Carica un file SRT modificato',
  'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick': 'Carica la trascrizione corretta con un solo clic.',
  'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith':
    'chiunque pubblichi su più piattaforme o lavori in team.',
  'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready':
    'Esporta i sottotitoli tradotti come file SRT: già sincronizzato, già tradotto e pronto per qualsiasi flusso di lavoro.',
  'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools':
    'Ottieni l’esportazione dei sottotitoli e altri strumenti Pro',
  'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra':
    'Passa il lavoro a montatori o clienti senza ulteriori passaggi',
  'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn':
    'Pubblica su YouTube, TikTok o qualsiasi altra piattaforma in pochi minuti',
  'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport': 'Vedi i piani con esportazione dei sottotitoli',
  'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens':
    'Porta i sottotitoli ovunque si svolga il lavoro',
  'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo':
    'I timestamp rimangono perfettamente allineati con il video',
  'pricing.upgrade.subtitleExport.withSubtitleExport': 'Con l’esportazione dei sottotitoli:',
  'pricing.upgrade.teamspace.aboutTeamspaceCollaboration': 'sulla collaborazione in Teamspace',
  'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout':
    'agenzie e team che gestiscono più progetti di doppiaggio senza confusione.',
  'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace': 'Collabora con il tuo team in un unico posto.',
  'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf':
    'Contattaci per trovare il numero di Teamspace e membri più adatto al tuo team.',
  'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra':
    'Offri agli invitati l’accesso completo alle funzioni senza abbonamenti aggiuntivi',
  'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials':
    'Invita i colleghi con accessi individuali, senza condividere le credenziali',
  'pricing.upgrade.teamspace.lookingToScaleYourTeam': 'Vuoi espandere il tuo team?',
  'pricing.upgrade.teamspace.orContactUs': 'oppure contattaci',
  'pricing.upgrade.teamspace.orUpgradeToBusiness': 'oppure passa a Business',
  'pricing.upgrade.teamspace.scaleYourTeam': 'Espandi il tuo team',
  'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60':
    'I team riducono del 60% il tempo dedicato al coordinamento dei progetti',
  'pricing.upgrade.teamspace.unlockTeamspaces': 'Sblocca i Teamspace',
  'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5':
    'Passa a Business per ottenere un Teamspace con 5 posti oppure aggiungi i posti necessari.',
  'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith':
    'Passa a Creator Pro per avere un Teamspace con un massimo di 3 membri',
  'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember':
    'Passa a Enterprise per personalizzare i Teamspace e i limiti dei membri oppure aggiungi i posti necessari.',
  'pricing.upgrade.teamspace.workBetterTogether': 'Lavorate meglio insieme',
  'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd':
    'Lavora senza interruzioni su progetti condivisi, senza continui trasferimenti di file',
  'pricing.upgrade.texts.choosePlan': 'Scegli un piano',
  'pricing.upgrade.texts.contactUs': 'Contattaci',
  'pricing.upgrade.texts.everythingInBusinessPlus': 'Tutto ciò che include Business, più:',
  'pricing.upgrade.texts.everythingInCreatorPlus': 'Tutto ciò che include Creator, più:',
  'pricing.upgrade.texts.everythingInCreatorProPlus': 'Tutto ciò che include Creator Pro, più:',
  'pricing.upgrade.texts.everythingInTrialPlus': 'Tutto ciò che include Trial, più:',
  'pricing.upgrade.texts.orChoosePlan': 'oppure scegli un piano',
  'pricing.upgrade.texts.upgradeToBusinessPlan': 'Passa al piano Business',
  'pricing.upgrade.texts.upgradeToCreatorPlan': 'Passa al piano Creator',
  'pricing.upgrade.texts.upgradeToCreatorProPlan': 'Passa al piano Creator Pro',
  'pricing.upgrade.texts.withTheBusinessPlanYouLlGet': 'Con il piano Business otterrai:',
  'pricing.upgrade.texts.withTheCreatorPlanYouLlGet': 'Con il piano Creator otterrai:',
  'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet': 'Con il piano Creator Pro otterrai:',
  'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd':
    'Il dizionario salva nomi del brand, termini di prodotto e frasi chiave e li usa in modo coerente in ogni progetto.',
  'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain':
    'Correggi un termine una sola volta e non dovrai più farlo',
  'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro':
    'Ottieni traduzioni coerenti con il dizionario e altri strumenti Pro',
  'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross':
    'Non dovrai più modificare gli stessi termini in progetti diversi',
  'pricing.upgrade.translationDictionary.seePlansWithDictionary': 'Vedi i piani con dizionario',
  'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand':
    'team e creator che utilizzano una terminologia specifica o il linguaggio del proprio brand.',
  'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect':
    'Traduzioni che suonano come te, non solo corrette',
  'pricing.upgrade.translationDictionary.withDictionary': 'Con il dizionario:',
  'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage':
    'La voce del tuo brand rimane coerente in ogni lingua',
  'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot':
    'Contenuti che sembrano scritti per quel pubblico, non tradotti',
  'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther':
    'Controlla meglio le traduzioni con le istruzioni e altri strumenti Pro',
  'pricing.upgrade.translationTone.lessEditingAfterEveryDub': 'Meno modifiche dopo ogni doppiaggio',
  'pricing.upgrade.translationTone.seePlansWithPrompting': 'Vedi i piani con istruzioni',
  'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows':
    'team con flussi di localizzazione continuativi.',
  'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd':
    'Indicaci il tono, il pubblico e il contesto per ottenere una traduzione adatta ai tuoi contenuti, non soltanto alle parole.',
  'pricing.upgrade.translationTone.translationsThatSoundLikeYou': 'Traduzioni che suonano come te',
  'pricing.upgrade.translationTone.withPrompting': 'Con le istruzioni:',
  'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage': 'Il tuo tono viene mantenuto in ogni lingua',
  'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews':
    'qualsiasi contenuto più lungo di un minuto: tutorial, interviste o corsi.',
  'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview': 'Doppia l’intero video, non solo un’anteprima',
  'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd': 'Ogni parola e ogni locutore, fino alla fine',
  'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools':
    'Ottieni il doppiaggio integrale e altri strumenti Pro',
  'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit':
    'Nessun contenuto tagliato per rispettare un limite di tempo',
  'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength': 'Vedi i piani con durata illimitata',
  'pricing.upgrade.unlimitedLength.withUnlimitedLength': 'Con la durata illimitata:',
  'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo':
    'L’intero video, completamente doppiato e pronto per la pubblicazione',
  'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid':
    'La prova mostra l’anteprima di 1 minuto. Con un piano a pagamento, Rask doppia l’intero file: nessun taglio e nessuna parte mancante.',
  'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations':
    'brand e creator che hanno bisogno di traduzioni in linea con la propria identità senza modifiche intensive.',
  'pricing.upgrade.userPrompting.controlYourTranslation': 'Controlla la tua traduzione',
  'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5':
    'Gli utenti Enterprise confermano le modifiche alle traduzioni fino a 5× più velocemente',
  'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology': 'Guida la scelta delle parole e la terminologia',
  'pricing.upgrade.userPrompting.howToUsePromptingEffectively': 'su come usare efficacemente i prompt',
  'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice':
    'Fai in modo che i tuoi video doppiati rispecchino la voce del tuo brand.',
  'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations':
    'Definisci tono, stile e contesto delle traduzioni tramite le istruzioni. Scegli uno dei nostri modelli o scrivi un’istruzione personalizzata in base alle tue esigenze.',
  'pricing.upgrade.userPrompting.setToneAndFormalityLevel': 'Imposta il tono e il livello di formalità',
  'pricing.upgrade.userPrompting.unlockTranslationPrompting': 'Sblocca le istruzioni di traduzione',
  'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature': 'Sblocca le istruzioni di traduzione',
  'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts':
    'Usa modelli pronti oppure scrivi istruzioni personalizzate',
  'pricing.upgrade.videoSubtitles.unlockCaptionsFeature': 'Sblocca la funzione sottotitoli',
  'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith':
    'Passa a Creator Pro per scaricare video con sottotitoli',
  'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary': 'sulla libreria di Voice Clone',
  'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents': 'Regola l’espressività o rimuovi gli accenti',
  'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining':
    'Creator che doppiano in più lingue e brand che mantengono la stessa voce in tutti i contenuti.',
  'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro':
    'Migliora i doppiaggi con questa funzione e altri strumenti Pro',
  'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery':
    'Fai suonare la tua voce clonata esattamente come desideri, ogni volta.',
  'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects':
    'Riutilizza le tue voci clonate in un numero illimitato di progetti',
  'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes':
    'Salva cloni vocali personalizzati o creane di nuovi da zero',
  'pricing.upgrade.voicePresets.unlockMoreVoiceClones': 'Sblocca altre Voice Clone',
  'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary': 'Sblocca la libreria di Voice Clone',
  'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10':
    'Passa a Business per salvare fino a 10 Voice Clone personalizzate',
  'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom':
    'Passa a Creator Pro per creare una Voice Clone personalizzata',
  'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice':
    'Passa a Enterprise per salvare un numero illimitato di Voice Clone personalizzate',
  'pricing.upgrade.voicePresets.whatYouCanDo': 'Cosa puoi fare',
  'pricing.yearly.buyMinutes': 'Acquista minuti aggiuntivi in qualsiasi momento',
  'pricing.yearly.keepMinutes': 'Nessun minuto perso a fine mese',
  'pricing.yearly.only': 'SOLO PIANI ANNUALI',
  'pricing.yearly.unlimitedEditing': 'Modifiche e ridoppiaggi illimitati',
};

const ru: Record<keyof typeof en, string> = {
  'billing.confirm.amountDue': 'Сумма к оплате сегодня',
  'billing.confirm.and': 'и',
  'billing.confirm.boostersTerms': 'Условия использования бустеров',
  'billing.confirm.confirm': 'Подтвердить',
  'billing.confirm.discountHint': 'Скидка {percent} % применяется только к первому счету.',
  'billing.confirm.havePromo': 'Есть промокод?',
  'billing.confirm.hideDetails': 'Скрыть детали',
  'billing.confirm.invalidPromo': 'Промокод недействителен',
  'billing.confirm.monthlyFrom': 'Ежемесячно с {date}',
  'billing.confirm.noCharges': 'Нет предстоящих списаний за бустеры',
  'billing.confirm.noChargesDescription': 'После подтверждения у вас не будет активных бустеров.',
  'billing.confirm.oneTimeHint': 'Единовременный платеж покрывает использование до конца расчетного цикла.',
  'billing.confirm.paymentMethod': 'Способ оплаты',
  'billing.confirm.perMonth': '/месяц',
  'billing.confirm.perYear': '/год',
  'billing.confirm.privacy': 'Политика конфиденциальности',
  'billing.confirm.promoFailed': 'Не удалось применить промокод',
  'billing.confirm.promoLine': 'Промокод {code}',
  'billing.confirm.promoPlaceholder': 'Промокод',
  'billing.confirm.promotionTerms': 'Условия акции',
  'billing.confirm.remove': '(удалено)',
  'billing.confirm.removeItem': 'Удаление: {item}',
  'billing.confirm.renews': 'Продлевается автоматически до отмены',
  'billing.confirm.subscribe': 'Оформить подписку с обязательством оплатить',
  'billing.confirm.taxHint': 'Итоговая сумма включает налоги, рассчитанные на основании ваших платежных данных.',
  'billing.confirm.terms': 'Условия использования',
  'billing.confirm.termsIntro': 'Подтверждая, вы соглашаетесь со следующими документами Rask AI:',
  'billing.confirm.updatePayment': 'Пожалуйста, обновите способ оплаты',
  'billing.confirm.vat': 'НДС {percent}',
  'billing.confirm.viewDetails': 'Посмотреть детали',
  'billing.confirm.yearlyFrom': 'Ежегодно с {date}',
  'billing.error.authentication': 'Аутентификация платежа не удалась. Нам не удалось подтвердить платеж в вашем банке.',
  'billing.error.bankDeclined': 'Платеж отклонен вашим банком. Банк не одобрил эту операцию.',
  'billing.error.cardCannotBeUsed': 'Эту карту нельзя использовать',
  'billing.error.cardDetails':
    'Данные карты неверны. Пожалуйста, проверьте номер карты, срок ее действия и код безопасности.',
  'billing.error.changePayment': 'Измените способ оплаты',
  'billing.error.editPayment': 'Изменить способ оплаты',
  'billing.error.failed': 'Платеж не выполнен',
  'billing.error.insufficient':
    'Платеж не выполнен — недостаточно средств или достигнут лимит. Ваш банк отклонил платеж из-за низкого баланса или лимита расходов.',
  'billing.error.retryPayment': 'Попробуйте еще раз или измените способ оплаты.',
  'billing.result.canClose': 'Вы можете закрыть это модальное окно в любое время.',
  'billing.result.closeWindow': 'Закрыть окно',
  'billing.result.processing': 'Мы обрабатываем ваш заказ',
  'billing.result.processingDescription':
    'Это может занять несколько минут. Мы продолжим обработку в фоновом режиме и автоматически активируем вашу подписку после ее завершения.',
  'billing.result.success': 'Платеж успешно обработан',
  'billing.result.viewInvoice': 'Посмотреть счет',
  'bookDemo.booked': 'Встреча забронирована!',
  'bookDemo.bookedFor': 'Встреча забронирована на {slot}',
  'bookDemo.coverDescription':
    'ваши задачи по локализации, оптимальный способ решать их с помощью Rask, работу сервиса в вашей команде и понятную структуру тарифов.',
  'bookDemo.coverTitle': 'Что мы рассмотрим:',
  'bookDemo.inviteSent': 'На вашу электронную почту было отправлено приглашение со ссылкой на встречу.',
  'bookDemo.seeYou': 'До скорой встречи',
  'bookDemo.subtitle':
    'Мы обсудим ваш рабочий процесс, покажем неочевидные возможности и подберем оптимальный тариф под ваши задачи.',
  'bookDemo.timeBenefit': '30-минутная демонстрация сэкономит вам около 5 часов знакомства с продуктом.',
  'bookDemo.title': 'Запишитесь на демо-встречу с нашим специалистом',
  'pricing.actions.contactUs': 'Свяжитесь с нами',
  'pricing.actions.downgrade': 'Перейти на тариф ниже',
  'pricing.actions.getStarted': 'Начать',
  'pricing.actions.renew': 'Продлить',
  'pricing.actions.switchAnnual': 'Перейти на годовой',
  'pricing.actions.switchMonthly': 'Перейти на ежемесячный',
  'pricing.actions.upgrade': 'Перейти на тариф выше',
  'pricing.archived.description': 'Сейчас у вас архивный тариф {plan}. Включено минут: {count}.',
  'pricing.archived.hint': 'Продолжайте пользоваться им или перейдите на новый тариф.',
  'pricing.billing.annual': 'Ежегодно',
  'pricing.billing.aria': 'Расчетный период',
  'pricing.billing.billAnnual': 'Оплата раз в год',
  'pricing.billing.billedAnnually': 'Оплата за год',
  'pricing.billing.monthly': 'Ежемесячно',
  'pricing.billing.payAnnual': 'Оплачивать ежегодно',
  'pricing.booster.addForMonth': 'Добавить за {price} в месяц',
  'pricing.buyMinutes.benefitRemain': 'Неиспользованные минуты останутся на счете, даже если вы приостановите подписку',
  'pricing.buyMinutes.benefitRollOver': 'Мы перенесем неиспользованные минуты на следующий месяц',
  'pricing.buyMinutes.checkout': 'Перейти к оплате',
  'pricing.buyMinutes.minutes': 'Минуты',
  'pricing.buyMinutes.newPricingDescription': 'Оцените новые тарифы с гибкими пакетами минут и новыми возможностями!',
  'pricing.buyMinutes.newPricingTitle': 'Мы запустили новые тарифы!',
  'pricing.buyMinutes.payLess': 'Платить меньше',
  'pricing.buyMinutes.payOnly': 'Всего {price} за минуту!',
  'pricing.buyMinutes.perMinute': '{price}/мин',
  'pricing.buyMinutes.price': 'Стоимость',
  'pricing.buyMinutes.title': 'Купить дополнительные минуты',
  'pricing.buyMinutes.upgradeDescription': 'Перейдите на более высокий тариф и платите меньше за дополнительные минуты',
  'pricing.cancelDowngrade.button': 'Отменить понижение тарифа',
  'pricing.cancelDowngrade.currentDescription':
    'Сейчас у вас тариф {plan} за {price} с оплатой {interval}; он активен до {date}.',
  'pricing.cancelDowngrade.currentTitle': 'Текущий тариф',
  'pricing.cancelDowngrade.hint': 'Понижение тарифа можно снова запланировать в любое время.',
  'pricing.cancelDowngrade.scheduledDescription':
    'Переход на тариф {plan} за {price} с оплатой {interval} запланирован на {date}. Если отменить переход, текущая подписка на тариф {currentPlan} продолжит действовать.',
  'pricing.cancelDowngrade.scheduledTitle': 'Запланированный тариф',
  'pricing.cancelDowngrade.success': 'Изменение подписки отменено. Тариф {plan} останется активным.',
  'pricing.change.activeUntil': 'Ваш текущий тариф остаётся активным до {date}.',
  'pricing.change.boosterDescription':
    'Загрузка и скачивание SRT теперь включены в ваш тариф без дополнительной оплаты. Мы автоматически отключим соответствующий бустер.',
  'pricing.change.boosterIncluded': 'Бустер включён в тариф!',
  'pricing.change.changeSuccess': 'Тариф изменён',
  'pricing.change.current': 'Текущий тариф',
  'pricing.change.currentDescription': 'Сейчас у вас тариф {plan} с оплатой {interval}; он активен до {date}.',
  'pricing.change.downgradeDescription':
    'Вы переходите на тариф {plan} с оплатой {interval}. Изменение вступит в силу в конце текущего расчётного периода.',
  'pricing.change.downgradeError': 'Не удалось перейти на более дешёвый тариф:',
  'pricing.change.downgradeSuccess': 'Понижение тарифа запланировано',
  'pricing.change.featuresLost': 'Возможности, которые станут недоступны',
  'pricing.change.monthly': 'раз в месяц',
  'pricing.change.new': 'Новый тариф',
  'pricing.change.scheduleDowngrade': 'Запланировать понижение тарифа',
  'pricing.change.switchBack': 'Вы сможете вернуться к предыдущему тарифу начиная с {date}.',
  'pricing.change.upgradeDescription':
    'Вы переходите на тариф {plan} с оплатой {interval}. Сразу станут доступны новые возможности и дополнительные минуты: {count} (разница между тарифами).',
  'pricing.change.upgradeError': 'Не удалось перейти на тариф выше:',
  'pricing.change.upgradeNow': 'Перейти на тариф выше',
  'pricing.change.upgradePaidSuccess': 'Платёж успешно обработан, тариф повышен',
  'pricing.change.upgradeSuccess': 'Тариф изменён',
  'pricing.change.yearly': 'раз в год',
  'pricing.compare.credits': 'Кредиты и генерации',
  'pricing.compare.editor': 'Редактор',
  'pricing.compare.extraMinutes': 'Дополнительные минуты',
  'pricing.compare.minutesIncluded': 'Включённые минуты',
  'pricing.compare.plans': 'Сравнить планы',
  'pricing.compare.row.api': 'API и интеграции',
  'pricing.compare.row.apiDescription':
    'Подключите Rask к существующим инструментам и автоматизируйте рабочий процесс.',
  'pricing.compare.row.autoCut': 'Автомонтаж с ИИ',
  'pricing.compare.row.autoCutDescription': 'Автоматически убирает слова-паразиты и паузы из записей.',
  'pricing.compare.row.autoZoom': 'Автозум',
  'pricing.compare.row.autoZoomDescription':
    'Автоматически приближает область, где происходит действие, во время записи.',
  'pricing.compare.row.controls': 'Управление сценарием, субтитрами и голосом',
  'pricing.compare.row.controlsDescription': 'Редактируйте расшифровку, таймкоды, метки спикеров и настройки голоса.',
  'pricing.compare.row.extraDescription': 'Вы можете купить дополнительные минуты в любое время на годовых планах.',
  'pricing.compare.row.glossary': 'Глоссарий и терминология',
  'pricing.compare.row.glossaryDescription':
    'Сохраняйте пользовательские термины, чтобы одни и те же слова каждый раз переводились одинаково.',
  'pricing.compare.row.lipSync': 'Липсинк для нескольких спикеров',
  'pricing.compare.row.lipSyncDescription':
    'Синхронизирует движения губ с переведённым аудио, чтобы дубляж выглядел естественнее.',
  'pricing.compare.row.minutes': 'Минуты локализации за год',
  'pricing.compare.row.minutesDescription':
    'Годовой объём минут для перевода или озвучки. На годовых тарифах Business все минуты начисляются сразу.',
  'pricing.compare.row.minutesTitle': 'Минуты локализации, включённые в годовой план',
  'pricing.compare.row.multiLanguage': 'Многоязычный рабочий процесс',
  'pricing.compare.row.multiLanguageDescription': 'Переведите одно видео на несколько языков в одном проекте.',
  'pricing.compare.row.prompting': 'Инструкции для перевода',
  'pricing.compare.row.promptingDescription':
    'Добавьте инструкции перед переводом, чтобы задать контекст: тон, степень формальности и формулировки.',
  'pricing.compare.row.review': 'Проверка и согласование',
  'pricing.compare.row.reviewDescription':
    'Передавайте переведённые материалы на проверку и согласование перед публикацией.',
  'pricing.compare.row.screenRecorder': 'Запись экрана с ИИ',
  'pricing.compare.row.screenRecorderDescription': 'Записывайте экран и видео с камеры прямо в Rask.',
  'pricing.compare.row.security': 'Безопасность и закупки',
  'pricing.compare.row.securityDescription':
    'Поддержка договоров, выставления счетов и документации для подтверждения соответствия требованиям.',
  'pricing.compare.row.speed': 'Скорость обработки',
  'pricing.compare.row.speedDescription': 'Насколько быстро ваши видео обрабатываются и рендерятся.',
  'pricing.compare.row.srt': 'Импорт и экспорт SRT',
  'pricing.compare.row.srtDescription': 'Скачивайте файлы субтитров или загружайте свои для синхронизации с озвучкой.',
  'pricing.compare.row.srtTitle': 'Импорт и экспорт SRT',
  'pricing.compare.row.team': 'Рабочее пространство команды',
  'pricing.compare.row.teamDescription':
    'Приглашайте коллег по команде работать над проектами в одном общем пространстве.',
  'pricing.compare.row.voices': 'Сохраненные пользовательские голоса',
  'pricing.compare.row.voicesDescription':
    'Сохраняйте клонированные голоса, чтобы их можно было повторно использовать в будущих проектах.',
  'pricing.compare.showAll': 'Посмотреть все функции',
  'pricing.compare.showLess': 'Показать меньше',
  'pricing.compare.subtitle': 'Выберите план, соответствующий частоте публикаций.',
  'pricing.compare.support': 'Поддержка и командная работа',
  'pricing.compare.title': 'Сравните, что меняется при масштабировании',
  'pricing.compare.value.compliance': 'SSO, DPA, проверка соответствия',
  'pricing.compare.value.customBatch': 'Индивидуальные процессы пакетной обработки',
  'pricing.compare.value.customIntegrations': 'Индивидуальные интеграции',
  'pricing.compare.value.customRoles': 'Настраиваемые роли',
  'pricing.compare.value.dedicated': 'Выделенная / приоритетная очередь',
  'pricing.compare.value.extraMinute': '$3/мин',
  'pricing.compare.value.fiveMembers': 'До 5 участников + приглашённые проверяющие',
  'pricing.compare.value.fullApi': 'Полный доступ к API',
  'pricing.compare.value.included': 'Включено',
  'pricing.compare.value.managedQa': 'Управляемый контроль качества / согласование профильным экспертом',
  'pricing.compare.value.managedTerms': 'Управляемый терминологический рабочий процесс',
  'pricing.compare.value.multiBatch': 'Пакетная обработка нескольких видео на нескольких языках',
  'pricing.compare.value.personalGlossary': 'Персональный глоссарий',
  'pricing.compare.value.priorityQueue': 'Приоритетная очередь',
  'pricing.compare.value.reviewer': 'Роли проверяющих и согласование',
  'pricing.compare.value.sandboxApi': 'Ограниченный доступ к API в песочнице',
  'pricing.compare.value.sharedGlossary': 'Общий глоссарий бренда',
  'pricing.compare.value.sharedVoices': '10 общих командных голосов',
  'pricing.compare.value.standard': 'Стандартный уровень',
  'pricing.compare.value.standardQueue': 'Стандартная очередь',
  'pricing.compare.value.three': '3',
  'pricing.compare.value.threeMembers': 'До 3 участников',
  'pricing.compare.value.unlimited': 'Без ограничений',
  'pricing.compare.value.upgradePro': 'Перейти на Pro',
  'pricing.compare.value.voiceLibrary': 'Библиотека пользовательских голосов',
  'pricing.compare.whatChanges': 'Что меняется',
  'pricing.enterprisePayment.contactSupport': 'Обратитесь в чат поддержки или напишите нам по адресу',
  'pricing.enterprisePayment.unknownError': 'Неизвестная ошибка',
  'pricing.feature.aiRewriter': 'Корректировка сценария с помощью ИИ',
  'pricing.feature.allBusiness': 'Все функции Business, а также:',
  'pricing.feature.allCreator': 'Все функции Creator, а также:',
  'pricing.feature.allCreatorPro': 'Все функции Creator Pro, а также:',
  'pricing.feature.api': 'API',
  'pricing.feature.applyChanges': 'Применить изменения бесплатно',
  'pricing.feature.businessContract': 'Деловой договор и выставление счетов',
  'pricing.feature.captions': 'Автоматические субтитры',
  'pricing.feature.customerSuccess': 'Менеджер по работе с клиентами',
  'pricing.feature.dictionary': 'Словарь переводов',
  'pricing.feature.editor': 'Продвинутый видеоредактор',
  'pricing.feature.flexibleMinutes': 'Гибкие цены на минуты',
  'pricing.feature.humanReview': 'Проверка человеком',
  'pricing.feature.languages': 'Переводы на 135+ языков',
  'pricing.feature.languagesDescription':
    'Доступность языков зависит от того, используете ли вы ИИ-голоса или Voice Clone.',
  'pricing.feature.learnMore': 'Узнать больше',
  'pricing.feature.lipSync': 'Липсинк для нескольких спикеров',
  'pricing.feature.machineTranslation': 'Машинный перевод',
  'pricing.feature.multiLanguage': 'Одновременный перевод на несколько языков',
  'pricing.feature.noWatermark': 'Нет водяного знака',
  'pricing.feature.onlyVideoDownload': 'Только скачивание видео',
  'pricing.feature.priority': 'Приоритетная обработка',
  'pricing.feature.prompting': 'Инструкции для перевода',
  'pricing.feature.readDocs': 'Читать документацию',
  'pricing.feature.speechToText': 'Автоматическая транскрипция речи в текст',
  'pricing.feature.srtDownload': 'Скачивание SRT',
  'pricing.feature.srtDownloadUpload': 'Скачивание и загрузка SRT',
  'pricing.feature.srtUpload': 'Загрузка SRT',
  'pricing.feature.support': 'Поддержка 24/7',
  'pricing.feature.teamspace3': '1 Teamspace, 3 участника',
  'pricing.feature.teamspace5': '1 Teamspace, 5 участников',
  'pricing.feature.teamspaces': 'Командные пространства',
  'pricing.feature.voiceClones10': '10 пользовательских голосовых клонов',
  'pricing.feature.voiceClones3': '3 пользовательских голосовых клона',
  'pricing.feature.voiceCloning': 'Клонирование голоса на 32 языках',
  'pricing.feature.voiceCloningDescription':
    'Доступно 32 языка, включая английский, испанский, французский, итальянский, португальский и русский.',
  'pricing.feature.voiceLibrary': 'Библиотека голосовых клонов',
  'pricing.feature.voiceSettings': 'Настройки клонированного голоса',
  'pricing.feature.watermark': 'Водяной знак',
  "pricing.featurePaywall.controlDownload.formats": "Любой формат в любое время",
  "pricing.featurePaywall.controlDownload.fullVideo": "Экспорт всего видео, а не только превью",
  "pricing.featurePaywall.controlDownload.share": "Поделиться бесплатно",
  "pricing.featurePaywall.controlDownload.subtitle": "Перейдите на платный тариф, чтобы скачивать видео без водяного знака и без ограничений, или поделитесь им бесплатно",
  "pricing.featurePaywall.controlDownload.title": "Разблокируйте экспорт полного видео или поделитесь им бесплатно",
  "pricing.featurePaywall.controlDownload.unlock": "Разблокировать экспорт видео",
  "pricing.featurePaywall.controlDownload.watermark": "Без водяного знака",
  'pricing.header.description':
    'Каждый тариф включает перевод видео на любой язык, клонирование голоса с сохранением эмоций и бесплатные удобные инструменты управления.',
  'pricing.header.title': 'Тарифы, которые растут вместе с объёмом вашего видеоконтента',
  'pricing.legacy.businessFeature1': 'Обеспечьте единообразие тона бренда',
  'pricing.legacy.businessFeature2': 'Управляйте терминологией в переводах',
  'pricing.legacy.businessFeature3': 'Обрабатывайте большие объёмы контента быстрее, чем когда-либо',
  'pricing.legacy.creatorFeature1': 'Дублируйте более чем на 135 языках с помощью ИИ',
  'pricing.legacy.creatorFeature2': 'Клонируйте голоса на 32 языках',
  'pricing.legacy.creatorFeature3': 'Мощный редактор без ограничений',
  'pricing.legacy.creatorFeature4': 'Автоматическая транскрипция и перевод',
  'pricing.legacy.creatorProFeature1': 'Добавьте липсинк и субтитры',
  'pricing.legacy.creatorProFeature2': 'Используйте профессиональные инструменты для работы с голосом и сценарием',
  'pricing.legacy.creatorProFeature3': 'Работайте вместе в общем пространстве',
  'pricing.legacy.enterpriseFeature1': 'Заключайте индивидуальные договоры и получайте счета',
  'pricing.legacy.enterpriseFeature2': 'Получите приоритетную поддержку от выделенной команды',
  'pricing.legacy.enterpriseFeature3': 'Настройте все в соответствии с вашими потребностями',
  'pricing.legacy.everythingBusiness': 'Всё из тарифа Business, а также:',
  'pricing.legacy.everythingCreator': 'Всё из тарифа Creator, а также:',
  'pricing.legacy.everythingCreatorPro': 'Всё из тарифа Creator Pro, а также:',
  'pricing.limits.enterprise.contactOrSelectPlan':
    'Свяжитесь с нашим специалистом по партнерствам по адресу {email} или выберите один из тарифов.',
  'pricing.limits.enterprise.notEnoughMinutes': 'У вас недостаточно минут для перевода этого видео.',
  'pricing.limits.enterprise.notEnoughMinutesShort': 'Недостаточно минут для перевода этого видео.',
  'pricing.limits.enterprise.purchaseMore':
    'Чтобы купить дополнительные минуты, свяжитесь с нашим специалистом по партнерствам: {email}',
  'pricing.limits.enterprise.ranOut': 'Минуты на вашем тарифе закончились.',
  'pricing.limits.enterprise.renewAccess':
    'Чтобы возобновить доступ, свяжитесь с нашим специалистом по партнерствам по адресу {email}.',
  'pricing.limits.enterprise.renewOrSelectPlan':
    'Свяжитесь с нашим специалистом по партнерствам по адресу {email}, чтобы возобновить доступ, или выберите один из тарифов.',
  'pricing.limits.exploreFullVersion': 'Откройте полную версию с расширенными возможностями',
  'pricing.limits.feature.lipSyncBeta': 'Применяйте липсинк (бета)',
  'pricing.limits.feature.noTrialLimits': 'Загружайте файлы без ограничений пробного периода',
  'pricing.limits.feature.proofread': 'Проверяйте текст перед дубляжом',
  'pricing.limits.feature.srtUpload': 'Загружайте SRT-файл вместе с видео',
  'pricing.limits.feature.translation130': 'Переводите на 135+ языков',
  'pricing.limits.feature.voiceClone28': 'Используйте Voice Clone на 32 языках',
  'pricing.limits.freeVideoLimit': 'Вы достигли лимита бесплатных видео.',
  'pricing.limits.notEnoughMinutes': 'Недостаточно доступных минут для перевода видео.',
  'pricing.limits.paymentFailed':
    'Не удалось обработать платеж за продление подписки. Обновите платежные данные, чтобы продолжить пользоваться Rask.',
  'pricing.limits.renewSubscription': 'Продлить подписку',
  'pricing.limits.spaceUnsupported':
    'Ваш текущий тариф не поддерживает это пространство. Повысьте тариф, чтобы продолжить работу.',
  'pricing.limits.subscriptionCanceled': 'Ваша подписка отменена.',
  'pricing.limits.subscriptionCanceledDescription':
    'Мы заморозили минуты на вашем счете. Продлите подписку, чтобы продолжить пользоваться Rask и расходовать минуты.',
  'pricing.limits.subscriptionExpired':
    'Срок действия подписки истек. Продлите ее, чтобы продолжить пользоваться Rask.',
  'pricing.limits.subscriptionPaused':
    'Ваша подписка приостановлена, а минуты на счете заморожены. Продлите подписку, чтобы продолжить пользоваться Rask и расходовать минуты.',
  'pricing.limits.translationMinuteLimit': 'Вы достигли лимита минут для перевода.',
  'pricing.limits.unlockFullVersion': 'Открыть полную версию',
  'pricing.limits.updatePayment': 'Обновить платежные данные',
  'pricing.limits.upgradeForMoreVideos': 'Повысьте тариф, чтобы переводить больше видео',
  'pricing.limits.upgradeForMoreVideosTitle': 'Повысьте тариф, чтобы переводить больше видео:',
  'pricing.limits.upgradePlanForMoreVideos': 'Повысьте тариф, чтобы переводить больше видео',
  'pricing.limits.upgradeToContinue': 'Повысьте тариф, чтобы продолжить создавать контент.',
  'pricing.limits.whiteLabelInactive':
    'Ваша подписка больше не активна. Для получения помощи обратитесь по адресу {email}.',
  'pricing.limits.whiteLabelOutOfMinutes': 'Недостаточно минут. Пополните баланс минут.',
  'pricing.minutes.custom': 'Индивидуально',
  'pricing.minutes.from': 'От {count} мин.',
  'pricing.minutes.fromMonthly': 'От {count} мин. в месяц',
  'pricing.minutes.included': 'В тариф включено {count} мин.',
  'pricing.modal.closeAria': 'Закрыть',
  'pricing.notActive.checkBoosters': 'Посмотреть другие бустеры',
  'pricing.notActive.closeAria': 'Закрыть предложение о приглашении команды',
  'pricing.notActive.paidDescription': 'Добавьте участников к подписке и работайте вместе в общем пространстве!',
  'pricing.notActive.title': 'Вместе лучше. Пригласите команду!',
  'pricing.notActive.trialDescription':
    'Создавайте отдельные рабочие пространства, приглашайте коллег и вместе управляйте проектами в Teamspaces.',
  'pricing.notActive.trialPaywallTitle': 'Раскройте потенциал команды',
  'pricing.notActive.unlockTeamspaces': 'Откройте Teamspaces с тарифом Creator Pro',
  'pricing.pause.chargeDescription':
    'Следующее списание {price} по исходному тарифу с оплатой {interval} произойдёт {date}.',
  'pricing.pause.description':
    'Подписка возобновится {date}. Данные аккаунта будут надежно храниться до ее возобновления.',
  'pricing.pause.nextBillingDate': 'в следующую дату оплаты',
  'pricing.pause.resumeNow': 'Возобновить подписку сейчас',
  'pricing.pause.resumeTitle': 'Хотите возобновить подписку?',
  'pricing.pause.success': 'Подписка возобновлена.\nСледующее списание произойдёт в дату продления подписки.',
  'pricing.pause.title': 'Ваша подписка приостановлена',
  'pricing.paywall.enterpriseQuestion': 'Переводите более 1 000 минут в месяц?',
  'pricing.paywall.feature.api': 'Доступ к API',
  'pricing.paywall.feature.customVoiceClone': 'Настройте клонированный голос и сохраните его в библиотеке',
  'pricing.paywall.feature.dictionary': 'Сохраняйте собственные переводы в словаре',
  'pricing.paywall.feature.lipSync': 'Применить липсинк',
  'pricing.paywall.feature.srtDownload': 'Скачивайте субтитры в формате SRT',
  'pricing.paywall.feature.srtUpload': 'Загружайте SRT-файл вместе с видео',
  'pricing.paywall.feature.subtitles': 'Добавляйте субтитры к видео',
  'pricing.paywall.feature.teamspacesSoon': 'Создавайте командные пространства и работайте вместе с командой',
  'pricing.paywall.feature.translation130': 'Переводите видео и аудио на 135+ языков',
  'pricing.paywall.feature.voiceClone29': 'Клонирование голоса на 32 языках',
  'pricing.paywall.queueTitle': 'Очередь для бесплатных пользователей сейчас перегружена',
  'pricing.paywall.requestEnterpriseDemo': 'Запросить демо Enterprise',
  'pricing.paywall.upgradeTitle': 'Перейдите на более высокий тариф, чтобы получить полный доступ!',
  'pricing.paywall.viewPlans': 'Посмотреть тарифы',
  'pricing.plan.bestForBeginners': 'Лучший выбор для начинающих',
  'pricing.plan.bestForIndividuals': 'Лучший выбор для индивидуальных пользователей',
  'pricing.plan.bestValue': 'Выгодный выбор',
  'pricing.plan.business': 'Business',
  'pricing.plan.businessDescription': 'Для команд с растущей видеотекой',
  'pricing.plan.businessFeature1': 'Просматривайте проекты и управляйте ими вместе со своей командой',
  'pricing.plan.businessFeature2': 'Сохраняйте единообразие бренда и терминологии',
  'pricing.plan.businessFeature3': 'Загружайте и переводите несколько видео одновременно',
  'pricing.plan.creator': 'Creator',
  'pricing.plan.creatorDescription': 'Для авторов, работающих над небольшими проектами',
  'pricing.plan.creatorFeature1': 'Начните без настройки',
  'pricing.plan.creatorFeature2': 'Переводите одно видео на несколько языков',
  'pricing.plan.creatorFeature3': 'Перейдите на более высокий тариф, когда локализация станет регулярной',
  'pricing.plan.creatorPro': 'Creator Pro',
  'pricing.plan.creatorProDescription': 'Для регулярной публикации видео',
  'pricing.plan.creatorProFeature1': 'Контролируйте точность перевода и речи',
  'pricing.plan.creatorProFeature2': 'Сохраняйте индивидуальность говорящего с помощью липсинка',
  'pricing.plan.creatorProFeature3': 'Для регулярных проектов небольшой команды',
  'pricing.plan.current': 'Текущий план',
  'pricing.plan.currentOutsideGrid': 'Ваш текущий план: {plan}, {price}',
  'pricing.plan.currentShort': 'Текущий',
  'pricing.plan.enterprise': 'Enterprise',
  'pricing.plan.enterpriseDescription': 'Для работы в глобальном масштабе, где важны надёжность и предсказуемость',
  'pricing.plan.enterpriseFeature1': 'Готовность в области безопасности и соответствия требованиям',
  'pricing.plan.enterpriseFeature2': 'Надёжность в промышленной эксплуатации и SLA',
  'pricing.plan.enterpriseFeature3': 'Индивидуальные интеграции и API',
  'pricing.plan.enterpriseFeature4': 'Управляемое обеспечение качества',
  'pricing.plan.limitedOffer': 'Предложение ограничено по времени',
  'pricing.plan.mostPopular': 'Самый популярный',
  'pricing.plan.starter': 'Starter',
  'pricing.plan.starterDescription': 'Для первых шагов в простой локализации видео',
  'pricing.plan.tailoredOnboarding': 'Индивидуальное подключение и SLA',
  'pricing.plan.toggleDetails': 'Показать или скрыть сведения о тарифе',
  'pricing.plan.unlimitedRecording': 'Безлимитная запись экрана',
  'pricing.price.billedMonthly': 'счет выставляется ежемесячно',
  'pricing.price.billedYearly': 'выставляется счет на {amount} ежегодно',
  'pricing.price.custom': 'Индивидуально',
  'pricing.price.from': 'от',
  'pricing.price.perMonth': '/мес.',
  'pricing.price.perMonthLong': 'в месяц',
  'pricing.renew.happy': 'Мы рады снова вас видеть!',
  'pricing.renew.welcome': 'С возвращением!',
  'pricing.savings.year': 'Сэкономьте {amount} в год (скидка {percent}%)',
  'pricing.socialProof': 'Более {count} довольных пользователей',
  'pricing.starter.allCreator': 'Все возможности тарифа Creator',
  'pricing.starter.currentTitle': 'Тариф {plan}: {price} в месяц',
  'pricing.starter.minuteDescription':
    '1 минута = 1 минута переведённого контента. Например, для перевода минутного видео на два языка потребуется 2 минуты.',
  'pricing.starter.minuteTitle': 'Что означает минута?',
  'pricing.starter.tryTitle': 'Попробуйте тариф {plan} за {price} в месяц',
  'pricing.starter.watermarkDescription': 'В правом верхнем углу видео будет водяной знак «Translated by Rask AI».',
  'pricing.title': 'Цены',
  'pricing.trial.continue': 'Продолжить бесплатный пробный период',
  'pricing.upgrade.aiRewrite.unlockAiRewriteFeature': 'Разблокируйте функцию переписывания с помощью ИИ',
  'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl':
    'Перейдите на план Creator Pro, чтобы управлять скоростью и выравнивать сегменты с помощью ИИ по временным меткам',
  'pricing.upgrade.audioDownload.unlockAudioDownload': 'Разблокируйте скачивание аудио',
  'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated':
    'Перейдите на Creator, чтобы скачивать аудио со сгенерированным голосом или голосом и фоновым звуком',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members': '1 Teamspace до 10 участников',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members': '1 Teamspace до 5 участников',
  'pricing.upgrade.bullets.aiScriptAdjustment': 'Корректировка сценария с помощью ИИ',
  'pricing.upgrade.bullets.apiAccess': 'Доступ к API',
  'pricing.upgrade.bullets.automatedCaptionsSubtitles': 'Автоматические субтитры',
  'pricing.upgrade.bullets.businessContractAndInvoicing': 'Корпоративный договор и выставление счетов',
  'pricing.upgrade.bullets.customPriceForMinutes': 'Индивидуальная стоимость минуты',
  'pricing.upgrade.bullets.customVoiceCloneLibrary': 'Собственная библиотека клонированных голосов',
  'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices':
    'Собственная библиотека клонированных голосов (10 голосов)',
  'pricing.upgrade.bullets.downloadGeneratedVoice': 'Скачивание сгенерированного голоса',
  'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound':
    'Скачивание сгенерированного голоса с фоновым звуком',
  'pricing.upgrade.bullets.from100MinutesEveryMonth': 'От 100 минут в месяц',
  'pricing.upgrade.bullets.from2000MinutesEveryMonth': 'От 2000 минут в месяц',
  'pricing.upgrade.bullets.from25MinutesEveryMonth': 'От 25 минут в месяц',
  'pricing.upgrade.bullets.from500MinutesEveryMonth': 'От 500 минут в месяц',
  'pricing.upgrade.bullets.humanInTheLoop': 'Проверка человеком',
  'pricing.upgrade.bullets.multispeakerLipSync': 'Липсинк для нескольких спикеров',
  'pricing.upgrade.bullets.noWatermark': 'Без водяного знака',
  'pricing.upgrade.bullets.personalCustomerManager': 'Персональный менеджер по работе с клиентами',
  'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation': 'Одновременный перевод на несколько языков',
  'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload': 'Загрузка расшифровки SRT и скачивание SRT',
  'pricing.upgrade.bullets.translationDictionaries': 'Словари переводов',
  'pricing.upgrade.bullets.translationPrompting': 'Инструкции для перевода',
  'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers': 'Teamspace и участники без ограничений',
  'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones': 'Неограниченное число собственных клонированных голосов',
  'pricing.upgrade.bullets.voiceCloneSettings': 'Настройки клонирования голоса',
  'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark':
    'Добавьте термины с предпочтительными вариантами перевода или отметьте их как непереводимые',
  'pricing.upgrade.glossary.applyToAnyProjectWithOneClick': 'Примените его к любому проекту одним нажатием',
  'pricing.upgrade.glossary.createADictionaryForYourLanguagePair': 'Создайте словарь для нужной языковой пары',
  'pricing.upgrade.glossary.howItWorks': 'Как это работает',
  'pricing.upgrade.glossary.howToUseDictionaryEffectively': 'как эффективно пользоваться словарём',
  'pricing.upgrade.glossary.learnMore': 'Подробнее',
  'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay':
    'Закрепите варианты перевода один раз — и они останутся единообразными во всех видео.',
  'pricing.upgrade.glossary.perfectFor': 'Идеально для',
  'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation':
    '83% пользователей тарифа Business доверяют точности перевода',
  'pricing.upgrade.glossary.unlockTranslationDictionary': 'Разблокируйте словарь переводов',
  'pricing.upgrade.glossary.upgradeToBusiness': 'Перейдите на Business',
  'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary':
    'Перейдите на Business, чтобы создать словарь переводов',
  'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr':
    'видео со специальной терминологией и названиями продуктов, а также библиотек контента на разных языках.',
  'pricing.upgrade.lipSync.aboutLipSyncFeature': 'о функции липсинка',
  'pricing.upgrade.lipSync.enhancedModel':
    'Новая улучшенная модель липсинка студийного качества (списывает {multiplier} минут за 1 минуту видео)',
  'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync': 'Каждое лицо в кадре идеально синхронизировано',
  'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther':
    'Создавайте профессиональный контент с липсинком и другими Pro-инструментами',
  'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio':
    'Липсинк синхронизирует движения губ с переведённым аудио, чтобы дубляж выглядел естественно, а не наложенным поверх видео.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth':
    'Сделайте дубляж естественным, синхронизировав движения губ с переведённым аудио. Доступно на Creator Pro и более высоких планах.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookReal': 'Сделайте дублированные видео реалистичными',
  'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage':
    'Естественно выглядящие дублированные видео на любом языке',
  'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters':
    'профессиональный контент, для которого важна визуальная достоверность.',
  'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility':
    'Публикуйтесь на любом рынке, не теряя доверия аудитории',
  'pricing.upgrade.lipSync.seePlansWithLipSync': 'Посмотреть планы с липсинком',
  'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple':
    'Синхронизация движений губ с переведённым аудио для нескольких спикеров',
  'pricing.upgrade.lipSync.unlockLipSyncFeature': 'Разблокируйте функцию липсинка',
  'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip':
    'Перейдите на план Creator Pro, чтобы добавить липсинк в видео и получить перевод высочайшего качества',
  'pricing.upgrade.lipSync.withLipSync': 'С липсинком:',
  'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver':
    'Контент выглядит созданным на языке зрителя, а не наложенным поверх оригинала дубляжом',
  'pricing.upgrade.multilanguage.learnMoreCaption': '(Подробнее)[{link}] об эффективном использовании этой функции',
  'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature': 'Разблокируйте перевод на несколько языков',
  'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer':
    'Ваш план позволяет переводить каждую загрузку на 1 язык. Перейдите на другой план, чтобы перевести видео на несколько языков',
  'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade':
    'Вы исчерпали лимит бесплатных видео. Перейдите на план Business, чтобы переводить видео на несколько языков',
  'pricing.upgrade.paywallTitles.unlockAudioExportAndMore': 'Разблокируйте экспорт аудио и другие функции',
  'pricing.upgrade.paywallTitles.unlockDictionaryAndMore': 'Разблокируйте словарь и другие функции',
  'pricing.upgrade.paywallTitles.unlockGlossaryAndMore': 'Разблокируйте глоссарий и другие функции',
  'pricing.upgrade.paywallTitles.unlockLipSyncAndMore': 'Разблокируйте липсинк и другие функции',
  'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore':
    'Разблокируйте перевод на несколько языков и другие функции',
  'pricing.upgrade.paywallTitles.unlockPromptingAndMore': 'Разблокируйте инструкции и другие функции',
  'pricing.upgrade.paywallTitles.unlockSrtExportAndMore': 'Разблокируйте экспорт SRT и другие функции',
  'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore': 'Разблокируйте загрузку SRT и другие функции',
  'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore': 'Разблокируйте экспорт субтитров и другие функции',
  'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore': 'Разблокируйте Teamspace и другие функции',
  'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore':
    'Разблокируйте инструкции для перевода и другие функции',
  'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore':
    'Разблокируйте неограниченную длительность и другие функции',
  'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore': 'Разблокируйте субтитры в видео и другие функции',
  'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore': 'Разблокируйте пресеты голосов и другие функции',
  'pricing.upgrade.srtDownload.aboutSrtDownload': 'о скачивании SRT',
  'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers':
    'Оригинальные и переведённые версии субтитров с указанием спикеров',
  'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads':
    'авторов, которым нужны собственные варианты субтитров, загрузка на YouTube или работа во внешних редакторах.',
  'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize':
    'Получайте удобные файлы субтитров, которые можно редактировать, настраивать и использовать где угодно.',
  'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt':
    'Полностью управляйте субтитрами с помощью SRT и Pro-инструментов',
  'pricing.upgrade.srtDownload.orUpgradeToCreatorPro': 'или перейдите на Creator Pro',
  'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken':
    'Файлы субтитров в виде обычного текста с временными метками и расшифровкой речи',
  'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing':
    'Текстовые сегменты в формате для видеоплатформ и редакторов',
  'pricing.upgrade.srtDownload.unlockSrtDownload': 'Разблокируйте скачивание файлов .SRT',
  'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt':
    'Перейдите на план Creator Pro, чтобы скачивать SRT-файлы с субтитрами для оригинального и переведённого видео',
  'pricing.upgrade.srtDownload.whatYouLlGet': 'Что вы получите',
  'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile':
    'Скачайте SRT → Отправьте на исправление → Загрузите обновлённый файл',
  'pricing.upgrade.srtUpload.howToUseSrtUpload': 'как пользоваться загрузкой SRT',
  'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo':
    'Мгновенно обновите текст, тайминг и данные о спикерах',
  'pricing.upgrade.srtUpload.noManualCopyPaste': 'Без ручного копирования и вставки',
  'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick':
    'Замените часы ручного редактирования одним нажатием',
  'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo':
    'команды, которые редактируют субтитры во внешних инструментах и хотят быстро синхронизировать изменения.',
  'pricing.upgrade.srtUpload.unlockSrtUpload': 'Разблокируйте загрузку SRT',
  'pricing.upgrade.srtUpload.unlockSrtUploadFeature': 'Разблокируйте загрузку SRT',
  'pricing.upgrade.srtUpload.updateSubtitlesInSeconds': 'Обновляйте субтитры за несколько секунд',
  'pricing.upgrade.srtUpload.upgradeToCreatorPro': 'Перейдите на Creator Pro',
  'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair':
    'Перейдите на план Creator Pro, чтобы легко совместить видео с готовыми субтитрами и получить точный дубляж',
  'pricing.upgrade.srtUpload.uploadAnEditedSrtFile': 'Загрузите отредактированный SRT-файл',
  'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick': 'Загрузите исправленную расшифровку одним нажатием.',
  'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith':
    'все, кто публикуется на разных платформах или работает в команде.',
  'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready':
    'Экспортируйте переведённые субтитры в SRT-файл: тайминг и перевод уже готовы, файл можно сразу использовать в любом рабочем процессе.',
  'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools':
    'Получите экспорт субтитров и другие Pro-инструменты',
  'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra':
    'Передавайте материалы редакторам или клиентам без дополнительных действий',
  'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn':
    'Публикуйте на YouTube, TikTok и любых других платформах за считаные минуты',
  'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport': 'Посмотреть планы с экспортом субтитров',
  'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens':
    'Используйте субтитры во всех своих рабочих процессах',
  'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo':
    'Временные метки останутся идеально синхронизированы с видео',
  'pricing.upgrade.subtitleExport.withSubtitleExport': 'С экспортом субтитров:',
  'pricing.upgrade.teamspace.aboutTeamspaceCollaboration': 'о совместной работе в Teamspace',
  'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout':
    'агентства и команды, которые хотят управлять несколькими проектами дубляжа без хаоса.',
  'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace': 'Работайте со своей командой в одном пространстве.',
  'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf':
    'Свяжитесь с нами, и мы подберём подходящее число Teamspace и участников для вашей команды.',
  'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra':
    'Предоставьте приглашённым полный доступ к функциям без дополнительных подписок',
  'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials':
    'Приглашайте коллег с отдельными аккаунтами — без общих учётных данных',
  'pricing.upgrade.teamspace.lookingToScaleYourTeam': 'Хотите расширить команду?',
  'pricing.upgrade.teamspace.orContactUs': 'или свяжитесь с нами',
  'pricing.upgrade.teamspace.orUpgradeToBusiness': 'или перейдите на Business',
  'pricing.upgrade.teamspace.scaleYourTeam': 'Расширьте команду',
  'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60':
    'Команды сокращают время на координацию проектов на 60%',
  'pricing.upgrade.teamspace.unlockTeamspaces': 'Разблокируйте Teamspace',
  'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5':
    'Перейдите на Business, чтобы получить Teamspace на 5 мест, или добавьте нужное число мест.',
  'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith':
    'Перейдите на Creator Pro, чтобы создать Teamspace для команды до 3 участников',
  'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember':
    'Перейдите на Enterprise, чтобы настроить Teamspace и лимиты участников, или добавьте нужное число мест.',
  'pricing.upgrade.teamspace.workBetterTogether': 'Работайте эффективнее вместе',
  'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd':
    'Удобно работайте над общими проектами без постоянной пересылки файлов',
  'pricing.upgrade.texts.choosePlan': 'Выбрать план',
  'pricing.upgrade.texts.contactUs': 'Связаться с нами',
  'pricing.upgrade.texts.everythingInBusinessPlus': 'Всё из Business, а также:',
  'pricing.upgrade.texts.everythingInCreatorPlus': 'Всё из Creator, а также:',
  'pricing.upgrade.texts.everythingInCreatorProPlus': 'Всё из Creator Pro, а также:',
  'pricing.upgrade.texts.everythingInTrialPlus': 'Всё из Trial, а также:',
  'pricing.upgrade.texts.orChoosePlan': 'или выбрать план',
  'pricing.upgrade.texts.upgradeToBusinessPlan': 'Перейти на план Business',
  'pricing.upgrade.texts.upgradeToCreatorPlan': 'Перейти на план Creator',
  'pricing.upgrade.texts.upgradeToCreatorProPlan': 'Перейти на план Creator Pro',
  'pricing.upgrade.texts.withTheBusinessPlanYouLlGet': 'На плане Business вы получите:',
  'pricing.upgrade.texts.withTheCreatorPlanYouLlGet': 'На плане Creator вы получите:',
  'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet': 'На плане Creator Pro вы получите:',
  'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd':
    'Словарь сохраняет названия брендов, термины продуктов и ключевые фразы и единообразно использует их в каждом проекте.',
  'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain':
    'Исправьте термин один раз — и больше не возвращайтесь к нему',
  'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro':
    'Получайте единообразные переводы со словарём и другими Pro-инструментами',
  'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross':
    'Больше не придётся повторно исправлять одни и те же термины в разных проектах',
  'pricing.upgrade.translationDictionary.seePlansWithDictionary': 'Посмотреть планы со словарём',
  'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand':
    'команды и авторы, использующие специальную терминологию или лексику своего бренда.',
  'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect':
    'Переводы, которые звучат как вы, а не просто формально верны',
  'pricing.upgrade.translationDictionary.withDictionary': 'Со словарём:',
  'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage':
    'Стиль вашего бренда остаётся единообразным на всех языках',
  'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot':
    'Контент выглядит написанным для этой аудитории, а не переведённым',
  'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther':
    'Точнее управляйте переводом с помощью инструкций и других Pro-инструментов',
  'pricing.upgrade.translationTone.lessEditingAfterEveryDub': 'Меньше правок после каждого дубляжа',
  'pricing.upgrade.translationTone.seePlansWithPrompting': 'Посмотреть планы с инструкциями',
  'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows':
    'команды с постоянными процессами локализации.',
  'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd':
    'Укажите тон, аудиторию и контекст, чтобы получить перевод, подходящий вашему контенту, а не только отдельным словам.',
  'pricing.upgrade.translationTone.translationsThatSoundLikeYou': 'Переводы, которые звучат как вы',
  'pricing.upgrade.translationTone.withPrompting': 'С инструкциями:',
  'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage': 'Ваш тон сохраняется на всех языках',
  'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews':
    'любой контент длительностью больше минуты: обучающие видео, интервью или курсы.',
  'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview': 'Дублируйте всё видео, а не только предпросмотр',
  'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd': 'Каждое слово и каждый спикер — до самого конца',
  'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools':
    'Получите полный дубляж и другие Pro-инструменты',
  'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit': 'Контент не обрезается из-за ограничения по времени',
  'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength': 'Посмотреть планы с неограниченной длительностью',
  'pricing.upgrade.unlimitedLength.withUnlimitedLength': 'С неограниченной длительностью:',
  'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo':
    'Всё видео полностью дублировано и готово к публикации',
  'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid':
    'В Trial доступен предпросмотр 1 минуты. На платном плане Rask дублирует весь файл: без обрезки и пропущенных фрагментов.',
  'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations':
    'бренды и авторы, которым нужны переводы в стиле бренда без множества ручных правок.',
  'pricing.upgrade.userPrompting.controlYourTranslation': 'Управляйте переводом',
  'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5':
    'Пользователи Enterprise подтверждают правки перевода до 5× быстрее',
  'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology': 'Управляйте выбором слов и терминологией',
  'pricing.upgrade.userPrompting.howToUsePromptingEffectively': 'как эффективно пользоваться инструкциями',
  'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice':
    'Сохраняйте голос своего бренда в дублированных видео.',
  'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations':
    'Задавайте тон, стиль и контекст перевода с помощью инструкций. Выберите готовый шаблон или составьте собственную инструкцию под свои задачи.',
  'pricing.upgrade.userPrompting.setToneAndFormalityLevel': 'Задайте тон и уровень формальности',
  'pricing.upgrade.userPrompting.unlockTranslationPrompting': 'Разблокируйте инструкции для перевода',
  'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature': 'Разблокируйте инструкции для перевода',
  'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts':
    'Используйте готовые шаблоны или создавайте собственные инструкции',
  'pricing.upgrade.videoSubtitles.unlockCaptionsFeature': 'Разблокируйте функцию субтитров',
  'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith':
    'Перейдите на Creator Pro, чтобы скачивать видео с субтитрами',
  'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary': 'о библиотеке клонированных голосов',
  'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents':
    'Настраивайте выразительность или убирайте акцент',
  'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining':
    'Авторы, создающие дубляж на нескольких языках, и бренды, сохраняющие один голос во всём контенте.',
  'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro':
    'Выведите дубляж на новый уровень с этой и другими Pro-функциями',
  'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery':
    'Каждый раз добивайтесь именно того звучания клонированного голоса, которое вам нужно.',
  'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects':
    'Используйте клонированные голоса в неограниченном числе проектов',
  'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes':
    'Сохраняйте настроенные клонированные голоса или создавайте новые с нуля',
  'pricing.upgrade.voicePresets.unlockMoreVoiceClones': 'Разблокируйте больше клонированных голосов',
  'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary': 'Разблокируйте библиотеку клонированных голосов',
  'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10':
    'Перейдите на Business, чтобы сохранить до 10 собственных клонированных голосов',
  'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom':
    'Перейдите на Creator Pro, чтобы создать собственный клонированный голос',
  'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice':
    'Перейдите на Enterprise, чтобы сохранять неограниченное число собственных клонированных голосов',
  'pricing.upgrade.voicePresets.whatYouCanDo': 'Что можно сделать',
  'pricing.yearly.buyMinutes': 'Покупайте дополнительные минуты в любое время',
  'pricing.yearly.keepMinutes': 'Минуты не сгорают в конце месяца',
  'pricing.yearly.only': 'ТОЛЬКО ГОДОВЫЕ ПЛАНЫ',
  'pricing.yearly.unlimitedEditing': 'Неограниченное повторное редактирование и повторный дубляж',
};

export const PRICING_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
